<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-expand-x-transition>
        <v-card>
          <v-list>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="12"
                    class="d-flex justify-center"
                >
                  <!-- <v-radio-group row v-model="YearSel" @change="ChooseYearFiscal"> -->
                  <v-radio-group row v-model="YearSel" @change="selProjFiscalYear">
                    <v-radio v-for="(yearMenu, idx) in FiscalYearMenuData" :key="idx"
                              :label="'แผนประจำปี ' + yearMenu.yearth" :value="yearMenu.year">
                      <template v-slot:label>
                        <div>
                      <span>
                        แผนประจำปี {{ yearMenu.yearth }}
                      </span>
                          <v-chip :color="appColor" class="font-weight-bold" dark v-if="YearSel == yearMenu.year">
                            {{
                              Project_plan.filter(projI => projI.Project_type == TypeProject && projI.FiscalYear == yearMenu.year).length
                            }}
                          </v-chip>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-row
                  justify="center">
                <v-col
                    cols="12"
                    md="8">
                  <v-autocomplete
                      :items="Project_plan.filter(item => item.Project_type == TypeProject && item.Approve == '1')"
                      item-text="full_Text"
                      item-value="Project_code"
                      v-model="ProjectPlan"
                      label="ข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี"
                      clearable
                      @change="GetPlanToForm"
                      outlined
                      :error-messages="ProjectPlan == null ? 'ข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี (กรุณาเลือกแผนที่ต้องการแก้ไขข้อมูล)' : ''"
                      persistent-hint
                      :error="ProjectPlan == null"
                      :loading="isLoading"
                      :disabled="isLoading"
                  >
                    <template v-slot:selection="{item}">
                          <span>
                            {{ (item.full_Text.replaceAll("[^a-zA-Z]+", "")) }}
                          <v-chip
                              v-if="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0"
                              :color="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].color : ''"
                              style="transform: scale(0.8);color: white"
                          >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].status : ''
                              }}</span>
                          </v-chip>
                          <v-chip
                              v-if="item.IsDataComplete == '0'"
                              color="#E53935"
                              style="transform: scale(0.8);color: white"
                          >
                            <span style="color: white">ข้อมูลไม่สมบูรณ์</span>
                          </v-chip>
                                 </span>
                    </template>
                    <template v-slot:item="{item}">
                          <span>
                            {{ (item.full_Text.replaceAll("[^a-zA-Z]+", "")) }}
                          <v-chip
                              v-if="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0"
                              :color="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].color : ''"
                              style="transform: scale(0.8);color: white"
                          >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].status : ''
                              }}</span>
                          </v-chip>
                          <v-chip
                              v-if="item.IsDataComplete == '0'"
                              color="#E53935"
                              style="transform: scale(0.8);color: white"
                          >
                            <span style="color: white">ข้อมูลไม่สมบูรณ์</span>
                          </v-chip>
                                 </span>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item-title class="d-flex justify-center">
              <span
                  style="font-weight: bold;font-size: 24px;color: #42b983">แก้ไขข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี</span>
            </v-list-item-title>
            <template v-if="ProjectPlan != null">
              <v-tabs
                  v-model="tab"
                  fixed-tabs
                  dark
                  class="pa-6"
              >
                <v-tab key="tab1">
                  <span style="font-weight: bold;font-size: 20px;padding: 10px">แก้ไขข้อมูลแผน</span>
                </v-tab>
                <v-tab key="tab2">
                  <span style="font-weight: bold;font-size: 20px;padding: 10px">ประวัติขอนุมัติแก้ไขข้อมูลแผน</span>
                </v-tab>
                <v-tab key="tab3">
                  <span style="font-weight: bold;font-size: 20px;padding: 10px">ประวัติการแก้ไขแผน</span>
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item
                    key="tab1"
                >
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-title class="headline mb-1"><span>ข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี</span>
                      </v-list-item-title>
                      <!--              <v-list-item>
                                      <v-row justify="space-around">
                                        <span>วันที่เริ่มต้นโครงการ</span>
                                        <span>วันที่สิ้นสุดโครงการ</span>
                                      </v-row>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-row class="d-flex justify-center">
                                        <v-col
                                            class="d-flex justify-center"
                                            cols="12"
                                            md="6"
                                        >
                                          <v-date-picker
                                              v-model="DateStart"
                                              :landscape="landscape"
                                              :reactive="reactive"
                                              :full-width="fullWidth"
                                              :show-current="showCurrent"
                                              :type="month ? 'month' : 'date'"
                                              :multiple="multiple"
                                              :readonly="readonly"
                                              :disabled="disabled"
                                              locale="th"
                                              :events="enableEvents ? functionEvents : null"
                                              :color="DateStart == '' ? 'red' : 'primary'"
                                              style="border: 1px solid black;border-radius: 5px"
                                          ></v-date-picker>
                                        </v-col>
                                        <v-col
                                            class="d-flex justify-center"
                                            cols="12"
                                            md="6">
                                          <v-date-picker
                                              v-model="DateEnd"
                                              :landscape="landscape"
                                              :reactive="reactive"
                                              :full-width="fullWidth"
                                              :show-current="showCurrent"
                                              :type="month ? 'month' : 'date'"
                                              :multiple="multiple"
                                              :readonly="readonly"
                                              :disabled="disabled"
                                              locale="th"
                                              :events="enableEvents ? functionEvents : null"
                                              :color="DateEnd == '' ? 'red' : 'primary'"
                                              style="border: 1px solid black;border-radius: 5px"
                                          ></v-date-picker>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>-->
                      <v-row>
                        <v-col
                            cols="12"
                            md="6">
                          <v-card>
                            <v-card-subtitle>
                              <span style="font-size: 20px;color: black;font-weight: bold">ข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี</span>
                              <v-spacer></v-spacer>
                              <!--                        <span style="font-size: 20px;color: green;font-weight: bold" v-if="DateForPlan.length > 0">ช่วงระยะเวลาเสนอแผน ประจำปี {{ parseInt(DateForPlan[0].year) + 543 }} : {{ DateForPlan[0].date_start | dateToThai }} - {{ DateForPlan[0].date_end | dateToThai }}</span>-->
                            </v-card-subtitle>
                            <v-card-text>
                              <v-list-item style="margin-top: 20px">
                                <v-row class="d-flex justify-center">
                                  <v-col
                                      cols="12"
                                      md="8"
                                  >
                                    <v-autocomplete
                                        v-model="DepSelect"
                                        label="หน่วยงาน"
                                        :items="depart"
                                        item-text="dep_name"
                                        item-value="dep_id"
                                        hint="หน่วยงาน (ห้ามว่าง)"
                                        :error-messages="DepSelect == '' ? 'หน่วยงาน (ห้ามว่าง)' : ''"
                                        persistent-hint
                                        :error="DepSelect == ''"
                                    >

                                    </v-autocomplete>
                                  </v-col>
                                  <v-col
                                      cols="12"
                                      md="4"
                                  >
                                    <v-autocomplete
                                        v-model="FiscalYear"
                                        label="แผนประจำปี"
                                        :items="FiscalYearData"
                                        item-text="yearth"
                                        item-value="year"
                                        :error-messages="FiscalYear == '' ? 'แผนประจำปี (ห้ามว่าง)' : ''"
                                        persistent-hint
                                        :error="FiscalYear == ''"
                                        disabled
                                    ></v-autocomplete>
                                  </v-col>
                                  <!--                  <v-col
                                                        cols="12"
                                                        md="4"
                                                    >
                                  &lt;!&ndash;                    <v-autocomplete
                                                          v-model="FiscalYear"
                                                          label="แผนประจำปี"
                                                          :items="FiscalYearData"
                                                          item-text="yearth"
                                                          item-value="year"
                                                          :error-messages="FiscalYear == '' ? 'แผนประจำปี (ห้ามว่าง)' : ''"
                                                          persistent-hint
                                                          :error="FiscalYear == ''"
                                                      ></v-autocomplete>&ndash;&gt;
                                                      <v-text-field
                                                          v-model="FiscalYear"
                                                          label="แผนประจำปี"
                                                          readonly
                                                      ></v-text-field>
                                                    </v-col>-->
                                </v-row>
                              </v-list-item>
                              <v-list-item class="justify-center" v-if="FiscalYear != '' && TypeProject == '2'">
                                <span style="font-weight: bold">ประเภทการทำรายการ</span>
                              </v-list-item>
                              <v-list-item class="justify-center" v-if="FiscalYear != '' && TypeProject == '2'">
                                <v-radio-group row
                                               v-model="IsProcess"
                                               :error="IsProcess == null"
                                               :error-messages="IsProcess == null ? 'ประเภทการทำรายการ' : ''"
                                               persistent-hint
                                               :rules="[rules.required]"
                                               required
                                >
                                  <v-radio value="2" class="font-weight-bold" label="เดินทางไปราชการ (ในวิชาชีพ)"
                                           color="green"></v-radio>
                                  <v-radio value="1" class="font-weight-bold" label="เดินทางไปราชการ (นอกวิชาชีพ)"
                                           color="yellow"></v-radio>
                                  <v-radio value="3" class="font-weight-bold" label="เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)"
                                           color="red"></v-radio>
                                </v-radio-group>
                              </v-list-item>
                              <v-list-item class="justify-center">
                                <span style="font-weight: bold">หมวดโครงการ</span>
                              </v-list-item>
                              <v-list-item class="justify-center" v-if="FiscalYear != ''">
                                <v-radio-group row
                                               v-model="Project_category"
                                               :error="(Project_category == '' || Project_category == null)"
                                               :error-messages="(Project_category == '' || Project_category == null) ? 'หมวดหมู่ งาน / กิจกรรม (ห้ามว่าง)' : ''"
                                               persistent-hint
                                               :rules="[rules.required]"
                                               required
                                               @change="ChooseCompetency"
                                               :disabled="IsPlanStatus == '2' || IsPlanStatus == '5'"
                                >
                                  <v-radio value="1" class="font-weight-bold" label="พัฒนาบุคลากร"></v-radio>
                                  <v-radio value="2" class="font-weight-bold" label="โครงการอื่นๆ"></v-radio>
                                  <v-radio value="3" class="font-weight-bold" label="บริการวิชาการ"></v-radio>
                                  <v-radio value="4" class="font-weight-bold" label="วิจัย"></v-radio>
                                </v-radio-group>
                              </v-list-item>
                              <v-list-item class="justify-center">
                                <span style="font-weight: bold">ประเภทแผน</span>
                              </v-list-item>
                              <v-list-item class="justify-center" v-if="FiscalYear != ''">
                                <v-radio-group row
                                               v-model="IsPlan"
                                               :error="IsPlan == null"
                                               :error-messages="IsPlan == null ? 'ประเภทแผน (ห้ามว่าง)' : ''"
                                               persistent-hint
                                               :rules="[rules.required]"
                                               required
                                               @change="getCourseType"
                                >
                                  <v-radio value="1" class="font-weight-bold" label="งานในแผน"
                                           :disabled="IsPlanCordi"></v-radio>
                                  <v-radio value="0" class="font-weight-bold" label="งานนอกแผน"></v-radio>
                                </v-radio-group>
                              </v-list-item>
                              <v-list-item class="justify-center" v-if="FiscalYear != ''">
                                <span style="font-weight: bold">ระยะเวลาที่คาดว่าจะจัด</span>
                              </v-list-item>
                              <v-list-item class="justify-center" v-if="FiscalYear != ''">
                                <v-radio-group row
                                               v-model="episode"
                                               :error="episode == null"
                                               :error-messages="episode == null ? 'ระยะเวลาที่คาดว่าจะจัด (ห้ามว่าง)' : ''"
                                               persistent-hint
                                               :rules="[rules.required]"
                                               required
                                               @change="changeDate"
                                >
                                  <v-radio class="font-weight-bold" value="1"
                                           :label="'ต.ค. ' + (parseInt(FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(FiscalYear) + 543 - 1)"></v-radio>
                                  <v-radio class="font-weight-bold" value="2"
                                           :label="'ม.ค. ' + (parseInt(FiscalYear) + 543)  + '- มี.ค. ' + (parseInt(FiscalYear) + 543) "></v-radio>
                                  <v-radio class="font-weight-bold" value="3"
                                           :label="'เม.ย. ' + (parseInt(FiscalYear) + 543)  + '- มิ.ย. ' + (parseInt(FiscalYear) + 543) "></v-radio>
                                  <v-radio class="font-weight-bold" value="4"
                                           :label="'ก.ค. ' + (parseInt(FiscalYear) + 543)  + '- ก.ย. ' + (parseInt(FiscalYear) + 543) "></v-radio>
                                  <v-radio class="font-weight-bold" value="9"
                                           :label="'ตลอดปีงบประมาณ ' + (parseInt(FiscalYear) + 543)"></v-radio>
                                </v-radio-group>
                              </v-list-item>
                              <p style="color: blue;font-weight: bold" v-if="episode == '9'">
                                ***** สามารถระบุรายละเอียดระยะเวลาที่จัดเพิ่มเติมได้ที่ช่อง รายละเอียดประกอบ (เพิ่มเติม)
                                ได้ที่ช่องด้านล่างเพื่อเป็นข้อมูลประกอบการพิจารณา *****
                              </p>
                              <v-list-item>
                                <v-row>
                                  <v-col
                                      cols="12"
                                  >
                                    <div class="d-inline">
                                      <v-text-field v-model="Project_code" label="รหัสแผน"
                                                    hide-details="auto" disabled></v-text-field>
                                    </div>
                                  </v-col>
                                  <v-col
                                      cols="12"
                                  >
                                    <div class="d-inline">
                                      <v-text-field v-model="Project_name" label="ชื่องาน / กิจกรรม"
                                                    :rules="[rules.required]"
                                                    required
                                                    hide-details="auto"
                                                    :error-messages="Project_name == '' ? 'ชื่องาน / กิจกรรม (ห้ามว่าง)' : ''"
                                                    :error="Project_name == ''"
                                                    persistent-hint></v-text-field>
                                    </div>
                                  </v-col>
                                  <v-col
                                      cols="12"
                                  >
                                    <div class="d-inline">
                                      <v-select
                                          :error="Project_group == ''"
                                          v-model="Project_group"
                                          :items="TypeProject == '1' ? projectGroup.filter(item => item.Type == '1') : projectGroup.filter(item => item.Type == '2')"
                                          item-value="Project_group"
                                          item-text="Project_group_des"
                                          label="ประเภทแผน"
                                          :error-messages="Project_group == '' ? 'ประเภทแผน (ห้ามว่าง)' : ''"
                                          persistent-hint
                                          :rules="[rules.required]"
                                          required
                                          @change="SelProjectGroup"
                                      ></v-select>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item>
                                <v-row class="d-flex justify-center">
                                  <v-col
                                      cols="12"
                                  >
                                    <div class="d-inline">
                                      <!--                      <v-autocomplete
                                                                :items="courseData"
                                                                item-text="Course_name"
                                                                item-value="Course_code"
                                                                v-model="Course_code"
                                                                label="หลักสูตร"
                                                                @change="getCourseType"
                                                                :error-messages="((Project_group == '101' || Project_group == '102' || Project_group == '103' || Project_group == '104') && Course_code == null) ? 'หลักสูตร (ห้ามว่าง)' : ''"
                                                                :error="((Project_group == '101' || Project_group == '102' || Project_group == '103' || Project_group == '104') && Course_code == null)"
                                                                persistent-hint
                                                                clearable
                                                            ></v-autocomplete>-->
                                      <v-autocomplete
                                          :items="courseData"
                                          item-text="Course_name"
                                          item-value="Course_code"
                                          v-model="Course_code"
                                          label="หลักสูตร"
                                          @change="getCourseType"
                                          persistent-hint
                                          clearable
                                      ></v-autocomplete>
                                    </div>
                                  </v-col>
                                  <template>
                                    <v-col
                                        cols="12"
                                        md="6"
                                    >
                                      <div class="d-inline">
                                        <v-text-field
                                            v-model="course_group"
                                            label="สาขาประเภทหลักสูตร"
                                            required
                                            disabled
                                        ></v-text-field>
                                      </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6"
                                    >
                                      <div class="d-inline">
                                        <v-autocomplete
                                            readonly
                                            :items="period"
                                            item-text="name"
                                            item-value="id"
                                            v-model="Period_code"
                                            label="ระยะเวลา"
                                            required
                                        ></v-autocomplete>
                                      </div>
                                    </v-col>
                                  </template>
                                </v-row>
                              </v-list-item>
                              <v-list-item>
                                <v-row>
                                  <v-col
                                      cols="12"
                                      md="6"
                                  >
                                    <div class="d-inline">
                                      <v-text-field type="number"
                                                    :error="CalHourse == ''"
                                                    v-model="CalHourse"
                                                    label="จำนวน ช.ม"
                                                    hide-details="auto"
                                                    :rules="[rules.required]"
                                                    required
                                                    :error-messages="CalHourse == '' ? 'จำนวน ช.ม (ห้ามว่าง)' : ''"
                                                    persistent-hint></v-text-field>
                                    </div>
                                  </v-col>
                                  <v-col
                                      cols="12"
                                      md="6"
                                  >
                                    <div class="d-inline">
                                      <v-text-field type="number"
                                                    :error="CalCredit == ''"
                                                    v-model="CalCredit"
                                                    label="จำนวน เครดิต"
                                                    hide-details="auto"
                                                    :error-messages="CalCredit == '' ? 'จำนวน เครดิต (ห้ามว่าง) **ไม่มีใส่0' : ''"
                                                    persistent-hint></v-text-field>
                                    </div>
                                  </v-col>
                                  <v-col
                                      cols="12"
                                      md="6"
                                  >
                                    <div class="d-inline">
                                      <v-select
                                          :items="PLACESelete"
                                          item-value="id"
                                          item-text="detail"
                                          :error="PLACE == ''"
                                          v-model="PLACE"
                                          label="งาน / กิจกรรม ถูกจัดขึ้น"
                                          :error-messages="PLACE == '' ? 'งาน / กิจกรรม ถูกจัดขึ้น (ห้ามว่าง)' : ''"
                                          persistent-hint
                                          required
                                          :rules="[rules.required]"
                                          @change="CheckPlace"
                                      >
                                      </v-select>
                                    </div>
                                  </v-col>
                                  <v-col
                                      cols="12"
                                      md="6"
                                  >
                                    <div class="d-inline" v-if="PLACE == '2'">
                                      <v-autocomplete
                                          :error="Province_id == ''"
                                          v-model="Province_id"
                                          :items="provinces_Data"
                                          item-text="name_th"
                                          item-value="code"
                                          label="จังหวัด"
                                          :error-messages="Province_id == '' ? 'จังหวัด (ห้ามว่าง)' : ''"
                                          persistent-hint
                                          required
                                          :rules="[rules.required]"></v-autocomplete>
                                    </div>
                                    <div class="d-inline" v-if="PLACE == '3'">
                                      <v-autocomplete
                                          :error="Country_id == ''"
                                          v-model="Country_id"
                                          :items="countryData"
                                          item-text="ct_nameTHA"
                                          item-value="ct_code"
                                          label="ประเทศ"
                                          :error-messages="Country_id == '' ? 'ประเทศ (ห้ามว่าง)' : ''"
                                          persistent-hint
                                          required
                                          :rules="[rules.required]"></v-autocomplete>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item>
                                <v-row>
                                  <v-col
                                      cols="12"
                                      md="6"
                                  >
                                    <div class="d-inline">
                                      <v-text-field type="number"
                                                    :error="BudgetRequest == ''"
                                                    v-model="BudgetRequest"
                                                    label="งบประมาณที่ขอ"
                                                    hide-details="auto"
                                                    :rules="[rules.required]"
                                                    required
                                                    :error-messages="BudgetRequest == '' ? 'งบประมาณที่ขอ (ห้ามว่าง) **ไม่มีใส่0' : ''"
                                                    persistent-hint></v-text-field>
                                    </div>
                                  </v-col>
                                  <v-col
                                      cols="12"
                                      md="6"
                                  >
                                    <div class="d-inline">
                                      <v-select
                                          :error="WorkBy == ''"
                                          v-model="WorkBy"
                                          label="จัดโดย"
                                          :items="WorkByData"
                                          item-value="id"
                                          item-text="detail"
                                          :error-messages="WorkBy == '' ? 'จัดโดย (ห้ามว่าง)' : ''"
                                          persistent-hint
                                          required
                                          :rules="[rules.required]"></v-select>
                                    </div>
                                  </v-col>
                                  <v-col
                                      cols="12"
                                      md="6"
                                  >
                                    <div class="d-inline">
                                      <v-text-field
                                          :error="WorkByName == ''"
                                          v-model="WorkByName"
                                          label="ชื่อผู้จัด"
                                          hide-details="auto"
                                          :error-messages="WorkByName == '' ? 'ชื่อผู้จัด (ห้ามว่าง)' : ''"
                                          persistent-hint
                                          required
                                          :rules="[rules.required]"></v-text-field>
                                    </div>
                                  </v-col>
                                  <v-col
                                      cols="12"
                                      md="6"
                                  >
                                    <div class="d-inline">
                                      <v-text-field
                                          :error="WorkByPhone == ''"
                                          v-model="WorkByPhone"
                                          label="เบอร์โทรติดต่อผู้กรอกข้อมูล"
                                          hide-details="auto"
                                          :error-messages="WorkByPhone == '' ? 'เบอร์โทรติดต่อผู้กรอกข้อมูล (ห้ามว่าง)' : ''"
                                          persistent-hint
                                          required
                                          :rules="[rules.required]"></v-text-field>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item>
                                <v-row>
                                  <v-col
                                      cols="12"
                                      md="6"
                                  >
                                    <div class="d-inline">
                                      <v-text-field
                                          v-model="Location"
                                          label="สถานที่จัด"
                                          hide-details="auto"
                                          persistent-hint
                                      ></v-text-field>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item>
                                <v-row>
                                  <v-col
                                      cols="12"
                                  >
                                    <div class="d-inline">
                                      <v-textarea
                                          v-model="TargetGroup"
                                          outlined
                                          name=""
                                          label="กลุ่มเป้าหมาย"
                                          value=""
                                          persistent-hint
                                          :error="TargetGroup == '' || TargetGroup == null"
                                          :error-messages="(TargetGroup == '' || TargetGroup == null) ? 'กลุ่มเป้าหมาย (ห้ามว่าง)' : ''"
                                          required
                                      ></v-textarea>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item>
                                <v-row>
                                  <v-col
                                      cols="12"
                                  >
                                    <div class="d-inline">
                                      <v-textarea
                                          v-model="Objective"
                                          outlined
                                          name=""
                                          label="วัตถุประสงค์"
                                          value=""
                                          persistent-hint
                                          :error="Objective == '' || Objective == null"
                                          :error-messages="(Objective == '' || Objective == null) ? 'วัตถุประสงค์ (ห้ามว่าง)' : ''"
                                          required
                                      ></v-textarea>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item>
                                <v-row>
                                  <v-col
                                      cols="12"
                                  >
                                    <div class="d-inline">
                                      <v-textarea
                                          v-model="Remarks"
                                          outlined
                                          name=""
                                          label="รายละเอียดประกอบ (เพิ่มเติม ถ้ามี)"
                                          value=""
                                          persistent-hint
                                      ></v-textarea>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item>
                                <v-file-input
                                    v-model="files"
                                    color="deep-purple accent-4"
                                    counter
                                    label="แนบไฟล์เอกสารประกอบ (เพิ่มเติม ถ้ามี)"
                                    multiple
                                    placeholder="เลือกไฟล์"
                                    prepend-icon="mdi-paperclip"
                                    outlined
                                    :show-size="1000"
                                    @change="FileSelect"
                                >
                                  <template v-slot:selection="{ index, text }">
                                    <v-chip
                                        v-if="index < 5"
                                        color="deep-purple accent-4"
                                        dark
                                        label
                                        small
                                    >
                                      {{ text }}
                                    </v-chip>

                                    <span
                                        v-else-if="index === 5"
                                        class="overline grey--text text--darken-3 mx-2"
                                    >
                                  +{{ files.length - 2 }} File(s)
                                </span>
                                  </template>
                                </v-file-input>
                              </v-list-item>
                              <v-list-item>
                                <p style="font-weight: bold;color: #ff6d81;text-align: right;width: 100%">**สนับสนุนไฟล์
                                  PDF เท่านั้น</p>
                              </v-list-item>
                              <v-list-item>
                                <v-alert
                                    v-if="alert"
                                    prominent
                                    type="error"
                                >
                                  <v-row align="center" v-for="item in txtAlert" :key="item.id">
                                    <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                                  </v-row>
                                </v-alert>
                              </v-list-item>
                              <v-list-item v-if="FileProject.length > 0">
                                <template>
                                  <v-row>
                                    <v-col cols="12">
                                      <v-card>
                                        <v-card-title>
                                          ไฟล์เอกสารประกอบ
                                        </v-card-title>
                                        <v-container fluid>
                                          <v-row>
                                            <v-col
                                                v-for="(file_i, index) in FileProject"
                                                :key="index"
                                                class="d-flex child-flex"
                                                cols="12"
                                                md="4"
                                            >
                                              <v-card flat tile>
                                                <v-img
                                                    v-if="file_i.type == 'image'"
                                                    :src="file_i.src"
                                                    :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                    aspect-ratio="1"
                                                    class="grey lighten-2"
                                                >
                                                  <template
                                                      v-slot:placeholder>
                                                    <v-row
                                                        class="fill-height ma-0"
                                                        align="center"
                                                        justify="center"
                                                    >
                                                      <v-progress-circular
                                                          indeterminate
                                                          color="grey lighten-5"></v-progress-circular>
                                                    </v-row>
                                                  </template>
                                                </v-img>
                                                <v-img
                                                    v-if="file_i.type == 'pdf'"
                                                    src="../../assets/Image/pdf.png"
                                                    :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                    aspect-ratio="1"
                                                    class="grey lighten-2"
                                                >
                                                  <template
                                                      v-slot:placeholder>
                                                    <v-row
                                                        class="fill-height ma-0"
                                                        align="center"
                                                        justify="center"
                                                    >
                                                      <v-progress-circular
                                                          indeterminate
                                                          color="grey lighten-5"></v-progress-circular>
                                                    </v-row>
                                                  </template>
                                                </v-img>
                                                <v-card-text>
                                                                                                  <span
                                                                                                      style="font-weight: bold;color: black">
                                                                                                      {{ file_i.name }}
                                                                                                  </span>
                                                </v-card-text>
                                                <v-card-actions>
                                                  <v-btn text
                                                         @click="ShowData(file_i.src)">
                                                                                                      <span
                                                                                                          style="color: indigo;font-weight: bold">
                                                                                                          เรียกดู
                                                                                                      </span>
                                                  </v-btn>
                                                  <v-btn text
                                                         @click="DeleteFile(file_i)">
                                                                                                       <span
                                                                                                           style="color: red;font-weight: bold">
                                                                                                          ลบ
                                                                                                      </span>
                                                  </v-btn>
                                                </v-card-actions>
                                              </v-card>
                                            </v-col>
                                          </v-row>
                                        </v-container>
                                      </v-card>
                                    </v-col>
                                  </v-row>
                                </template>
                              </v-list-item>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col
                            cols="12"
                            md="6">
                          <v-card>
                            <v-card-subtitle>
                              <span style="font-size: 20px;color: black;font-weight: bold">Strategic Objective( วัตถุประสงค์เชิงกลยุทธ์ )</span>
                            </v-card-subtitle>
                            <v-card-text>
                              <v-list>
                                <v-list-item three-line>
                                  <v-list-item-content>
                                    <v-list-item-title class="headline mb-1">
                                      <span>สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์</span>
                                    </v-list-item-title>
                                    <v-list-item>
                                      <v-row class="d-flex justify-center">
                                        <v-col
                                            cols="12"
                                            md="12"
                                        >
                                          <v-row class="d-flex justify-center">
                                            <v-col
                                                cols="12"
                                                md="12">
                                              <v-responsive>
                                                <v-spacer></v-spacer>
                                                <v-text-field label="ค้นหา สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์"
                                                              v-model="searchCompe"></v-text-field>
                                              </v-responsive>
                                              <v-responsive>
                                                <v-treeview v-model="selection" selectable
                                                            :activatable="true"
                                                            :items="CompetencyData"
                                                            :search="searchCompe"
                                                            @input="ChooseCompetency"
                                                >
                                                  <template v-slot:prepend="{ item, open }">
                                                    <v-icon v-if="!item.file"
                                                            color="blue lighten-2">
                                                      {{
                                                        open ? 'mdi-folder-open' :
                                                            'mdi-folder'
                                                      }}
                                                    </v-icon>
                                                    <v-icon v-else>
                                                      {{ files[item.file] }}
                                                    </v-icon>
                                                  </template>
                                                  <template v-slot:label="{ item, active }">
                                                    <div v-if="isMobile" style="cursor: pointer"
                                                         @click="ShowDetail(item)">
               <span
                   :style="item.checkCordi ? {color:'red', fontWeight: 'bold', fontSize: '12px'} : {color:'black', fontSize: '12px'}"
                   v-if="!active">
                                                    {{ item.name }}
                                                </span>
                                                    </div>
                                                    <div v-else style="cursor: pointer"
                                                         @click="ShowDetail(item)">
                                                <span
                                                    :style="item.checkCordi ? {color:'red', fontWeight: 'bold'} : {color:'black'}"
                                                    v-if="!active">
                                                    {{ item.name }}
                                                </span>
                                                      <!--                                                <span style="color: #364eff;font-weight: bold"-->
                                                      <!--                                                      v-else>-->
                                                      <!--                                                    {{ item.name }}-->
                                                      <!--                                                </span>-->
                                                    </div>
                                                  </template>
                                                </v-treeview>
                                              </v-responsive>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-card-text>
                          </v-card>
                          <v-card class="mt-4">
                            <v-card-subtitle v-if="Project != null">
                              <span style="font-size: 20px;color: black;font-weight: bold">
                                สถานะแผน
                                                            <v-chip
                                                                v-if="StatusProject.filter(staItem => staItem.id == Project.IsPlanStatus).length > 0"
                                                                :color="StatusProject.filter(staItem => staItem.id == Project.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == Project.IsPlanStatus)[0].color : ''"
                                                                style="transform: scale(0.8);color: white"
                                                            >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == Project.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == Project.IsPlanStatus)[0].status : ''
                              }}</span>
                          </v-chip>
                                      <v-chip
                                          v-if="Project.IsDataComplete == '0'"
                                          color="#E53935"
                                          style="transform: scale(0.8);color: white"
                                      >
                            <span style="color: white">ข้อมูลไม่สมบูรณ์</span>
                          </v-chip>
                              </span>
                              <hr class="mb-2 mt-2"/>
                              <span style="font-size: 20px;color: black;font-weight: bold;margin-top: 30px"
                                    v-if="parseInt(Project.IsPlanStatus) >= 6 && parseInt(Project.IsPlanStatus) <= 9">
                                อนุมัติวงเงิน : {{ Project.BudgetArrove | currency }} บาท
                              </span>
                              <hr class="mb-2 mt-2"/>
                              <span style="font-size: 20px;color: black;font-weight: bold;margin-top: 30px"
                                    v-if="parseInt(Project.IsPlanStatus) >= 6 && parseInt(Project.IsPlanStatus) <= 9">
                                จำนวนเงินเบิกจ่าย : {{ Project.MoneyDisburse | currency }} บาท
                              </span>
                            </v-card-subtitle>
                          </v-card>
                          <v-card class="mt-4">
                            <v-card-subtitle v-if="Project != null">
                              <span style="font-size: 20px;color: black;font-weight: bold">
                                ประวัติการพิจารณาแผน
                              </span>
                              <v-divider></v-divider>
                              <v-list class="mt-6">
                                <template v-if="RecordDataDump.length > 0">
                                  <v-list-item class="justify-center">
                                    <v-row justify="center">
                                      <v-col
                                          cols="12"
                                          md="12">
                                        <v-list-item>
                                          <v-expansion-panels popout>
                                            <v-expansion-panel
                                                v-for="(item,i) in RecordData"
                                                :key="i"
                                            >
                                              <v-expansion-panel-header>
                                                <span
                                                    style="color: #364eff;margin-left: 15px">{{
                                                    item.Date_Approve | DateToThai
                                                  }}</span>
                                                <v-chip
                                                    v-if="StatusProject.filter(staItem => staItem.id == item.Status).length > 0"
                                                    :color="StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].color : ''"
                                                    style="transform: scale(0.8);color: white"
                                                    class="d-flex justify-center"
                                                >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].status : ''
                              }}</span>
                                                </v-chip>
                                              </v-expansion-panel-header>
                                              <v-expansion-panel-content>
                                                <p>
                                                  เหตุผล : {{ item.Remark }}
                                                </p>
                                                <div v-for="(file,idx) in item.files"
                                                     v-bind:key="idx"
                                                     style="color: #ff6d81">
                                                  ไฟล์ประกอบ :
                                                  <v-btn text
                                                         @click="ShowData(Openfile + file.File_path)">
                                                    {{ file.File_name }}
                                                  </v-btn>
                                                </div>
                                              </v-expansion-panel-content>
                                            </v-expansion-panel>
                                          </v-expansion-panels>
                                        </v-list-item>
                                      </v-col>
                                    </v-row>
                                  </v-list-item>
                                </template>
                                <template v-else>
                                  <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                                    ไม่พบข้อมูลประวัติผลการพิจารณาแผน !!</p>
                                </template>
                              </v-list>
                            </v-card-subtitle>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="d-flex justify-center">
                    <v-row class="d-flex justify-center">
                      <v-col
                          class="d-flex justify-center"
                          cols="12"
                          md="3">
                        <v-btn
                            color="#8E24AA"
                            class="darken-3 pa-8"
                            @click="UpdateProject('0')"
                            :disabled="btnDisable"
                            dark
                        >
                          <span style="font-weight: bold;font-size: 20px">แก้ไขข้อมูลแผน</span>
                        </v-btn>
                      </v-col>
                      <v-col
                          class="d-flex justify-center"
                          cols="12"
                          md="3">
                        <v-btn
                            color="#8E24AA"
                            class="darken-3 pa-8"
                            @click="UpdateProject('1')"
                            v-if="Project != null && (Project.IsPlanStatus == '0' || Project.IsPlanStatus == '4')"
                            :disabled="btnDisable"
                            dark
                        >
                          <span style="font-weight: bold;font-size: 20px">แก้ไขและเสนอแผน</span>
                        </v-btn>
                      </v-col>
                      <v-col
                          class="d-flex justify-center"
                          cols="12"
                          md="3">
                        <v-btn
                            color="red"
                            class="darken-3 pa-8"
                            @click="remarksProject(Project)"
                            :disabled="btnDisable"
                            dark
                        >
                          <span style="font-weight: bold;font-size: 20px">ยกเลิกแผน</span>
                        </v-btn>
                      </v-col>
                      <v-col
                          class="d-flex justify-center"
                          cols="12"
                          md="3"
                          v-if="Project != null && Project.IsPlanStatus == '7'"
                      >
                        <v-btn
                            color="green"
                            class="darken-3 pa-8"
                            @click="SuccessProject()"
                            :disabled="btnDisable"
                            dark
                        >
                          <span style="font-weight: bold;font-size: 20px">ปิดโครงการ</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-tab-item>
                <v-tab-item
                    key="tab2"
                >
                  <template v-if="TempProject.length > 0">
                    <v-timeline
                        dense
                    >
                      <v-timeline-item
                          v-for="(TempProject, i) in TempProject"
                          :key="i"
                          color="cyan"
                          small
                      >
                        <template v-slot:opposite>
        <span
            class="headline font-weight-bold cyan--text"
        >{{ TempProject.Create_Time | dateToThai2 }}</span>
                        </template>
                        <div class="py-4">
                          <h2 :class="`headline font-weight-light mb-4 cyan--text`">
                            {{ TempProject.Create_Time | dateToThai2 }}
                          </h2>
                          <v-chip
                              color="#6D4C41"
                              style="transform: scale(0.8);color: white"
                              v-if="TempProject.Req_status == '0'"
                          >
                            <span style="color: white;font-size: 24px;font-weight: bold;padding: 20px">รอพิจารณา</span>
                          </v-chip>
                          <v-chip
                              color="#00BFA5"
                              style="transform: scale(0.8);color: white"
                              v-else-if="TempProject.Req_status == '1'"
                          >
                            <span style="font-size: 24px;font-weight: bold;padding: 20px">อนุมติ</span>
                          </v-chip>
                          <v-chip
                              color="#F50057"
                              style="transform: scale(0.8);color: white"
                              v-else-if="TempProject.Req_status == '2'"
                          >
                            <span style="font-size: 24px;font-weight: bold;padding: 20px">ไม่อนุมัติ</span>
                          </v-chip>
                          <v-chip
                              color="#3E2723"
                              style="transform: scale(0.8);color: white"
                              v-else
                          >
                            <span style="font-size: 24px;font-weight: bold;padding: 20px">ยกเลิกการแก้ไข</span>
                          </v-chip>
                          <v-row>
                            <v-col
                                cols="12"
                                md="6">
                              <p class="font-weight-bold">หน่วยงาน:
                                {{
                                  depart.filter(item => item.dep_id == TempProject.Dep_Code).length > 0 ? depart.filter(item => item.dep_id == TempProject.Dep_Code)[0].dep_name : '-'
                                }}</p>
                              <p class="font-weight-bold">แผนประจำปี: {{ parseInt(TempProject.FiscalYear) + 543 }}</p>
                              <p class="font-weight-bold" v-if="TempProject.Project_type == '2'">ประเภททำรายการ:
                                {{
                                  TempProject.IsProcess == '2' ? 'เดินทางไปราชการ (ในวิชาชีพ)' : TempProject.IsProcess == '1' ? 'เดินทางไปราชการ (นอกวิชาชีพ)' : 'เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)'
                                }}</p>
                              <p class="font-weight-bold">หมวดหมู่ งาน / กิจกรรม:
                                {{
                                  TempProject.Project_category == '1' ? 'พัฒนาบุคลากร' : TempProject.Project_category == '2' ? 'โครงการอื่นๆ' : TempProject.Project_category == '3' ? 'บริการวิชาการ' : 'วิจัย'
                                }}</p>
                              <p class="font-weight-bold">ประเภทแผน: {{
                                  TempProject.IsPlan == '1' ? 'ในแผน' : 'นอกแผน'
                                }}</p>
                              <p class="font-weight-bold" v-if="episode == '1'">ระยะเวลาที่คาดว่าจะจัด:
                                {{
                                  'ต.ค. ' + (parseInt(FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(FiscalYear) + 543 - 1)
                                }}</p>
                              <p class="font-weight-bold" v-else-if="episode == '2'">ระยะเวลาที่คาดว่าจะจัด:
                                {{
                                  'ม.ค. ' + (parseInt(FiscalYear) + 543) + '- มี.ค. ' + (parseInt(FiscalYear) + 543)
                                }}</p>
                              <p class="font-weight-bold" v-else-if="episode == '3'">ระยะเวลาที่คาดว่าจะจัด:
                                {{
                                  'เม.ย. ' + (parseInt(FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(FiscalYear) + 543)
                                }}</p>
                              <p class="font-weight-bold" v-else-if="episode == '4'">ระยะเวลาที่คาดว่าจะจัด:
                                {{
                                  'ก.ค. ' + (parseInt(FiscalYear) + 543) + '- ก.ย. ' + (parseInt(FiscalYear) + 543)
                                }}</p>
                              <p class="font-weight-bold" v-else-if="episode == '9'">ระยะเวลาที่คาดว่าจะจัด:
                                {{
                                  'ตลอดปีงบประมาณ ' + (parseInt(FiscalYear) + 543)
                                }}</p>
                              <p class="font-weight-bold">รหัสแผน: {{ TempProject.Project_code }}</p>
                              <p class="font-weight-bold">ชื่องาน / กิจกรรม: {{ TempProject.Project_name }}</p>
                              <p class="font-weight-bold">ประเภทแผน: {{
                                  projectGroup.filter(item => item.Project_group == TempProject.Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == TempProject.Project_group)[0].Project_group_des : '-'
                                }}</p>
                              <p class="font-weight-bold">หลักสูตร:
                                {{
                                  courseData.filter(item => item.Course_code == TempProject.Course_code).length > 0 ? courseData.filter(item => item.Course_code == TempProject.Course_code)[0].Course_name : '-'
                                }}</p>
                              <p class="font-weight-bold">สาขาประเภทหลักสูตร:
                                {{
                                  courseData.filter(item => item.Course_code == TempProject.Course_code).length > 0 ? courseData.filter(item => item.Course_code == TempProject.Course_code)[0].Course_type_des : '-'
                                }}</p>
                              <p class="font-weight-bold">ระยะเวลา:
                                {{
                                  courseData.filter(item => item.Course_code == TempProject.Course_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == TempProject.Course_code)[0].Period_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == TempProject.Course_code)[0].Period_code)[0].name : '-' : '-'
                                }}</p>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6">
                              <p class="font-weight-bold">จำนวน ช.ม.: {{ TempProject.CalHourse }}</p>
                              <p class="font-weight-bold">จำนวน เครดิต: {{ TempProject.CalCredit }}</p>
                              <p class="font-weight-bold">งบประมาณที่ขอ: {{ TempProject.BudgetRequest }}</p>
                              <p class="font-weight-bold">งาน / กิจกรรม ถูกจัดขึ้น: {{
                                  PLACESelete.filter(item => item.id == TempProject.PLACE).length > 0 ? PLACESelete.filter(item => item.id == TempProject.PLACE)[0].detail : '-'
                                }}</p>
                              <p class="font-weight-bold" v-if="TempProject.PLACE == '2'">จังหวัด: {{
                                  provinces_Data.filter(item => item.code == TempProject.Province_id).length > 0 ? provinces_Data.filter(item => item.code == TempProject.Province_id)[0].name_th : '-'
                                }}</p>
                              <p class="font-weight-bold" v-else-if="TempProject.PLACE == '3'">ประเทศ: {{
                                  countryData.filter(item => item.ct_code == TempProject.Country_id).length > 0 ? countryData.filter(item => item.ct_code == TempProject.Country_id)[0].ct_nameTHA : '-'
                                }}</p>
                              <p class="font-weight-bold">จัดโดย:
                                {{
                                  WorkByData.filter(item => item.id == TempProject.WorkBy).length > 0 ? WorkByData.filter(item => item.id == TempProject.WorkBy)[0].detail : '-'
                                }}</p>
                              <p class="font-weight-bold">ชื่อผู้จัด: {{ TempProject.WorkByName }}</p>
                              <p class="font-weight-bold">เบอร์โทรติดต่อผู้กรอกข้อมูล: {{ TempProject.WorkByPhone }}</p>
                              <p class="font-weight-bold">สถานที่จัด: {{ TempProject.Location }}</p>
                              <p class="font-weight-bold">กลุ่มเป้าหมาย: {{ TempProject.TargetGroup }}</p>
                              <p class="font-weight-bold">วัตถุประสงค์: {{ TempProject.Objective }}</p>
                              <p class="font-weight-bold">รายละเอียดประกอบ (เพิ่มเติม): {{ TempProject.Remarks }}</p>
                              <p class="font-weight-bold">Competency,Core Value,Strategic Objective:
                                <v-btn text color="primary" @click="showTempCompetency(TempProject)">คลิก!!</v-btn>
                              </p>
                              <p class="font-weight-bold">ไฟล์เอกสารประกอบ:
                                <v-btn text color="primary" @click="showTempFile(TempProject)">คลิก!!</v-btn>
                              </p>
                              <p class="font-weight-bold">แก้ไขโดย: {{
                                  staffData.filter(item => item.perid == TempProject.Create_By).length > 0 ? staffData.filter(item => item.perid == TempProject.Create_By)[0].full_Name + '(' + staffData.filter(item => item.perid == TempProject.Create_By)[0].perid + ') ' + staffData.filter(item => item.perid == TempProject.Create_By)[0].dep_name : '-'
                                }}</p>
                            </v-col>
                          </v-row>
                          <v-divider></v-divider>
                        </div>
                      </v-timeline-item>
                    </v-timeline>
                  </template>
                  <template v-else>
                    <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                      ไม่พบข้อมูลประวัติการขอนุมัติแก้ไขข้อมูลแผน</p>
                  </template>
                </v-tab-item>
                <v-tab-item
                    key="tab3"
                >
                  <template v-if="LogProject.length > 0">
                    <v-timeline
                        dense
                    >
                      <v-timeline-item
                          v-for="(logProject, i) in LogProject"
                          :key="i"
                          color="cyan"
                          small
                      >
                        <template v-slot:opposite>
        <span
            class="headline font-weight-bold cyan--text"
        >{{ logProject.Create_Time | dateToThai2 }}</span>
                        </template>
                        <div class="py-4">
                          <h2 :class="`headline font-weight-light mb-4 cyan--text`">
                            {{ logProject.Create_Time | dateToThai2 }}
                          </h2>
                          <v-chip
                              v-if="logProject.IsPlanStatus == '0'"
                              outlined
                              color="#00C853"
                              style="transform: scale(0.8)"
                          >
                            <span style="font-size: 24px;font-weight: bold;padding: 20px">รอเสนอแผน</span>
                          </v-chip>

                          <v-chip
                              color="#6D4C41"
                              style="transform: scale(0.8);color: white"
                              v-else-if="logProject.IsPlanStatus == '1'"
                          >
                            <span style="color: white;font-size: 24px;font-weight: bold;padding: 20px">รอพิจารณา</span>
                          </v-chip>

                          <v-chip
                              color="#00BFA5"
                              style="transform: scale(0.8);color: white"
                              v-else-if="logProject.IsPlanStatus == '2'"
                          >
                            <span style="font-size: 24px;font-weight: bold;padding: 20px">อนุมติ</span>
                          </v-chip>
                          <v-chip
                              color="#F50057"
                              style="transform: scale(0.8);color: white"
                              v-else-if="logProject.IsPlanStatus == '3'"
                          >
                            <span style="font-size: 24px;font-weight: bold;padding: 20px">ไม่อนุมัติ</span>
                          </v-chip>
                          <v-chip
                              color="#C0CA33"
                              style="transform: scale(0.8);color: white"
                              v-else-if="logProject.IsPlanStatus == '4'"
                          >
                            <span style="font-size: 24px;font-weight: bold;padding: 20px">แก้ไข</span>
                          </v-chip>
                          <v-chip
                              color="#FF9800"
                              style="transform: scale(0.8);color: white"
                              v-else-if="logProject.IsPlanStatus == '5'"
                          >
                            <span style="font-size: 24px;font-weight: bold;padding: 20px">แก้ไข (หลังการอนุมัติ)</span>
                          </v-chip>
                          <v-chip
                              color="#3E2723"
                              style="transform: scale(0.8);color: white"
                              v-else
                          >
                            <span style="font-size: 24px;font-weight: bold;padding: 20px">ยกเลิก</span>
                          </v-chip>
                          <v-row>
                            <v-col
                                cols="12"
                                md="6">
                              <p class="font-weight-bold">หน่วยงาน:
                                {{
                                  depart.filter(item => item.dep_id == logProject.Dep_Code).length > 0 ? depart.filter(item => item.dep_id == logProject.Dep_Code)[0].dep_name : '-'
                                }}</p>
                              <p class="font-weight-bold">แผนประจำปี: {{ parseInt(logProject.FiscalYear) + 543 }}</p>
                              <p class="font-weight-bold" v-if="logProject.Project_type == '2'">ประเภททำรายการ:
                                {{
                                  logProject.IsProcess == '2' ? 'เดินทางไปราชการ (ในวิชาชีพ)' : logProject.IsProcess == '1' ? 'เดินทางไปราชการ (นอกวิชาชีพ)' : 'เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)'
                                }}</p>
                              <p class="font-weight-bold">หมวดหมู่ งาน / กิจกรรม:
                                {{
                                  logProject.Project_category == '1' ? 'พัฒนาบุคลากร' : logProject.Project_category == '2' ? 'โครงการอื่นๆ' : logProject.Project_category == '3' ? 'บริการวิชาการ' : 'วิจัย'
                                }}</p>
                              <p class="font-weight-bold">ประเภทแผน: {{
                                  logProject.IsPlan == '1' ? 'ในแผน' : 'นอกแผน'
                                }}</p>
                              <p class="font-weight-bold" v-if="episode == '1'">ระยะเวลาที่คาดว่าจะจัด:
                                {{
                                  'ต.ค. ' + (parseInt(FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(FiscalYear) + 543 - 1)
                                }}</p>
                              <p class="font-weight-bold" v-else-if="episode == '2'">ระยะเวลาที่คาดว่าจะจัด:
                                {{
                                  'ม.ค. ' + (parseInt(FiscalYear) + 543) + '- มี.ค. ' + (parseInt(FiscalYear) + 543)
                                }}</p>
                              <p class="font-weight-bold" v-else-if="episode == '3'">ระยะเวลาที่คาดว่าจะจัด:
                                {{
                                  'เม.ย. ' + (parseInt(FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(FiscalYear) + 543)
                                }}</p>
                              <p class="font-weight-bold" v-else-if="episode == '4'">ระยะเวลาที่คาดว่าจะจัด:
                                {{
                                  'ก.ค. ' + (parseInt(FiscalYear) + 543) + '- ก.ย. ' + (parseInt(FiscalYear) + 543)
                                }}</p>
                              <p class="font-weight-bold" v-else-if="episode == '9'">ระยะเวลาที่คาดว่าจะจัด:
                                {{
                                  'ตลอดปีงบประมาณ ' + (parseInt(FiscalYear) + 543)
                                }}</p>
                              <p class="font-weight-bold">รหัสแผน: {{ logProject.Project_code }}</p>
                              <p class="font-weight-bold">ชื่องาน / กิจกรรม: {{ logProject.Project_name }}</p>
                              <p class="font-weight-bold">ประเภทแผน: {{
                                  projectGroup.filter(item => item.Project_group == logProject.Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == logProject.Project_group)[0].Project_group_des : '-'
                                }}</p>
                              <p class="font-weight-bold">หลักสูตร:
                                {{
                                  courseData.filter(item => item.Course_code == logProject.Course_code).length > 0 ? courseData.filter(item => item.Course_code == logProject.Course_code)[0].Course_name : '-'
                                }}</p>
                              <p class="font-weight-bold">สาขาประเภทหลักสูตร:
                                {{
                                  courseData.filter(item => item.Course_code == logProject.Course_code).length > 0 ? courseData.filter(item => item.Course_code == logProject.Course_code)[0].Course_type_des : '-'
                                }}</p>
                              <p class="font-weight-bold">ระยะเวลา:
                                {{
                                  courseData.filter(item => item.Course_code == logProject.Course_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == logProject.Course_code)[0].Period_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == logProject.Course_code)[0].Period_code)[0].name : '-' : '-'
                                }}</p>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6">
                              <p class="font-weight-bold">จำนวน ช.ม.: {{ logProject.CalHourse }}</p>
                              <p class="font-weight-bold">จำนวน เครดิต: {{ logProject.CalCredit }}</p>
                              <p class="font-weight-bold">งบประมาณที่ขอ: {{ logProject.BudgetRequest }}</p>
                              <p class="font-weight-bold">งาน / กิจกรรม ถูกจัดขึ้น: {{
                                  PLACESelete.filter(item => item.id == logProject.PLACE).length > 0 ? PLACESelete.filter(item => item.id == logProject.PLACE)[0].detail : '-'
                                }}</p>
                              <p class="font-weight-bold" v-if="logProject.PLACE == '2'">จังหวัด: {{
                                  provinces_Data.filter(item => item.code == logProject.Province_id).length > 0 ? provinces_Data.filter(item => item.code == logProject.Province_id)[0].name_th : '-'
                                }}</p>
                              <p class="font-weight-bold" v-else-if="logProject.PLACE == '3'">ประเทศ: {{
                                  countryData.filter(item => item.ct_code == logProject.Country_id).length > 0 ? countryData.filter(item => item.ct_code == logProject.Country_id)[0].ct_nameTHA : '-'
                                }}</p>
                              <p class="font-weight-bold">จัดโดย:
                                {{
                                  WorkByData.filter(item => item.id == logProject.WorkBy).length > 0 ? WorkByData.filter(item => item.id == logProject.WorkBy)[0].detail : '-'
                                }}</p>
                              <p class="font-weight-bold">ชื่อผู้จัด: {{ logProject.WorkByName }}</p>
                              <p class="font-weight-bold">เบอร์โทรติดต่อผู้กรอกข้อมูล: {{ logProject.WorkByPhone }}</p>
                              <p class="font-weight-bold">สถานที่จัด: {{ logProject.Location }}</p>
                              <p class="font-weight-bold">กลุ่มเป้าหมาย: {{ logProject.TargetGroup }}</p>
                              <p class="font-weight-bold">วัตถุประสงค์: {{ logProject.Objective }}</p>
                              <p class="font-weight-bold">รายละเอียดประกอบเพิ่มเติม: {{ logProject.Remarks }}</p>
                              <p class="font-weight-bold">Competency,Core Value,Strategic Objective:
                                <v-btn text color="primary" @click="showCompetency(logProject)">คลิก!!</v-btn>
                              </p>
                              <p class="font-weight-bold">ไฟล์เอกสารประกอบ:
                                <v-btn text color="primary" @click="showFile(logProject)">คลิก!!</v-btn>
                              </p>
                              <p class="font-weight-bold">แก้ไขโดย: {{
                                  staffData.filter(item => item.perid == logProject.Create_By).length > 0 ? staffData.filter(item => item.perid == logProject.Create_By)[0].full_Name + '(' + staffData.filter(item => item.perid == logProject.Create_By)[0].perid + ') ' + staffData.filter(item => item.perid == logProject.Create_By)[0].dep_name : '-'
                                }} {{ logProject.Edit_type == '0' ? '(user)' : '(Admin)' }}</p>
                            </v-col>
                          </v-row>
                          <v-divider></v-divider>
                        </div>
                      </v-timeline-item>
                    </v-timeline>
                  </template>
                  <template v-else>
                    <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                      ไม่พบข้อมูลประวัติการแก้ไขข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี</p>
                  </template>
                </v-tab-item>
              </v-tabs-items>
            </template>
            <template v-else>
              <v-alert
                  outlined
                  type="warning"
                  prominent
                  border="left"
                  class="mt-8"
              >
                <span
                    style="text-align: center;font-size: 24px;font-weight: bold;">กรุณาเลือกแผนก่อนทำรายการ!!</span>
              </v-alert>
            </template>
          </v-list>
        </v-card>
      </v-expand-x-transition>
      <template>
        <v-dialog
            v-model="dialogLecturer"
            max-width="800"
        >
          <v-card style="padding-bottom: 20px">
            <v-card-title>
                                      <span style="font-weight: bold;color: black">
                                             แบบฟอร์มการเป็นวิทยากร/คณะกรรมการ
                                      </span>
            </v-card-title>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12"
                       md="6">
                  <v-text-field label="หัวข้อเรื่อง / หน้าที่" v-model="SubjectForLecturer"
                                :error="SubjectForLecturer == ''"
                                :error-messages="SubjectForLecturer == '' ? 'หัวข้อเรื่อง / หน้าที่ ห้ามว่าง' : ''"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12"
                       md="6">
                  <v-text-field type="date" label="วันที่เริ่มต้นจัดงาน"
                                v-model="dateSForLecturer"
                                :error="dateSForLecturer == ''"
                                :error-messages="dateSForLecturer == '' ? 'วันที่เริ่มต้นจัดงาน ห้ามว่าง' : ''"
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex justify-center" cols="12"
                       md="6">
                  <v-text-field type="date" label="วันที่สิ้นสุดจัดงาน"
                                v-model="dateEForLecturer"
                                :error="dateEForLecturer == ''"
                                :error-messages="dateEForLecturer == '' ? 'วันที่เริ่มต้นจัดงาน ห้ามว่าง' : ''"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12"
                       md="6">
                  <v-text-field type="date" label="วันที่เดินทาง"
                                v-model="dateSTravelForLecturer"
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex justify-center" cols="12"
                       md="6">
                  <v-text-field type="date" label="วันที่กลับ"
                                v-model="dateETravelForLecturer"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12"
                       md="6">
                  <v-text-field type="time" label="เวลาเริ่มต้น"
                                v-model="timeSForLecturer"
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex justify-center" cols="12"
                       md="6">
                  <v-text-field type="time" label="เวลาสิ้นสุด"
                                v-model="timeEForLecturer"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12"
                       md="10">
                  <v-textarea label="รายละเอียดเพิ่มเติม (ถ้ามี)" outlined v-model="Rm2"></v-textarea>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-file-input
                  v-model="filesExpert"
                  color="deep-purple accent-4"
                  counter
                  label="แนบไฟล์เอกสารประกอบ"
                  multiple
                  placeholder="เลือกไฟล์"
                  prepend-icon="mdi-paperclip"
                  outlined
                  :show-size="1000"
                  @change="FileSelectExpert"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                      v-if="index < 5"
                      color="deep-purple accent-4"
                      dark
                      label
                      small
                  >
                    {{ text }}
                  </v-chip>

                  <span
                      v-else-if="index === 5"
                      class="overline grey--text text--darken-3 mx-2"
                  >
                                  +{{ filesExpert.length - 2 }} File(s)
                                </span>
                </template>
              </v-file-input>
            </v-list-item>
            <v-list-item>
              <v-alert
                  v-if="alertExpert"
                  prominent
                  type="error"
              >
                <v-row align="center" v-for="item in txtAlertExpert" :key="item.id">
                  <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                </v-row>
              </v-alert>
            </v-list-item>
            <v-list-item v-if="FileProjectExpert.length > 0">
              <template>
                <v-row class="d-flex justify-center">
                  <v-col cols="12" md="12">
                    <v-list>
                      <v-list-item-title>
                        ไฟล์เอกสารประกอบ
                      </v-list-item-title>
                      <v-list-item>
                        <v-data-table
                            :items="FileProjectExpert"
                            :headers="FileHeader"
                            style="width: 100%"
                        >
                          <template v-slot:item.action="{ item }">
                            <v-list-item class="justify-space-around">
                              <v-btn text @click="ShowData(item.src)" color="green">
                                เรียกดู
                              </v-btn>
                              <v-btn @click="DeleteFile2(item)" text color="red">
                                ลบ
                              </v-btn>
                            </v-list-item>
                          </template>
                        </v-data-table>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </template>
            </v-list-item>
            <div align="center">
              <v-btn outlined color="primary" @click="AddWorkGuest">เพิ่มข้อมูล</v-btn>
            </div>
            <v-list-item class="d-flex justify-center" style="margin-top: 20px">
              <v-data-table :items="Lecturer" :headers="headerLecturer" class="elevation-2"
                            show-expand
                            style="width: 100%">
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <div v-for="(file, idx) in item.files" v-bind:key="idx">
                      <v-btn color="primary" text @click="ShowData(Openfile + file.path)">ไฟล์ : {{ file.name }}
                      </v-btn>
                    </div>
                    <div>
                      รายละเอียด : {{ item.Rm }}
                    </div>
                  </td>
                </template>
                <template v-slot:item.date_travel_start="{item}">
                  <span v-if="item.date_travel_start != '' && item.date_travel_start != null">{{
                      item.date_travel_start | dateToThai
                    }}</span>
                </template>
                <template v-slot:item.date_travel_end="{item}">
                  <span v-if="item.date_travel_end != '' && item.date_travel_end != null">{{
                      item.date_travel_end | dateToThai
                    }}</span>
                </template>
                <template v-slot:item.date_start="{item}">
                  <span v-if="item.date_start != '' && item.date_start != null">{{
                      item.date_start | dateToThai
                    }}</span>
                </template>
                <template v-slot:item.date_end="{item}">
                  <span v-if="item.date_end != '' && item.date_end != null">{{ item.date_end | dateToThai }}</span>
                </template>
              </v-data-table>
            </v-list-item>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  outlined
                  color="green darken-2"
                  @click="InsertCoordinator(true)"
              >
                บันทึก
              </v-btn>
              <v-btn
                  color="red darken-1"
                  text
                  @click="dialogLecturer = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogDetail"
            max-width="800"
        >
          <v-card v-if="itemToShow != null">
            <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">{{
                itemToShow.DelvDes
              }}</span>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col
                    cols="12"
                    md="12">
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อย่อ:</span> {{ itemToShow.DelvShort }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อ Eng:</span> {{ itemToShow.DelvEng }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คำอธิบาย:</span> {{ itemToShow.DelvRm }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">PSU:</span> {{ itemToShow.PSU }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black" v-if="itemToShow.DelvGroup == 'A'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะหลัก
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'B'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะด้านบริหาร
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'C'">
                    <span style="color: #364eff">กรุ๊ป:</span> จิตสํานึกด้านความเสียงและความปลอดภัย
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'D'">
                    <span style="color: #364eff">กรุ๊ป:</span> กลยุทธ์
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คณะ/หน่วยงาน:</span> {{ itemToShow.dep_name }}
                  </p>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogDetail = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogTemplate"
            max-width="800"
        >
          <v-card>
            <v-card-title>ฟอร์ฺมตัวอย่าง</v-card-title>
            <v-card-text>
              <div v-html="editorData"></div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogTemplate = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogLecturerDetail"
            max-width="800"
        >
          <v-card>
            <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">รายละเอียดการเป็นวิทยากร/คณะกรรมการ</span>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="LecturerDetail" :headers="headerLecturer" class="elevation-2"
                            show-expand
                            style="width: 100%">
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <div v-for="(file, idx) in item.files" v-bind:key="idx">
                      <v-btn color="primary" text @click="ShowData(Openfile + file.File_path)">ไฟล์ : {{
                          file.File_name
                        }}
                      </v-btn>
                    </div>
                    <div>
                      รายละเอียด : {{ item.Rm }}
                    </div>
                  </td>
                </template>
                <template v-slot:item.date_travel_start="{item}">
                  <span v-if="item.date_travel_start != '' && item.date_travel_start != null">{{
                      item.date_travel_start | dateToThai
                    }}</span>
                </template>
                <template v-slot:item.date_travel_end="{item}">
                  <span v-if="item.date_travel_end != '' && item.date_travel_end != null">{{
                      item.date_travel_end | dateToThai
                    }}</span>
                </template>
                <template v-slot:item.date_start="{item}">
                  <span v-if="item.date_start != '' && item.date_start != null">{{
                      item.date_start | dateToThai
                    }}</span>
                </template>
                <template v-slot:item.date_end="{item}">
                  <span v-if="item.date_end != '' && item.date_end != null">{{ item.date_end | dateToThai }}</span>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  text
                  @click="dialogLecturerDetail = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <v-snackbar
          v-model="snack"
          :timeout="3000"
          :color="snackColor"
      >
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn
              v-bind="attrs"
              text
              @click="snack = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            :color="appColor"
            dark
        >
          <v-card-text>
            Loading.....
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogCompetency"
          max-width="800"
      >
        <v-card>
          <v-card-title>
            Competency,Core Value,Strategic Objective
          </v-card-title>
          <v-card-text>
            <template v-if="CompetencyToShow.length > 0">
              <v-treeview :activatable="true" :items="CompetencyToShow">
                <template v-slot:prepend="{ item, open }">
                  <v-icon v-if="!item.file" color="blue lighten-2">
                    {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                  </v-icon>
                  <v-icon v-else>
                    {{ files[item.file] }}
                  </v-icon>
                </template>
                <template v-slot:label="{ item, active }">
                  <div v-if="isMobile" style="cursor: pointer">
                                                <span style="font-size: 12px;color: black" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                    <span style="font-size: 12px;color: #364eff;font-weight: bold"
                          v-else>
                                                    {{ item.name }}
                                                </span>
                  </div>
                  <div v-else style="cursor: pointer">
                                                <span style="color:black;" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                    <span style="color: #364eff;font-weight: bold" v-else>
                                                    {{ item.name }}
                                                </span>
                  </div>
                </template>
              </v-treeview>
            </template>
            <template v-else>
              <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">ไม่พบข้อมูล
                Competency,Core Value,Strategic Objective</p>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="red darken-1"
                outlined
                @click="dialogCompetency = false"
            >
              <span style="font-size: 24px;font-weight: bold">ปิด</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogFile"
          max-width="800"
      >
        <v-card>
          <v-card-title>
            ไฟล์เอกสารประกอบ
          </v-card-title>
          <v-card-text>
            <template v-if="LogFileProject.length > 0">
              <v-container fluid>
                <v-row>
                  <v-col
                      v-for="(file_i, index) in LogFileProject"
                      :key="index"
                      class="d-flex child-flex"
                      cols="12"
                      md="4"
                  >
                    <v-card flat tile>
                      <v-img
                          v-if="file_i.type == 'image'"
                          :src="file_i.src"
                          :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                          aspect-ratio="1"
                          class="grey lighten-2"
                      >
                        <template
                            v-slot:placeholder>
                          <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                          >
                            <v-progress-circular
                                indeterminate
                                color="grey lighten-5"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-img
                          v-if="file_i.type == 'pdf'"
                          src="../../assets/Image/pdf.png"
                          :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                          aspect-ratio="1"
                          class="grey lighten-2"
                      >
                        <template
                            v-slot:placeholder>
                          <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                          >
                            <v-progress-circular
                                indeterminate
                                color="grey lighten-5"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-card-text>
                                                                                                  <span
                                                                                                      style="font-weight: bold;color: black">
                                                                                                      {{ file_i.name }}
                                                                                                  </span>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn text
                               @click="ShowData(file_i.src)">
                                                                                                      <span
                                                                                                          style="color: indigo;font-weight: bold">
                                                                                                          เรียกดู
                                                                                                      </span>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>
            <template v-else>
              <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                ไม่พบข้อมูลไฟล์เอกสารประกอบ</p>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="red darken-1"
                outlined
                @click="dialogFile = false"
            >
              <span style="font-size: 24px;font-weight: bold">ปิด</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogTempFile"
          max-width="800"
      >
        <v-card>
          <v-card-title>
            ไฟล์เอกสารประกอบ
          </v-card-title>
          <v-card-text>
            <template v-if="TempFileProject.length > 0">
              <v-container fluid>
                <v-row>
                  <v-col
                      v-for="(file_i, index) in TempFileProject"
                      :key="index"
                      class="d-flex child-flex"
                      cols="12"
                      md="4"
                  >
                    <v-card flat tile>
                      <v-img
                          v-if="file_i.type == 'image'"
                          :src="file_i.src"
                          :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                          aspect-ratio="1"
                          class="grey lighten-2"
                      >
                        <template
                            v-slot:placeholder>
                          <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                          >
                            <v-progress-circular
                                indeterminate
                                color="grey lighten-5"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-img
                          v-if="file_i.type == 'pdf'"
                          src="../../assets/Image/pdf.png"
                          :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                          aspect-ratio="1"
                          class="grey lighten-2"
                      >
                        <template
                            v-slot:placeholder>
                          <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                          >
                            <v-progress-circular
                                indeterminate
                                color="grey lighten-5"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-card-text>
                                                                                                  <span
                                                                                                      style="font-weight: bold;color: black">
                                                                                                      {{ file_i.name }}
                                                                                                  </span>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn text
                               @click="ShowData(file_i.src)">
                                                                                                      <span
                                                                                                          style="color: indigo;font-weight: bold">
                                                                                                          เรียกดู
                                                                                                      </span>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>
            <template v-else>
              <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                ไม่พบข้อมูลไฟล์เอกสารประกอบ</p>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="red darken-1"
                outlined
                @click="dialogTempFile = false"
            >
              <span style="font-size: 24px;font-weight: bold">ปิด</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <v-dialog
        v-model="dialogCancelOrCloseProject"
        max-width="600px"
    >
      <v-card v-if="ProjectObj != null">
        <v-card-title class="font-weight-bold">
          <span>กรุณาระบุเหตุผลยกเลิกการจัด โครงการ : {{ProjectObj.Project_name}} ({{ ProjectObj.Project_code }})</span>
        </v-card-title>
        <v-card-text>
          <v-textarea
              v-model="remarksCloseProject"
              label="เหตุผลการยกเลิกการจัดโครงการ"
              :error-messages="remarksCloseProject == '' ? 'เหตุผล ห้ามว่าง' : ''"
              :error="remarksCloseProject == ''"
              outlined
              required
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              @click="CancelProject(ProjectObj)"
          >บันทึก</v-btn>
          <v-btn
              color="red"
              @click="dialogCancelOrCloseProject = false"
          >ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import ConstData from '../../const/Const'
import {mapActions, mapGetters} from "vuex";
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
import Vue from "vue";
import queryString from "query-string";

export default {
  name: "EditPlanProject",
  data() {
    return {
      remarksCloseProject: '',
      dialogCancelOrCloseProject: false,
      ProjectObj: null,
      FiscalYearMenuData: [],
      YearSel: null,
      RecordDataDump: [],
      RecordData: [],
      headerAxios: {
        headers: {
          'Content-Type': 'application/json',
        }
      },
      dialogLoading: true,
      isLoading: true,
      Project: null,
      LogObjProject: null,
      TempObjProject: null,
      dialogTempFile: false,
      dialogFile: false,
      dialogCompetency: false,
      CompetencyToShow: [],
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      IsPlan: null,
      IsPlanCordi: false,
      episode: null,
      PlanProject_code: '',
      Project_code_dump: '',
      itemCode: '',
      ProjectPlan: null,
      Project_plan: [],
      TypeCreateProject: '1',
      FiscalYearData: [],
      rdoRegisterProject: '0',
      ProjectQuotaDepCount: 0,
      dateRegStart: '',
      dateRegEnd: '',
      MessageSuc: '',
      MessageError: '',
      ShowAlertErr: false,
      ShowAlertSuc: false,
      DepQuotaData: [],
      searchDepQuota: '',
      ChooseTypRegis: '1',
      ChooseTypRegis2: '0',
      ChkJoinPerson: true,
      ProjectQuotaCount: '',
      DepQuotaCount: '',
      groupDepart: [],
      ChooseTypeDep: '0',
      DepQuotaSelect: '',
      CheckSubAdmin: false,
      CheckAdmin: false,
      Rm2: '',
      WorkGroupData: [],
      Openfile: ConstData.ConnectionHost + '/rest/files',
      FileHeader: [
        {text: 'ชื่อไฟล์', value: 'name'},
        {text: 'ประเภทไฟล์', value: 'type'},
        {text: '', value: 'action'},
      ],
      DepQuotaHeader: [
        {text: 'ประเภท', value: 'type'},
        {text: 'ภาควิชา/หน่วยงาน', value: 'dep_name'},
        {text: 'จำนวน', value: 'count'},
        {text: '', value: 'action'},
      ],
      filesExpert: [],
      alertExpert: false,
      txtAlertExpert: [],
      FileProjectExpert: '',
      dateSTravelForLecturer: '',
      dateETravelForLecturer: '',
      ChooseForm: 'OldForm',
      dialogLecturerDetail: false,
      LecturerDetail: [],
      Country_id: '',
      dialogLecturer: false,
      percent: 0,
      dialogTemplate: false,
      CheckLecturer: false,
      Lecturer: [],
      TemplateProject: [],
      LecturerToShow: [],
      Committee_ToShow: [],
      projectGroupToShow: [],
      headerLecturer: [
        {text: 'หัวข้อเรื่อง', value: 'subject'},
        {text: 'วันที่จัดงานเริ่มต้น', value: 'date_start'},
        {text: 'วันที่จัดงานสิ้นสุด', value: 'date_end'},
        {text: 'วันที่เดินทาง', value: 'date_travel_start'},
        {text: 'วันที่กลับ', value: 'date_travel_end'},
        {text: 'เวลาเริ่มต้น', value: 'time_start'},
        {text: 'เวลาสิ้นสุด', value: 'time_end'},
      ],
      SubjectForLecturer: '',
      dateSForLecturer: '',
      dateEForLecturer: '',
      timeSForLecturer: '',
      timeEForLecturer: '',
      formprint1: '', // หลักการและเหตุผล
      formprint2: '', // วัตถุประสงค์
      formprint3: '', // กลุ่มเป้าหมาย
      formprint4: '', // วิธีการจัดอบรม
      formprint5: '', // ระยะเวลาการจัดอบรม
      formprint6: '', // สถานที่จัดอบรม
      formprint7: '', // ผลที่คาดว่าจะได้รับ
      formprint8: '', // ผู้รับผิดชอบโครงการ
      formprint9: '', // ผู้รับผิดชอบโครงการ
      formprint10: '', // วิทยากร
      formprint11: '', // งบประมาณ
      formprint12: '', // หมายเหตุ
      editor: DecoupledEditor,
      editorDataGenerate: '',
      editorDataFormDB: '',
      editorData: '',
      editorConfig: {
        // The configuration of the editor.
        language: 'th',
        fontFamily: {
          options: [
            'default',
            'Arial, Helvetica, sans-serif',
            'Courier New, Courier, monospace',
            'Georgia, serif',
            'Lucida Sans Unicode, Lucida Grande, sans-serif',
            'Tahoma, Geneva, sans-serif',
            'Times New Roman, Times, serif',
            'Trebuchet MS, Helvetica, sans-serif',
            'Verdana, Geneva, sans-serif',
            'THSarabunNew'
          ]
        },
        fontSize: {
          options: [
            2,
            4,
            8,
            16,
            18,
            20,
            22,
            24,
            28,
            32,
            48,
            56,
            64
          ]
        },
      },
      Expense: 0,
      btnDisable: false,
      snack: false,
      snackColor: '',
      snackText: '',
      ReqMoney: '',
      Rm: '',
      selection: [],
      logSelection: [],
      tempSelection: [],
      dialogDetail: false,
      itemToShow: null,
      searchCompe: '',
      isMobile: false,
      SelDelvNo: '',
      itemsSel: [],
      CompetencyData: [],
      CompetencyDataDump: [],
      ProjectData_U: [],
      Period_code: '',
      period: [
        {
          'name': 'ระยะสั้น (ไม่เกิน 1 เดือน)',
          'id': '2'
        },
        {
          'name': 'ระยะยาว (มากกว่า 1 เดือน)',
          'id': '3'
        }
      ],
      Approve: '1',
      DepSelect: '35000',
      EmpData: [],
      departSel: null,
      IdPersonal: '',
      personalMedData: [],
      IdDepart: '',
      Idstudent: '',
      tabPersonal: null,
      TypeInsert: '0',
      studentUniData: [],
      IdstudentUni: '',
      IdDepartStd: '',
      searchPerson: '',
      headersPerson: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ลงทะเบียน', value: 'status_reg'},
        {text: '', value: 'action'}
      ],
      JoinPerson: [],
      cardSel: '',
      staffSel: '',
      NameP: '',
      items: [],
      SurNameP: '',
      affiliation: '',
      position: '',
      idCard: '',
      NameStd: '',
      SurNameStd: '',
      affiliationStd: '',
      idCardStd: '',
      AllDepartData: [],
      studentData: [],
      FileProject: [],
      TempFileProject: [],
      LogFileProject: [],
      FileProjectOld: [],
      alert: false,
      txtAlert: [],
      tab: null,
      Competency_code: '',
      UPercent: '',
      competencyHeader: [
        {text: 'Competency', value: 'Competency_des'},
        {text: 'เปอเซ็นต์', value: 'UPercent'},
        {text: '', value: 'action'}
      ],
      competency_DataForSubmit: [],
      expenseCostSum: 0,
      DepCost: '',
      expenseCost: '',
      moneyCost: '',
      expense_DataForSubmit: [],
      expense_p_DataForSubmit: [],
      CheckStep1: true,
      e1: 1,
      steps: 8,
      vertical: false,
      altLabels: false,
      editable: true,
      CheckFiles: false,
      full_name: '',
      phone: '',
      perid: '',
      peridCost: '',
      peridCommittee: '',
      Committee_code: '',
      radioGroup: '0',
      radioGroup2: '0',
      files: [],
      Project_Choose: '',
      ChooseCourse: '',
      posiCondi: '',
      levelCondi: '',
      workAgeStart_Condi: '',
      workAgeEnd_Condi: '',
      WSYear_Condi: '',
      WEYear_Condi: '',
      Course_Choose: '',
      DataCondi: [],
      courseCondi: [],
      Project_code: '',
      Project_code_ref: '',
      Project_name: '',
      Course_code: null,
      course_group: '',
      FiscalYear: '',
      IsPlanStatus: '',
      IsDataComplete: '',
      IsProcess: null,
      Project_category: null,
      Project_type: '',
      WorkBy: '',
      WorkByName: '',
      WorkByPhone: '',
      Location: '',
      DateStart: '',
      DateEnd: '',
      CalHourse: '',
      CalCredit: '',
      PLACE: '',
      Province_id: '',
      Status: '0',
      Objective: '',
      TargetGroup: '',
      Remarks: '',
      ProjectLevel: '',
      App_doc_no: '',
      BudgetRequest: '',
      BudgetArrove: '',
      Project_group: '',
      D_Project: {
        Project_code: '',
        Ref_Project_code: '',
        Project_name: '',
        Course_code: null,
        course_group: '',
        IsProcess: null,
        Project_category: '',
        Project_type: '',
        WorkBy: '',
        WorkByName: '',
        WorkByPhone: '',
        Location: '',
        DatePeriod: '1',
        DateStart: '',
        DateEnd: '',
        CalHourse: '',
        CalCredit: '',
        PLACE: '',
        Province_id: '',
        Status: '0',
        Objective: '',
        TargetGroup: '',
        Remarks: '',
        ProjectLevel: '',
        App_doc_no: '',
        BudgetRequest: '',
        BudgetArrove: '',
        Project_group: '',
        Approve: '1',
        FiscalYear: '',
        IsPlan: '',
        IsPlanStatus: '',
        Status_Reg: '',
        Status_Type_Reg: '',
        DateS_Reg: '',
        DateE_Reg: '',
        Status_Count_Reg: '',
        Count_Reg: '',
        Dep_Code: '',
        Update_By: ''
      },
      expanded: [],
      singleExpand: false,
      search: '',
      CoordinatorHeader: [
        {text: 'ชื่อ - สกุล', value: 'Name'},
        {text: 'ตำแหน่ง', value: 'position_com'},
        {text: 'เบอรโ์โทร', value: 'TEL'},
        {text: 'สถานะ', value: 'Committee_type'},
        {text: 'วิทยากร', value: 'Lecturer'},
        {text: '', value: 'action'}
      ],
      Coordinator: [],
      courseHeadersCondi: [
        {text: 'หลักสูตร', value: 'Course_name'},
        {text: '', value: 'action'},
      ],
      courseDataCondi: [],
      dataHeadersCondi: [
        {text: 'ตำแหน่ง', value: 'PosName'},
        {text: 'อายุงานเริ่มต้น', value: 'workAgeStart'},
        {text: 'อายุงานสิ้นสุด', value: 'workAgeEnd'},
        {text: '', value: 'action'},
      ],
      dataDataCondi: [],
      projectNeed: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: false,
      disabled: false,
      enableEvents: false,
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ถายในประเทศ'
        },
        {
          id: '3', detail: 'ต่างประเทศ'
        },
        {
          id: '4', detail: 'online'
        }
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'หน่วยงาน/คณะ มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      Menu: [
        {
          'id': 1,
          'value': 'จัดโครงการ'
        },
        {
          'id': 2,
          'value': 'จัดการข้อมูลโครงการ'
        },
        {
          'id': 3,
          'value': 'ข้อมูลเบิกจ่ายเงินโครงการ'
        }],
      projectType: [
        {
          id: '0',
          details: 'อบรม'
        },
        {
          id: '1',
          details: 'ดูงาน'
        },
        {
          id: '2',
          details: 'ประชุม'
        },
        {
          id: '3',
          details: 'นำเสนองาน'
        }
      ],
      workBy: [
        'Depart',
        'Faculty',
        'University',
        'Public C',
        'Co-Project'
      ],
      CourseType: [
        'ทั่วไป',
        'เฉพาะตำแหน่ง'
      ],
      DataCourse: {
        Project_code: '',
        Course_code: '',
        Credit: ''
      },
      budgetHeader: [
        {text: 'รายการ', value: 'Expense_des'},
        {text: 'จำนวนเงิน', value: 'ReqMoney'},
        {text: 'หมายเหตุ', value: 'Rm'},
        {text: '', value: 'action'}
      ],
      budgetData: [],
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      }
    }
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    },
    vertical() {
      this.e1 = 2
      requestAnimationFrame(() => this.e1 = 1) // Workarounds
    },
  },
  computed: {
    functionEvents() {
      return this.month ? this.monthFunctionEvents : this.dateFunctionEvents
    },
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      committee_Posi: 'Project/getComitteeType',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      textForPrint: 'Project/getTextForPrint',
      countryData: 'Project/getCountry',
      projectPalnData: 'Project/getProjectPlan',
      ProjectPlanApproveData: 'Project/getProjectPlanApprove',
      projectForApprove: 'Project/getProjectForApprove',
      allPlanProj: 'Project/getAllPlanProjFormFiscalYear',
      ApproveMaster: 'Staff/getApproveMaster',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      Competency: 'Competency/getCompetency',
      ProjectCompetency: 'Project/getCompetency',
      ProjectExpense: 'Project/getProjectExpense',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      ApproveData: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
      SubMenuPermiss: 'Permission/getSubMenuPermiss',
      IgnoreSubMenuPermiss: 'Permission/getIgnoreSubMenuPermiss',
      DateForPlan: 'Project/getDateForPlan',
      LogProject: 'Project/getLogProject',
      LogCompetencyProject: 'Project/getLogCompetency',
      LogFiles: 'Project/getLogFiles',
      TempProject: 'Project/getTempProject',
      TempCompetencyProject: 'Project/getTempCompetency',
      TempFiles: 'Project/getTempFiles',
      TypeProject: 'Project/getTypeProject',
      StatusProject: 'Project/getStatusProject',
      appColor: 'Page/getColor',
      // dialogLoading: 'Page/getDialogLoading',
    }),
    // dialogLoading: {
    //   // getter
    //   get: function () {
    //     return this.$store.state.Page.appDialogLoading
    //   },
    //   // // setter
    //   // set: function (newValue) {
    //   // this.$store.commit('updateMessage', value)
    //   // }
    // }
  },

  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      MangeTextForPrint: 'Project/MangeTextForPrint',
      initCountryData: 'Project/initCountryData',
      initProjectExpenseData: 'Project/initProjectExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initProjectPlanData: 'Project/initProjectPlanData',
      initPlanProjectDataForApprove: 'Project/initPlanProjectDataForApprove',
      initAllPlanProjectDataForApprove: 'Project/initAllPlanProjectDataForApprove',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initProjAllPlanDataFromFiscalYear: 'Project/initProjAllPlanDataFromFiscalYear',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initApproveMasterByType: 'Staff/initApproveMasterByType',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      getSubMenuPermissData: 'Permission/getSubMenuPermissData',
      getIgnoreSubMenuPermissData: 'Permission/getIgnoreSubMenuPermissData',
      initDateForPlan: 'Project/initDateForPlan',
      initLogProject: 'Project/initLogProject',
      initLogCompetencyProject: 'Project/initLogCompetencyProject',
      initLogFileProject: 'Project/initLogFileProject',
      initTempProject: 'Project/initTempProject',
      initTempCompetencyProject: 'Project/initTempCompetencyProject',
      initTempFileProject: 'Project/initTempFileProject',
      changeTypeProject: 'Project/changeTypeProject',
      // changeDialogLoading: 'Page/changeDialogLoading',
    }),
    changeDate() {
      switch (this.episode) {
        case '1':
          this.DateStart = (parseInt(this.FiscalYear) - 1) + '-10-01'
          this.DateEnd = (parseInt(this.FiscalYear) - 1) + '-12-31'
          break
        case '2':
          this.DateStart = this.FiscalYear + '-01-01'
          this.DateEnd = this.FiscalYear + '-03-31'
          break
        case '3':
          this.DateStart = this.FiscalYear + '-04-01'
          this.DateEnd = this.FiscalYear + '-06-30'
          break
        case '4':
          this.DateStart = this.FiscalYear + '-07-01'
          this.DateEnd = this.FiscalYear + '-09-30'
          break
        default:
          this.DateStart = (parseInt(this.FiscalYear) - 1) + '-10-01'
          this.DateEnd = this.FiscalYear + '-09-30'
          break
      }
    },
    GetPlanToForm() {
      this.Project = null
      this.LogObjProject = null
      this.TempObjProject = null
      this.Project_code = ''
      this.Project_code_ref = ''
      this.Project_name = ''
      this.Project_code_dump = ''
      this.Course_code = null
      this.course_group = ''
      this.IsProcess = null
      this.Project_category = null
      this.Remarks = ''
      this.Objective = ''
      this.TargetGroup = ''
      this.CalCredit = '0'
      this.CalHourse = '0'
      this.PLACE = ''
      this.Province_id = ''
      this.Country_id = ''
      this.BudgetRequest = '0'
      this.Location = ''
      this.WorkBy = ''
      this.WorkByName = ''
      this.WorkByPhone = ''
      this.DateStart = ''
      this.DateEnd = ''
      this.DepSelect = '35000'
      this.Project_group = ''
      this.FiscalYear = ''
      this.episode = null
      this.itemCode = ''
      this.IsPlan = null
      this.IsPlanStatus = ''
      this.Status = '0'
      this.IsDataComplete = ''
      this.FileProjectOld = []
      this.FileProject = []
      this.RecordData = []
      this.RecordDataDump = []
      if (this.ProjectPlan != null) {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_view/Project_code/' + this.ProjectPlan).then(res => {
          if (res.data) {
            this.LogObjProject = res.data
            this.Project = res.data
            this.Project_code = res.data.Project_code
            this.Project_code_ref = res.data.Ref_Project_code
            this.Project_code_dump = res.data.Project_code
            this.Project_name = res.data.Project_name
            if (res.data.Course_code == '' || res.data.Course_code == null) {
              this.Course_code = null
            } else {
              this.Course_code = res.data.Course_code
            }
            this.course_group = res.data.Course_group
            this.IsProcess = res.data.IsProcess
            this.Project_category = res.data.Project_category
            this.Remarks = res.data.Remarks
            this.Objective = res.data.Objective
            this.TargetGroup = res.data.TargetGroup
            this.CalCredit = '' + res.data.CalCredit
            this.CalHourse = '' + res.data.CalHourse
            this.PLACE = res.data.PLACE
            this.Province_id = res.data.Province_id
            this.Country_id = res.data.Country_id
            this.BudgetRequest = res.data.BudgetRequest
            this.Location = res.data.Location
            this.WorkBy = res.data.WorkBy
            this.WorkByName = res.data.WorkByName
            this.WorkByPhone = res.data.WorkByPhone
            this.episode = res.data.DatePeriod
            this.DateStart = res.data.DateStart
            this.DateEnd = res.data.DateEnd
            this.DepSelect = res.data.Dep_Code
            this.Project_group = res.data.Project_group
            this.FiscalYear = parseInt(res.data.FiscalYear)
            this.IsPlan = res.data.IsPlan
            this.IsPlanStatus = res.data.IsPlanStatus
            this.itemCode = res.data.Item_Code
            this.Status = res.data.Status
            this.IsDataComplete = res.data.IsDataComplete

            this.SelProjectGroup()
            this.getCourseType()
            this.getCompetency()
            this.initLogProject({
              Project_code: this.ProjectPlan
            })
            this.initTempProject({
              Project_code: this.ProjectPlan
            })
            this.getApproveRecord()

            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Type/0/active/1/Project_code/' + this.ProjectPlan).then(res => {
              if (res.data) {
                if (res.data.length > 0) {
                  res.data.map((item) => {
                    switch (item.File_type) {
                      case 'image/jpg':
                      case 'image/jpeg':
                      case 'image/gif':
                      case 'image/bmp':
                      case 'image/png':
                        this.FileProject.push({
                          id: item.id,
                          name: item.File_name,
                          src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                          path: item.File_path,
                          type: 'image',
                          type_Img: item.File_type
                        })
                        break
                      case 'application/pdf':
                        this.FileProject.push({
                          id: item.id,
                          name: item.File_name,
                          src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                          path: item.File_path,
                          type: 'pdf',
                          type_Img: item.File_type
                        })
                        break
                      default:
                        break
                    }
                  })
                } else {
                  switch (res.data.File_type) {
                    case 'image/jpg':
                    case 'image/jpeg':
                    case 'image/gif':
                    case 'image/bmp':
                    case 'image/png':
                      this.FileProject.push({
                        id: res.data.id,
                        name: res.data.File_name,
                        src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                        path: res.data.File_path,
                        type: 'image',
                        type_Img: res.data.File_type
                      })
                      break
                    case 'application/pdf':
                      this.FileProject.push({
                        id: res.data.id,
                        name: res.data.File_name,
                        src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                        path: res.data.File_path,
                        type: 'pdf',
                        type_Img: res.data.File_type
                      })
                      break
                    default:
                      break
                  }
                }
                this.FileProjectOld = this.FileProject
              } else {
                this.FileProject = []
              }
            })


          }
        })
      }
    },
    getApproveRecord() {
      this.RecordDataDump = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record_view/Project_code/' + this.Project_code + '/Type/1/?sort=id_DESC').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.RecordData = res.data
          } else {
            this.RecordData.push(res.data)
          }
          this.RecordData.map(item => {
            item.files = []
          })
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/active/1/Project_code/' + this.Project_code + '/?sort=id_DESC').then(res => {
            if (res.data) {
              this.dialogLoading = false
              // var files_Project = []
              if (res.data.length > 0) {
                res.data.map(file_i => {
                  this.RecordData.map(record_i => {
                    if (record_i.Project_code == file_i.Project_code && record_i.id == file_i.project_record_id) {
                      record_i.files.push(file_i)
                    }
                  })
                })
              } else {
                this.dialogLoading = false
                this.RecordData.map(record_i => {
                  if (record_i.Project_code == res.data.Project_code && record_i.id == res.data.project_record_id) {
                    record_i.files.push(res.data)
                  }
                })
              }
              this.RecordDataDump = this.RecordData
            } else {
              this.dialogLoading = false
              this.RecordDataDump = this.RecordData
            }
          })
        } else {
          this.dialogLoading = false
          this.RecordData = []
          this.RecordDataDump = []
        }
      })
    },
    getCompetency() {
      this.logSelection = []
      this.selection = []
      this.initProjectCompetencyData({
        Project_code: this.ProjectPlan
      }).then(res => {
        if (res) {
          this.ProjectCompetency.map(ProjectCom => {
            this.selection.push(ProjectCom.DelvNo)
          })
          this.logSelection = this.selection
        }
        this.ChooseCompetency()
      }).catch(resCatch => {
        if (resCatch) {
          this.ChooseCompetency()
        }
      })
    },
    showCompetency(item) {
      this.CompetencyToShow = []
      this.dialogLoading = true
      this.initLogCompetencyProject({
        Ref_id: item.Ref_id
      }).then(res => {
        if (res) {
          this.dialogCompetency = true
          this.dialogLoading = false
          if (this.LogCompetencyProject.length > 0) {
            this.LogCompetencyProject.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)

                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })

                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }

                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)

                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }

                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          }
        } else {
          this.dialogLoading = false
          this.dialogCompetency = true
          // Error Competency
        }
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
          this.dialogCompetency = true
        }
      })
    },
    showFile(item) {
      this.dialogFile = true
      this.dialogLoading = true
      this.LogFileProject = []
      this.initLogFileProject({
        Ref_id: item.Ref_id
      }).then(res => {
        if (res) {
          if (this.LogFiles.length > 0) {
            this.LogFiles.map((item) => {
              switch (item.File_type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.LogFileProject.push({
                    id: item.id,
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'image',
                    type_Img: item.File_type
                  })
                  break
                case 'application/pdf':
                  this.LogFileProject.push({
                    id: item.id,
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'pdf',
                    type_Img: item.File_type
                  })
                  break
                default:
                  break
              }
            })
          }
        }
        this.dialogLoading = false
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
        }
      })
    },
    showTempCompetency(item) {
      this.CompetencyToShow = []
      this.dialogLoading = true
      this.initTempCompetencyProject({
        Ref_id: item.Ref_id
      }).then(res => {
        if (res) {
          this.dialogCompetency = true
          this.dialogLoading = false
          if (this.TempCompetencyProject.length > 0) {
            this.TempCompetencyProject.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)

                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })

                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }

                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)

                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }

                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          }
        } else {
          this.dialogLoading = false
          this.dialogCompetency = true
          // Error Competency
        }
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
          this.dialogCompetency = true
        }
      })
    },
    showTempFile(item) {
      this.dialogTempFile = true
      this.dialogLoading = true
      this.TempFileProject = []
      this.initTempFileProject({
        Ref_id: item.Ref_id
      }).then(res => {
        if (res) {
          if (this.TempFiles.length > 0) {
            this.TempFiles.map((item) => {
              switch (item.File_type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.TempFileProject.push({
                    id: item.id,
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'image',
                    type_Img: item.File_type
                  })
                  break
                case 'application/pdf':
                  this.TempFileProject.push({
                    id: item.id,
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'pdf',
                    type_Img: item.File_type
                  })
                  break
                default:
                  break
              }
            })
          }
        }
        this.dialogLoading = false
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
        }
      })
    },
    CheckCourseClear() {
      this.course_group = ''
      this.Project_code = ''
      this.Project_code_ref = ''
      this.Period_code = 0
      this.CalHourse = '0'
      this.CalCredit = '0'
    },
    ClearData() {
      this.PlanProject_code = ''
      this.Project = null
      this.ProjectPlan = null
      this.Project_code = ''
      this.Project_code_ref = ''
      this.Project_name = ''
      this.Course_code = null
      this.course_group = ''
      this.IsProcess = null
      this.Project_category = null
      this.Objective = ''
      this.TargetGroup = ''
      this.Remarks = ''
      this.CalCredit = '0'
      this.CalHourse = '0'
      this.PLACE = ''
      this.Province_id = ''
      this.Country_id = ''
      this.BudgetRequest = '0'
      this.Location = ''
      this.WorkBy = ''
      this.WorkByName = ''
      this.WorkByPhone = ''
      this.DateStart = ''
      this.IsDataComplete = ''
      this.DateEnd = ''
      this.DepSelect = ''
      this.Project_group = ''
      this.FiscalYear = ''
      this.itemCode = ''
      this.FileProjectOld = []
      this.FileProject = []
      this.files = []
      this.Project = null
      this.LogObjProject = null
      this.TempObjProject = null
    },
    DaysInMonth(anyDateInMonth) {
      return new Date(anyDateInMonth.getFullYear(),
          anyDateInMonth.getMonth() + 1,
          0).getDate()
    },
    getAge(date_1, date_2) {
      //convert to UTC
      var arrayWorkSummary = [];
      var date2_UTC = new Date(Date.UTC(date_2.getUTCFullYear(), date_2.getUTCMonth(), date_2.getUTCDate()));
      var date1_UTC = new Date(Date.UTC(date_1.getUTCFullYear(), date_1.getUTCMonth(), date_1.getUTCDate()));


      //--------------------------------------------------------------
      var days = date2_UTC.getDate() - date1_UTC.getDate();
      if (days < 0) {

        date2_UTC.setMonth(date2_UTC.getMonth() - 1);
        days += this.DaysInMonth(date2_UTC);
      }
      //--------------------------------------------------------------
      var months = date2_UTC.getMonth() - date1_UTC.getMonth();
      if (months < 0) {
        date2_UTC.setFullYear(date2_UTC.getFullYear() - 1);
        months += 12;
      }
      //--------------------------------------------------------------
      var years = date2_UTC.getFullYear() - date1_UTC.getFullYear();

      arrayWorkSummary.push(years);
      arrayWorkSummary.push(months);
      arrayWorkSummary.push(days);

      return arrayWorkSummary;
    },
    AddDepQuotaData() {
      var CheckMatch = []
      if (this.DepQuotaSelect != '' && this.DepQuotaCount != '') {
        if (!this.ChkJoinPerson && (parseInt(this.DepQuotaCount) > parseInt(this.ProjectQuotaCount))) {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถบันทึกโควต้าข้อมูลหน่วยงานได้เนื่องจากเกินจำนวนผู้เข้าร่วมที่กำหนด'
          })
        } else {
          if (parseInt(this.DepQuotaCount) > 0) {
            CheckMatch = this.DepQuotaData.filter(item => item.dep_group_id == this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_group_id)
            if (CheckMatch.length > 0) {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อมูลหน่วยงาน อยู่แล้วไม่สามารถบันทึกข้อมูลหน่วยงานเพิ่มได้อีก'
              })
            } else {
              var type = ''
              if (this.ChooseTypeDep == '0') {
                type = 'หน่วยงาน/ภาควิชา'
              } else {
                type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
              }
              this.DepQuotaData.push({
                quotaType: this.ChooseTypeDep,
                type: type,
                type_id: this.ChooseTypeDep,
                dep_name: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_name,
                dep_id: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_id,
                dep_group_id: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_group_id,
                count: this.DepQuotaCount
              })

              this.ProjectQuotaDepCount += parseInt(this.DepQuotaCount)
              this.DepQuotaSelect = ''
              this.DepQuotaCount = ''
            }
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'กรุณาระบุจำนวนผู้เข้าร่วมอย่างน้อย 1 คน'
            })
          }
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลหน่วยงาน และจำนวนผู้เข้าร่วมให้ครบถ้วน'
        })
      }
    },
    RemoveQuotaDep() {
      if (this.DepQuotaData.length > 0) {
        this.DepQuotaData = []
      }
      this.ProjectQuotaDepCount = 0
    },
    RemoveJoinProject() {
      if (this.JoinPerson.length > 0) {
        this.JoinPerson = []
      }
    },
    UniqueArraybyId(collection, keyname) {
      var output = [],
          keys = [];

      collection.map((item) => {
        var key = item[keyname];
        if (keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(item);
        }
      });
      return output;
    },
    CheckPlace() {
      if (this.PLACE == '2') {
        this.Country_id = ''
      } else if (this.PLACE == '3') {
        this.Province_id = ''
      }
    },
    CheckKeyPress(event) {
      if (event.key == "Enter") {
        console.log('here')
      }
    },
    ExecForm() {
      console.log(this.editorDataGenerate)
      if (this.ChooseForm == 'OldForm') {
        this.editorData = this.editorDataFormDB.replaceAll('&quot;', '"')
      } else {
        this.getFormGenerate()
      }
    },
    ShowDetailLecturer(item) {
      this.LecturerDetail = []
      this.LecturerDetail = this.WorkGroupData.filter(L_item => L_item.perid == item.Perid && L_item.type == item.Committee_code)
      this.dialogLecturerDetail = true
    },
    onProgress(evt) {
      console.log(evt)
      this.percent = 0
      this.percent = evt
    },
    hasGenerated(evt) {
      console.log(evt)
    },
    hasStartedGeneration(evt) {
      console.log(evt)
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
    ShowTemplate() {
      // this.dialogTemplate = true
      // this.generateReport()
      let routeData = this.$router.resolve({name: 'PrintFormProject', query: {data: this.editorData}});
      window.open(routeData.href, '_blank', 'location=yes,height=800,width=800,scrollbars=yes,status=yes');
    },
    SelProjectGroup() {
      if (this.Project_group == '108' || this.Project_group == '109') {
        this.rdoRegisterProject = '1'
        if (this.JoinPerson.length > 0) {
          this.JoinPerson.map(item => {
            item.status_reg = '1'
          })
        }
      } else {
        this.rdoRegisterProject = '0'
      }
      if (this.projectGroup.filter(item => item.Project_group == this.Project_group).length > 0) {
        this.projectGroupToShow = this.projectGroup.filter(item => item.Project_group == this.Project_group)[0].Project_group_des
      } else {
        this.projectGroupToShow = ''
      }
    },
    AddWorkGuest() {
      // if (this.SubjectForLecturer != '' && this.dateSForLecturer != ''
      //     && this.dateSTravelForLecturer != '' && this.dateETravelForLecturer != ''
      //     && this.dateEForLecturer != '' && this.timeSForLecturer != ''
      //     && this.timeEForLecturer != '') {
      if (this.SubjectForLecturer != '' && this.dateSForLecturer != ''
          && this.dateEForLecturer != '') {
        this.Lecturer.push({
          id: this.Lecturer.length,
          perid: this.perid,
          subject: this.SubjectForLecturer,
          date_start: this.dateSForLecturer,
          date_end: this.dateEForLecturer,
          time_start: this.timeSForLecturer,
          time_end: this.timeEForLecturer,
          full_Name: this.staffData.filter(item => item.perid == this.perid)[0].full_Name,
          date_travel_start: this.dateSTravelForLecturer,
          date_travel_end: this.dateETravelForLecturer,
          type: this.Committee_code,
          type_name: this.committee_Posi.filter(item => item.Committee_code == this.Committee_code)[0].committee_des,
          files: this.FileProjectExpert,
          Rm: this.Rm2
        })
        this.SubjectForLecturer = ''
        this.dateSTravelForLecturer = ''
        this.dateETravelForLecturer = ''
        this.dateSForLecturer = ''
        this.dateEForLecturer = ''
        this.timeSForLecturer = ''
        this.timeEForLecturer = ''
        this.FileProjectExpert = []
        this.filesExpert = []
        this.txtAlertExpert = []
        this.Rm2 = ''
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลให้ครบถ้วน'
        })
      }
    },
    DocumentExec() {
      this.formprint1 = this.editorData
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.docx'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
    },
    PrintForm() {
      axios.post('http://localhost:3006/exec/docx', {
        data: {
          val1: this.formprint1, // หลักการและเหตุผล
          val2: this.formprint2, // วัตถุประสงค์
          val3: this.formprint3, // กลุ่มเป้าหมาย
          val4: this.formprint4, // วิธีการจัดอบรม
          val5: this.formprint5, // ระยะเวลาการจัดอบรม
          val6: this.formprint6, // สถานที่จัดอบรม
          val7: this.formprint7, // ผลที่คาดว่าจะได้รับ
          val8: this.formprint8, // ผู้รับผิดชอบโครงการ
          val9: this.formprint9, // ผู้รับผิดชอบโครงการ
          val10: this.formprint10, // วิทยากร
          val11: this.formprint11, // งบประมาณ
          val12: this.formprint12, // หมายเหตุ
          budget: this.budgetData,
          Lecturer: this.LecturerToShow,
          Committee: this.Committee_ToShow,
          projectGroup: this.projectGroupToShow,
          projectname: this.Project_name,
          projectcode: '01010-0220-1541'
        }
      }).then((res) => {
        console.log(res.data)
      })
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.pdf'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
      // this.$htmlToPaper('printForm');
      // this.MangeTextForPrint({
      //     process: 'SET',
      //     message: this.editorData
      // }).then(res => {
      //     if (res) {
      //         // console.log(this.textForPrint)
      //         this.$router.push({name: 'PrintFormProject'});
      //         // window.open(routeData.href, '_blank');
      //         // console.log('------------------------------------')
      //         // console.log(this.textForPrint)
      //
      //     }
      // })
    },
    // onReady(editor) {
    //   // Insert the toolbar before the editable area.
    //   // editor.ui.getEditableElement().parentElement.insertBefore(
    //   //     editor.ui.view.toolbar.element,
    //   //     editor.ui.getEditableElement()
    //   // );
    // },
    save() {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data saved'
    },
    cancel() {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    open() {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    close() {
      console.log('Dialog closed')
    },
    AddExpenseData() {
      if (this.BudgetRequest != '') {
        if (this.expenseCost == '' && this.ReqMoney == '') {
          this.$swal.fire({
            icon: 'error',
            title: 'กรุณาระบุรายการค่าใช้จ่าย และ จำนวนเงิน ให้ครบถ้วน'
          })
        } else {
          if ((this.Expense + parseInt(this.ReqMoney)) > parseInt(this.BudgetRequest)) {
            this.$swal.fire({
              icon: 'error',
              title: 'กรุณาระบุค่าใช้จ่าย ห้ามเกินงบประมาณที่ขอในการจัดทำแผน'
            })
          } else {
            this.Expense += parseInt(this.ReqMoney)
            var ResultExpenseData = this.expense_Data.filter(item => item.Expense_id == this.expenseCost)
            if (ResultExpenseData.length > 0) {
              this.budgetData.push({
                Expense_id: ResultExpenseData[0].Expense_id,
                Expense_des: ResultExpenseData[0].Expense_des,
                ReqMoney: this.ReqMoney,
                Rm: this.Rm,
              })

              this.expenseCost = ''
              this.ReqMoney = ''
              this.Rm = ''
            }
          }
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุงบประมาณ'
        })
      }
    },
    DelExpense(item) {
      this.budgetData.map((bud_I, idx) => {
        if (bud_I.Expense_id == item.Expense_id) {
          this.Expense -= parseInt(item.ReqMoney)
          this.budgetData.splice(idx, 1)
        }
      })
    },
    ShowDetail(item) {
      this.dialogDetail = true
      this.itemToShow = null
      this.itemToShow = item
    },
    onResize() {
      this.isMobile = window.innerWidth < 600
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        this.ChooseEmpolyee_s()
      }
    },
    insertPersonUni() {
      this.personalMedData.map(value => {
        if (this.IdPersonal == value.STAFF_ID) {
          this.JoinPerson.push({
            ...value,
            uid: value.STAFF_ID,
            full_Name: value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI,
            name: value.STAFF_NAME_THAI,
            sname: value.STAFF_SNAME_THAI,
            idCard: value.STAFF_PERS_ID,
            affiliation: value.FAC_NAME_THAI,
            position: '',
            phone: '',
            registerType_id: 2,
          })
          this.IdPersonal = ''
        }
      })
    },
    insertStd(msg) {
      if (msg == 'med') {
        this.studentData.map(value => {
          if (this.Idstudent == value.STUDENT_ID) {
            this.JoinPerson.push({
              ...value,
              uid: value.STUDENT_ID,
              full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
              name: value.STUD_NAME_THAI,
              sname: value.STUD_SNAME_THAI,
              idCard: value.CITIZEN_ID,
              affiliation: 'คณะแพทยศาสตร์',
              position: '',
              phone: '',
              registerType_id: 1,
            })
            this.Idstudent = ''
          }
        })
      } else {
        this.studentUniData.map(value => {
          if (this.IdstudentUni == value.STUDENT_ID) {
            this.JoinPerson.push({
              ...value,
              uid: value.STUDENT_ID,
              full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
              name: value.STUD_NAME_THAI,
              sname: value.STUD_SNAME_THAI,
              idCard: value.CITIZEN_ID,
              affiliation: value.FAC_NAME_THAI,
              position: '',
              phone: '',
              registerType_id: 3,
            })
            this.IdstudentUni = ''
          }
        })
      }
    },
    Del_item(item) {
      this.JoinPerson = this.JoinPerson.filter(value => value.uid != item.uid)
    },
    GetStdPSU() {
      this.studentUniData = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT2_view/FAC_ID/' + this.IdDepartStd + '/?sort=STUDENT_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentUniData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentUniData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentUniData = []
        }
      })
    },
    GetPersonalPSU() {
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrstd/V_STAFF/FAC_ID/' + this.IdDepart + '/?sort=STAFF_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.personalMedData.push({
                ...item,
                FULL_NAME: item.STAFF_NAME_THAI + ' ' + item.STAFF_SNAME_THAI
              })
            })
          } else {
            this.personalMedData.push(res.data)
          }
        } else {
          this.personalMedData = []
        }
      })
    },
    ChooseEmp(item) {
      if (!item.switch) {
        item.switch = true
        if (item.header) {
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              if (item.switch) {
                child_i.switch = true
              } else {
                child_i.switch = false
              }
              this.EmpData.push(child_i)
            })
          }
        } else {
          this.EmpData.push(item)

        }
      } else {
        item.switch = false
        if (item.header) {
          this.EmpData = []
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              child_i.switch = false
            })
          }
        } else {
          if (this.EmpData.length > 0) {
            this.EmpData.map((Emp_i, idx) => {
              if (Emp_i.perid == item.perid) {
                this.EmpData.splice(idx, 1)
              }
            })
          }
        }
      }
    },
    ChooseEmpolyee_c(event) {
      var GetData = []
      if (event.key == "Enter") {
        GetData = this.CardData.filter(value => value.CARD_NO == this.cardSel)
        if (GetData.length > 0) {
          GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
          this.JoinPerson.push({
            ...GetData[0],
            uid: GetData[0].perid,
            name: GetData[0].name,
            sname: GetData[0].surname,
            idCard: GetData[0].citizen_id,
            affiliation: GetData[0].dep_name,
            position: '',
            phone: '',
            registerType_id: 0,
          })
          this.cardSel = ''
        }
      }
    },
    ChooseEmpolyee_s() {
      var CheckDupe = false
      var CheckDepMatch = false
      // var CheckQuotaProject = false
      var CheckGroupExample = []
      if (!this.ChkJoinPerson && this.JoinPerson.length >= parseInt(this.ProjectQuotaCount)) {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่กำหนด'
        })
      } else {
        this.staffData.map((staff_I) => {
          if (staff_I.perid == this.staffSel) {
            if (this.DataCondi.length > 0) {
              CheckGroupExample = this.DataCondi.filter(item => item.PosCode == staff_I.pos_id && this.getAge(new Date(staff_I.date_in), new Date())[0] >= item.workAgeStart && this.getAge(new Date(staff_I.date_in), new Date())[0] <= item.workAgeEnd)

              if (CheckGroupExample.length > 0) {
                if (this.DepQuotaData.length > 0) {
                  this.DepQuotaData.map((dep_quota, idx) => {
                    if (dep_quota.type_id == '0' && !CheckDepMatch) {
                      if (staff_I.dep_id == dep_quota.dep_id) {
                        CheckDepMatch = true
                        if (this.JoinPerson.length > 0) {
                          if (this.JoinPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                            if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }

                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.staffSel = ''
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                            })
                          }
                        } else {
                          if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }
                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: '',
                              phone: '',
                              registerType_id: 0,
                            })
                            this.staffSel = ''
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        }
                      } else {
                        if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                          if (this.ChkJoinPerson) {
                            if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.staffSel = ''
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            if ((this.JoinPerson.length + parseInt(this.ProjectQuotaDepCount)) < parseInt(this.ProjectQuotaCount)) {
                              if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }
                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.staffSel = ''
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                                })
                              }
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                              })
                            }
                          }
                        }
                      }
                    } else {
                      //// ตรงนี้ต้องเช็ค
                      if (!CheckDepMatch) {
                        var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                        if (DepGroup.length > 0) {
                          if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                            CheckDepMatch = true
                            if (this.JoinPerson.length > 0) {
                              if (this.JoinPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                                if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                  CheckDupe = true
                                }
                                if (!CheckDupe) {
                                  this.JoinPerson.unshift({
                                    ...staff_I,
                                    uid: staff_I.perid,
                                    name: staff_I.name,
                                    sname: staff_I.surname,
                                    idCard: staff_I.citizen_id,
                                    affiliation: staff_I.dep_name,
                                    status_reg: this.rdoRegisterProject,
                                    position: '',
                                    phone: '',
                                    registerType_id: 0,
                                  })
                                  this.staffSel = ''
                                } else {
                                  this.staffSel = ''
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                                  })
                                }
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                                })
                              }
                            } else {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.staffSel = ''
                            }
                          }
                        }
                      }
                    }
                  })
                } else {
                  if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.JoinPerson.unshift({
                      ...staff_I,
                      uid: staff_I.perid,
                      name: staff_I.name,
                      sname: staff_I.surname,
                      idCard: staff_I.citizen_id,
                      affiliation: staff_I.dep_name,
                      status_reg: this.rdoRegisterProject,
                      position: '',
                      phone: '',
                      registerType_id: 0,
                    })
                    this.staffSel = ''
                  } else {
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                  }
                }
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากเงื่อนไขอายุงานกลุ่มตัวอย่าง ไม่ตรงกับอายุงานของบุคลากรที่เลือก'
                })
              }
            } else if (this.DepQuotaData.length > 0) {
              this.DepQuotaData.map((dep_quota, idx) => {
                if (dep_quota.type_id == '0' && !CheckDepMatch) {
                  if (staff_I.dep_id == dep_quota.dep_id) {
                    CheckDepMatch = true
                    if (this.JoinPerson.length > 0) {
                      if (this.JoinPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                        if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                          CheckDupe = true
                        }

                        if (!CheckDupe) {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: '',
                            phone: '',
                            registerType_id: 0,
                          })
                          this.staffSel = ''
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                          })
                        }
                      } else {
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                        })
                      }
                    } else {
                      if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                        CheckDupe = true
                      }
                      if (!CheckDupe) {
                        this.JoinPerson.unshift({
                          ...staff_I,
                          uid: staff_I.perid,
                          name: staff_I.name,
                          sname: staff_I.surname,
                          idCard: staff_I.citizen_id,
                          affiliation: staff_I.dep_name,
                          status_reg: this.rdoRegisterProject,
                          position: '',
                          phone: '',
                          registerType_id: 0,
                        })
                        this.staffSel = ''
                      } else {
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                        })
                      }
                    }
                  } else {
                    if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                      if (this.ChkJoinPerson) {
                        if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                          CheckDupe = true
                        }
                        if (!CheckDupe) {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: '',
                            phone: '',
                            registerType_id: 0,
                          })
                          this.staffSel = ''
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                          })
                        }
                      } else {
                        if ((this.JoinPerson.length + parseInt(this.ProjectQuotaDepCount)) < parseInt(this.ProjectQuotaCount)) {
                          if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }
                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: '',
                              phone: '',
                              registerType_id: 0,
                            })
                            this.staffSel = ''
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                          })
                        }
                      }
                    }
                  }
                } else {
                  //// ตรงนี้ต้องเช็ค
                  if (!CheckDepMatch) {
                    var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                    if (DepGroup.length > 0) {
                      if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                        CheckDepMatch = true
                        if (this.JoinPerson.length > 0) {
                          if (this.JoinPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                            if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.staffSel = ''
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                            })
                          }
                        } else {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: '',
                            phone: '',
                            registerType_id: 0,
                          })
                          this.staffSel = ''
                        }
                      }
                    }
                  }
                }
              })
            } else {
              if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.JoinPerson.unshift({
                  ...staff_I,
                  uid: staff_I.perid,
                  name: staff_I.name,
                  sname: staff_I.surname,
                  idCard: staff_I.citizen_id,
                  affiliation: staff_I.dep_name,
                  status_reg: this.rdoRegisterProject,
                  position: '',
                  phone: '',
                  registerType_id: 0,
                })
                this.staffSel = ''
              } else {
                this.staffSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }
            }
          }
        })
      }
    },
    ChooseEmpolyee() {
      this.items = []
      this.AutoMateitems()
    },
    AutoMateitems() {
      var children = []
      if (this.depart.length > 0) {
        this.depart.map((depart_i) => {
          if (depart_i.dep_id == this.departSel) {
            if (this.staffData.length > 0) {
              this.staffData.map((staff_i, idx) => {
                if (staff_i.dep_id == this.departSel) {
                  children.push(
                      {
                        ...staff_i,
                        header: false,
                        switch: false,
                        id: parseInt(idx + 1),
                        name: staff_i.full_Name
                      })
                }
              })
            }
            children.sort((a, b) => {
              return a.perid > b.perid ? 1 : -1
            })
            this.items = [{
              id: 1,
              name: depart_i.dep_name,
              header: true,
              switch: false,
              children,
            }]
          }
        })
      }
    },
    insertDataPerson(type) {
      if (type == 'person') {
        this.JoinPerson.push({
          uid: 'P_' + this.JoinPerson.length,
          full_Name: this.NameP + ' ' + this.SurNameP,
          name: this.NameP,
          sname: this.SurNameP,
          idCard: this.idCard,
          affiliation: this.affiliation,
          position: this.position,
          phone: '',
          registerType_id: 4,
        })
        this.NameP = ''
        this.SurNameP = ''
        this.idCard = ''
        this.affiliation = ''
        this.position = ''
      } else {
        this.JoinPerson.push({
          uid: 'S_' + this.JoinPerson.length,
          full_Name: this.NameStd + ' ' + this.SurNameStd,
          name: this.NameStd,
          sname: this.SurNameStd,
          idCard: this.idCardStd,
          affiliation: this.affiliationStd,
          position: '',
          phone: '',
          registerType_id: 5,
        })
        this.NameStd = ''
        this.SurNameStd = ''
        this.idCardStd = ''
        this.affiliationStd = ''
      }
    },
    SaveToTable() {
      // this.EmpData.map((item) => {
      //   this.JoinPerson.push({
      //     ...item,
      //     uid: item.perid,
      //     name: item.name,
      //     sname: item.surname,
      //     idCard: item.citizen_id,
      //     affiliation: item.dep_name,
      //     position: '',
      //     phone: '',
      //     registerType_id: 0,
      //   })
      // })
      // this.EmpData = []
      // this.items = []
      // this.departSel = ''
      var CheckDupe = false
      var CheckDepMatch = false
      var CheckGroupExample = []
      this.ShowAlertSuc = false
      this.ShowAlertErr = false
      this.MessageSuc = ''
      this.MessageError = ''

      if (this.ChkJoinPerson && this.JoinPerson.length >= parseInt(this.ProjectQuotaCount)) {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่กำหนด'
        })
      } else {
        this.EmpData.map((item, EmpIdx) => {
          CheckDupe = false
          CheckDepMatch = false
          CheckGroupExample = []
          this.staffData.map((staff_I) => {
            if (staff_I.perid == item.perid) {
              if (this.DataCondi.length > 0) {
                CheckGroupExample = this.DataCondi.filter(item => item.PosCode == staff_I.pos_id && this.getAge(new Date(staff_I.date_in), new Date())[0] >= item.workAgeStart && this.getAge(new Date(staff_I.date_in), new Date())[0] <= item.workAgeEnd)

                if (CheckGroupExample.length > 0) {
                  if (this.DepQuotaData.length > 0) {
                    this.DepQuotaData.map((dep_quota, idx) => {
                      if (dep_quota.type_id == '0' && !CheckDepMatch) {
                        if (staff_I.dep_id == dep_quota.dep_id) {
                          CheckDepMatch = true
                          if (this.JoinPerson.length > 0) {
                            if (this.JoinPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                              if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }

                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                this.ShowAlertSuc = true
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                this.ShowAlertErr = true
                              }
                            } else {
                              this.MessageError += '<p style="font-weight: bold;color: chocolate">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                              this.ShowAlertErr = true
                            }
                          } else {
                            if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                              this.ShowAlertSuc = true
                            } else {
                              this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                              this.ShowAlertErr = true
                            }
                          }
                        } else {
                          if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                            if (this.ChkJoinPerson) {
                              if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }
                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                this.ShowAlertSuc = true
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                this.ShowAlertErr = true
                              }
                            } else {
                              if ((this.JoinPerson.length + parseInt(this.ProjectQuotaDepCount)) < parseInt(this.ProjectQuotaCount)) {
                                if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                  CheckDupe = true
                                }
                                if (!CheckDupe) {
                                  this.JoinPerson.unshift({
                                    ...staff_I,
                                    uid: staff_I.perid,
                                    name: staff_I.name,
                                    sname: staff_I.surname,
                                    idCard: staff_I.citizen_id,
                                    affiliation: staff_I.dep_name,
                                    status_reg: this.rdoRegisterProject,
                                    position: '',
                                    phone: '',
                                    registerType_id: 0,
                                  })
                                  this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                  this.ShowAlertSuc = true
                                } else {
                                  this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                  this.ShowAlertErr = true
                                }
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: blueviolet">' + item.full_Name + ' หมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข !!</p>'
                                this.ShowAlertErr = true
                              }
                            }
                          }
                        }
                      } else {
                        //// ตรงนี้ต้องเช็ค
                        if (!CheckDepMatch) {
                          var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                          if (DepGroup.length > 0) {
                            if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                              CheckDepMatch = true
                              if (this.JoinPerson.length > 0) {
                                if (this.JoinPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                                  if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                    CheckDupe = true
                                  }
                                  if (!CheckDupe) {
                                    this.JoinPerson.unshift({
                                      ...staff_I,
                                      uid: staff_I.perid,
                                      name: staff_I.name,
                                      sname: staff_I.surname,
                                      idCard: staff_I.citizen_id,
                                      affiliation: staff_I.dep_name,
                                      status_reg: this.rdoRegisterProject,
                                      position: '',
                                      phone: '',
                                      registerType_id: 0,
                                    })
                                    this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                    this.ShowAlertSuc = true
                                  } else {
                                    this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                    this.ShowAlertErr = true
                                  }
                                } else {
                                  this.MessageError += '<p style="font-weight: bold;color: chocolate"">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                                  this.ShowAlertErr = true
                                }
                              } else {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                this.ShowAlertSuc = true
                              }
                            }
                          }
                        }
                      }
                    })
                  } else {
                    if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                      CheckDupe = true
                    }
                    if (!CheckDupe) {
                      this.JoinPerson.unshift({
                        ...staff_I,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        idCard: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        status_reg: this.rdoRegisterProject,
                        position: '',
                        phone: '',
                        registerType_id: 0,
                      })
                      this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                      this.ShowAlertSuc = true
                    } else {
                      this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                      this.ShowAlertErr = true
                    }
                  }
                } else {
                  this.MessageError += '<p style="font-weight: bold;color: darkcyan">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ เงื่อนไขอายุงานกลุ่มตัวอย่าง ไม่ตรงกับอายุงานของบุคลากรที่เลือก</p>'
                  this.ShowAlertErr = true
                }
              } else if (this.DepQuotaData.length > 0) {
                this.DepQuotaData.map((dep_quota, idx) => {
                  if (dep_quota.type_id == '0' && !CheckDepMatch) {
                    if (staff_I.dep_id == dep_quota.dep_id) {
                      CheckDepMatch = true
                      if (this.JoinPerson.length > 0) {
                        if (this.JoinPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                          if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }

                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: '',
                              phone: '',
                              registerType_id: 0,
                            })
                            this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                            this.ShowAlertSuc = true
                          } else {
                            this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                            this.ShowAlertErr = true
                          }
                        } else {
                          this.MessageError += '<p style="font-weight: bold;color: chocolate"">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                          this.ShowAlertErr = true
                        }
                      } else {
                        if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                          CheckDupe = true
                        }
                        if (!CheckDupe) {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: '',
                            phone: '',
                            registerType_id: 0,
                          })
                          this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                          this.ShowAlertSuc = true
                        } else {
                          this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                          this.ShowAlertErr = true
                        }
                      }
                    } else {
                      if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                        if (this.ChkJoinPerson) {
                          if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }
                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: '',
                              phone: '',
                              registerType_id: 0,
                            })
                            this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                            this.ShowAlertSuc = true
                          } else {
                            this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                            this.ShowAlertErr = true
                          }
                        } else {
                          if ((this.JoinPerson.length + parseInt(this.ProjectQuotaDepCount)) < parseInt(this.ProjectQuotaCount)) {
                            if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                              this.ShowAlertSuc = true
                            } else {
                              this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                              this.ShowAlertErr = true
                            }
                          } else {
                            this.MessageError += '<p style="font-weight: bold;color: blueviolet">' + item.full_Name + ' หมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข !!</p>'
                            this.ShowAlertErr = true
                          }
                        }
                      }
                    }
                  } else {
                    //// ตรงนี้ต้องเช็ค
                    if (!CheckDepMatch) {
                      var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                      if (DepGroup.length > 0) {
                        if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                          CheckDepMatch = true
                          if (this.JoinPerson.length > 0) {
                            if (this.JoinPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                              if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }
                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                this.ShowAlertSuc = true
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                this.ShowAlertErr = true
                              }
                            } else {
                              this.MessageError += '<p style="font-weight: bold;color: chocolate"">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                              this.ShowAlertErr = true
                            }
                          } else {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: '',
                              phone: '',
                              registerType_id: 0,
                            })
                            this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                            this.ShowAlertSuc = true
                          }
                        }
                      }
                    }
                  }
                })
              } else {
                if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.JoinPerson.unshift({
                    ...staff_I,
                    uid: staff_I.perid,
                    name: staff_I.name,
                    sname: staff_I.surname,
                    idCard: staff_I.citizen_id,
                    affiliation: staff_I.dep_name,
                    status_reg: this.rdoRegisterProject,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                  })
                  this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                  this.ShowAlertSuc = true
                } else {
                  this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                  this.ShowAlertErr = true
                }
              }
            }
          })
          if (EmpIdx == this.EmpData.length - 1) {
            this.EmpData = []
            this.items = []
            this.departSel = ''
          }
        })
      }
    },
    InsertCompetency() {
      if (this.Competency_code == '' || this.UPercent == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาตรวจสอบข้อมูลอีกครั้ง'
        })
      } else {
        if (this.competency_DataForSubmit.length > 0) {
          this.competency_DataForSubmit.map((compe_i_s) => {
            if (compe_i_s.Competency_code == this.Competency_code) {
              this.$swal.fire({
                icon: 'error',
                title: 'มี Competency นี้อยู่แล้ว !! ไม่สามารถเพิ่มข้อมูลได้อีก'
              })
            } else {
              this.Competency_Data.map((compe_i) => {
                if (compe_i.Competency_code == this.Competency_code) {
                  this.competency_DataForSubmit.push({
                    Project_code: this.Project_code,
                    Competency_code: this.Competency_code,
                    Competency_des: compe_i.Competency_des,
                    UPercent: this.UPercent,
                  })
                }
              })
            }
          })
        } else {
          this.Competency_Data.map((compe_i) => {
            if (compe_i.Competency_code == this.Competency_code) {
              this.competency_DataForSubmit.push({
                Project_code: this.Project_code,
                Competency_code: this.Competency_code,
                Competency_des: compe_i.Competency_des,
                UPercent: this.UPercent,
              })
            }
          })
        }
      }
      this.Competency_code = ''
      this.UPercent = ''
    },
    AddExpense() {
      var CheckDupe = false
      var CheckDupeExpense = false
      var CheckDep = false
      if (this.radioGroup2 == '0') {
        if (this.moneyCost == '' || this.expenseCost == '') {
          this.$swal.fire({
            icon: 'error',
            title: 'กรุณาตรวจสอบข้อมูลอีกครั้ง'
          })
        } else {
          if (this.expense_p_DataForSubmit.length > 0) {
            this.expense_p_DataForSubmit.map((item) => {
              item.Expense_data.map((item_expense) => {
                if (item_expense.Expense_id == this.expenseCost) {
                  CheckDupe = true
                }
              });
            })
          }
          if (CheckDupe) {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีรหัสค่าเบิก/จ่ายหมายเลขที่เลือกอยู่แล้ว'
            })
          } else {
            if (this.expense_p_DataForSubmit.length > 0) {
              this.expense_p_DataForSubmit.map((item) => {
                CheckDep = false
                this.depart.map((dep_i) => {
                  if (dep_i.dep_id == this.DepCost) {
                    this.expense_Data.map((expense_i) => {
                      if (expense_i.Expense_id == this.expenseCost) {
                        item.Expense_data.push({
                          Dep_Cost: this.DepCost,
                          Dep_Cost_Name: dep_i.dep_name,
                          Expense_id: this.expenseCost,
                          Expense_des: expense_i.Expense_des,
                          ReqMoney: this.moneyCost
                        })
                        item.SumCost += parseInt(this.moneyCost)
                        this.expenseCostSum += parseInt(this.moneyCost)
                      }
                    })
                    CheckDep = true
                  }
                })
                if (!CheckDep) {
                  this.expense_Data.map((expense_i) => {
                    if (expense_i.Expense_id == this.expenseCost) {
                      item.Expense_data.push({
                        Dep_Cost: '',
                        Dep_Cost_Name: '',
                        Expense_id: this.expenseCost,
                        Expense_des: expense_i.Expense_des,
                        ReqMoney: this.moneyCost
                      })
                      item.SumCost += parseInt(this.moneyCost)
                      this.expenseCostSum += parseInt(this.moneyCost)
                    }
                  })
                }
              })
            } else {
              this.expense_p_DataForSubmit.push({
                id: this.expense_p_DataForSubmit.length + 1,
                Project_code: this.Project_code,
                SumCost: 0,
                Expense_data: []
              })
              this.expense_p_DataForSubmit.map((item) => {
                CheckDep = false
                this.depart.map((dep_i) => {
                  if (dep_i.dep_id == this.DepCost) {
                    this.expense_Data.map((expense_i) => {
                      if (expense_i.Expense_id == this.expenseCost) {
                        item.Expense_data.push({
                          Dep_Cost: this.DepCost,
                          Dep_Cost_Name: dep_i.dep_name,
                          Expense_id: this.expenseCost,
                          Expense_des: expense_i.Expense_des,
                          ReqMoney: this.moneyCost
                        })
                        item.SumCost += parseInt(this.moneyCost)
                        this.expenseCostSum += parseInt(this.moneyCost)
                      }
                    })
                    CheckDep = true
                  }
                })
                if (!CheckDep) {
                  this.expense_Data.map((expense_i) => {
                    if (expense_i.Expense_id == this.expenseCost) {
                      item.Expense_data.push({
                        Dep_Cost: '',
                        Dep_Cost_Name: '',
                        Expense_id: this.expenseCost,
                        Expense_des: expense_i.Expense_des,
                        ReqMoney: this.moneyCost
                      })
                      item.SumCost += parseInt(this.moneyCost)
                      this.expenseCostSum += parseInt(this.moneyCost)
                    }
                  })
                }
              })
            }
          }
          this.peridCost = ''
          this.moneyCost = ''
          this.expenseCost = ''
        }
      } else {
        if (this.peridCost == '' || this.moneyCost == '' || this.expenseCost == '') {
          this.$swal.fire({
            icon: 'error',
            title: 'กรุณาตรวจสอบข้อมูลอีกครั้ง'
          })
        } else {
          if (this.expense_DataForSubmit.length > 0) {
            this.expense_DataForSubmit.map((item) => {
              if (item.PERID == this.peridCost) {
                CheckDupe = true
                this.expense_p_DataForSubmit.map((item) => {
                  item.Expense_data.map((item_expense) => {
                    if (item_expense.Expense_id == this.expenseCost) {
                      CheckDupeExpense = true
                    }
                  });
                })
              }
            })
          }
          if (CheckDupe) {
            if (CheckDupeExpense) {
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีรหัสค่าเบิก/จ่ายหมายเลขที่เลือกอยู่แล้ว'
              })
            } else {
              if (this.expense_DataForSubmit.length > 0) {
                this.expense_DataForSubmit.map((item) => {
                  if (item.PERID == this.peridCost) {
                    CheckDep = false
                    this.depart.map((dep_i) => {
                      if (dep_i.dep_id == this.DepCost) {
                        this.expense_Data.map((expense_i) => {
                          if (expense_i.Expense_id == this.expenseCost) {
                            item.Expense_data.push({
                              Dep_Cost: this.DepCost,
                              Dep_Cost_Name: dep_i.dep_name,
                              Expense_id: this.expenseCost,
                              Expense_des: expense_i.Expense_des,
                              ReqMoney: this.moneyCost
                            })
                            item.SumCost += parseInt(this.moneyCost)
                            this.expenseCostSum += parseInt(this.moneyCost)
                          }
                        })
                        CheckDep = true
                      }
                    })
                    if (!CheckDep) {
                      this.expense_Data.map((expense_i) => {
                        if (expense_i.Expense_id == this.expenseCost) {
                          item.Expense_data.push({
                            Dep_Cost: '',
                            Dep_Cost_Name: '',
                            Expense_id: this.expenseCost,
                            Expense_des: expense_i.Expense_des,
                            ReqMoney: this.moneyCost
                          })
                          item.SumCost += parseInt(this.moneyCost)
                          this.expenseCostSum += parseInt(this.moneyCost)
                        }
                      })
                    }
                  }
                })
              }
            }
          } else {
            this.staffData.map((staff_i) => {
              if (staff_i.perid == this.peridCost) {
                this.expense_DataForSubmit.push({
                  id: this.expense_DataForSubmit.length + 1,
                  PERID: this.peridCost,
                  full_Name: staff_i.full_Name,
                  Dep_Code: this.dep_id,
                  Dep_name: staff_i.dep_name,
                  Project_code: this.Project_code,
                  SumCost: 0,
                  Expense_data: []
                })
              }
            })
            if (this.expense_DataForSubmit.length > 0) {
              this.expense_DataForSubmit.map((item) => {
                if (item.PERID == this.peridCost) {
                  CheckDep = false
                  this.depart.map((dep_i) => {
                    if (dep_i.dep_id == this.DepCost) {
                      this.expense_Data.map((expense_i) => {
                        if (expense_i.Expense_id == this.expenseCost) {
                          item.Expense_data.push({
                            Dep_Cost: this.DepCost,
                            Dep_Cost_Name: dep_i.dep_name,
                            Expense_id: this.expenseCost,
                            Expense_des: expense_i.Expense_des,
                            ReqMoney: this.moneyCost
                          })
                          item.SumCost += parseInt(this.moneyCost)
                          this.expenseCostSum += parseInt(this.moneyCost)
                        }
                      })
                      CheckDep = true
                    }
                  })
                  if (!CheckDep) {
                    this.expense_Data.map((expense_i) => {
                      if (expense_i.Expense_id == this.expenseCost) {
                        item.Expense_data.push({
                          Dep_Cost: '',
                          Dep_Cost_Name: '',
                          Expense_id: this.expenseCost,
                          Expense_des: expense_i.Expense_des,
                          ReqMoney: this.moneyCost
                        })
                        item.SumCost += parseInt(this.moneyCost)
                        this.expenseCostSum += parseInt(this.moneyCost)
                      }
                    })
                  }
                }
              })
            }
          }
          this.peridCost = ''
          this.moneyCost = ''
          this.expenseCost = ''
        }
      }
    },
    onInput(val) {
      this.steps = parseInt(val)
    },
    backStep(n) {
      this.e1 = n
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1
      } else {
        this.e1 = n + 1
        if (this.e1 == 2) {
          if (this.Project_name == '' || this.Project_group == '' || this.PLACE == ''
              || this.WorkBy == ''
              || this.DateStart == '' || this.DateEnd == '' || this.BudgetRequest == ''
              || this.CalCredit == '' || this.CalHourse == '') {
            this.CheckStep1 = false
          } else {
            if (this.PLACE == '2' && this.Province_id == '') {
              this.CheckStep1 = false
            } else if (this.PLACE == '3' && this.Country_id == '') {
              this.CheckStep1 = false
            } else {
              this.CheckStep1 = true
            }
          }
        }
      }

      if (this.e1 == 6) {
        var GroupExample = ''
        var committeeTxt = ''
        var lecturerTxt = ''
        var budgetTxt = ''
        if (this.Committee_ToShow.length > 0) {
          this.Committee_ToShow.map((item, idx) => {
            committeeTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.Committee_des + '</span></p>'
          })
        }
        if (this.DataCondi.length > 0) {
          this.DataCondi.map((item, idx) => {
            if (item.workAgeStart != item.workAgeEnd) {
              GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeEnd + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'
            } else {
              GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'

            }
          })
        }
        if (this.LecturerToShow.length > 0) {
          this.LecturerToShow.map((item, idx) => {
            if (item.Perid != '') {
              if (this.levelData.filter(lv_i => lv_i.LevelCode == item.pos_lv).length > 0) {
                lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.pos_name + this.levelData.filter(lv_i => lv_i.LevelCode == item.pos_lv)[0].LevelName + '</span></p>'
              } else {
                lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '</span></p>'
              }
            } else {
              lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '</span></p>'
            }
          })
        }
        if (this.budgetData.length > 0) {
          this.budgetData.map((item, idx) => {
            if (item.Rm != '') {
              budgetTxt += '<p class="custom-block-indent-a"  style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Expense_des + '(' + item.Rm + ') &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  = &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.ReqMoney + '  บาท</span></p>'
            } else {
              budgetTxt += '<p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Expense_des + ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.ReqMoney + '  บาท</span></p>'
            }
            if (idx == this.budgetData.length - 1) {
              budgetTxt += '<p class="custom-block-indent-a"  style="margin-left:150px;"><span style="font-family:THSarabunNew;">' + ' รวม &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + this.Expense + '  บาท</span></p>'
            }
          })
        }
        if (this.DateStart == '' || this.DateEnd == '') {
          this.editorDataGenerate = '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' + this.projectGroupToShow + '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' + this.Project_name + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + GroupExample + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + this.Location + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' + committeeTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' + lecturerTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' + budgetTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>'
        } else {
          this.editorDataGenerate = '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' + this.projectGroupToShow + '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' + this.Project_name + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + GroupExample + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">วันที่ &nbsp;&nbsp;&nbsp;&nbsp;' + Vue.filter('DateToThai')(this.DateStart) + '&nbsp;&nbsp;&nbsp;&nbsp;ถึง&nbsp;&nbsp;&nbsp;&nbsp;' + Vue.filter('DateToThai')(this.DateEnd) + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + this.Location + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' + committeeTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' + lecturerTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' + budgetTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>'
        }
      }
    },
    getFormGenerate() {
      var GroupExample = ''
      var committeeTxt = ''
      var lecturerTxt = ''
      var budgetTxt = ''
      if (this.Committee_ToShow.length > 0) {
        this.Committee_ToShow.map((item, idx) => {
          committeeTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.Committee_des + '</span></p>'
        })
      }
      if (this.DataCondi.length > 0) {
        this.DataCondi.map((item, idx) => {
          if (item.workAgeStart != item.workAgeEnd) {
            GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeEnd + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'
          } else {
            GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'

          }
        })
      }
      if (this.LecturerToShow.length > 0) {
        this.LecturerToShow.map((item, idx) => {
          if (item.Perid != '') {
            if (this.levelData.filter(lv_i => lv_i.LevelCode == item.pos_lv).length > 0) {
              lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.pos_name + this.levelData.filter(lv_i => lv_i.LevelCode == item.pos_lv)[0].LevelName + '</span></p>'
            } else {
              lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '</span></p>'
            }
          } else {
            lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '</span></p>'
          }
        })
      }
      if (this.budgetData.length > 0) {
        this.budgetData.map((item, idx) => {
          if (item.Rm != '') {
            budgetTxt += '<p class="custom-block-indent-a"  style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Expense_des + '(' + item.Rm + ') &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  = &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.ReqMoney + '  บาท</span></p>'
          } else {
            budgetTxt += '<p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Expense_des + ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.ReqMoney + '  บาท</span></p>'
          }
          if (idx == this.budgetData.length - 1) {
            budgetTxt += '<p class="custom-block-indent-a"  style="margin-left:150px;"><span style="font-family:THSarabunNew;">' + ' รวม &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + this.Expense + '  บาท</span></p>'
          }
        })
      }
      if (this.DateStart == '' || this.DateEnd == '') {
        this.editorDataGenerate = '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' + this.projectGroupToShow + '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' + this.Project_name + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + GroupExample + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + this.Location + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' + committeeTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' + lecturerTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' + budgetTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>'
      } else {
        this.editorDataGenerate = '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' + this.projectGroupToShow + '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' + this.Project_name + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + GroupExample + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">วันที่ &nbsp;&nbsp;&nbsp;&nbsp;' + Vue.filter('DateToThai')(this.DateStart) + '&nbsp;&nbsp;&nbsp;&nbsp;ถึง&nbsp;&nbsp;&nbsp;&nbsp;' + Vue.filter('DateToThai')(this.DateEnd) + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + this.Location + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' + committeeTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' + lecturerTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' + budgetTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>'
      }
      this.editorData = this.editorDataGenerate
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );

    },
    DeleteFile(file_i) {
      const headerAxiosDel = {
        headers: {
          'Content-Type': 'application/json',
          // 'X-REST-METHOD': 'DELETE'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/id/' + file_i.id, {
        active: '0',
        Update_By: this.MeData[0].perid
      }, headerAxiosDel).then(res => {
        if (res.data.status) {
          if (this.FileProject.length > 0) {
            this.FileProject.map((item, idx) => {
              if (item.name == file_i.name) {
                this.FileProject.splice(idx, 1)
              }
            })
          }
        }
      })
    },
    FileSelect: function () {
      // var count = 0
      this.txtAlert = []
      // this.FileProject = []
      this.alert = false
      if (this.files.length > 0) {
        this.files.map((item) => {
          var Checkfile = false;
          switch (item.type) {
              // case 'image/jpg':
              // case 'image/jpeg':
              // case 'image/gif':
              // case 'image/bmp':
              // case 'image/png':
              //   Checkfile = true;
              //   break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 4096 * 4096) {
              this.txtAlert.push({
                id: this.txtAlert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 8 mb*'
              })
            } else {
              const fd = new FormData()
              fd.append('file', item, item.name)
              const headerAxios = {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'WithCredentials': true,
                  "Access-Control-Allow-Origin": "*"
                  // "Accept": 'multipart/form-data'
                }
              }

              axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
                if (res.data.status) {
                  switch (item.type) {
                      // case 'image/jpg':
                      // case 'image/jpeg':
                      // case 'image/gif':
                      // case 'image/bmp':
                      // case 'image/png':
                      //   this.FileProject.push({
                      //     name: item.name,
                      //     src: URL.createObjectURL(item),
                      //     path: res.data.path,
                      //     type: 'image',
                      //     type_Img: item.type
                      //   })
                      //   break
                    case 'application/pdf':
                      this.FileProject.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'pdf',
                        type_Img: item.type
                      })
                      break
                    default:
                      break
                  }

                  // count++
                  //
                  // if (count === this.files.length) {
                  //     this.FileProjectPdf = []
                  //     this.FileProject = []
                  // }
                }
              })
            }
          } else {
            this.txtAlert.push({
              id: this.txtAlert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
            this.alert = true
          }
        })
      }

      // if (this.txtAlert.length == 0) {
      //     this.files.map((item) => {
      //         const fd = new FormData()
      //         fd.append('file', item, item.name)
      //         const headerAxios = {
      //             headers: {
      //                 'Content-Type': 'multipart/form-data',
      //                 'WithCredentials': true,
      //                 "Access-Control-Allow-Origin": "*"
      //                 // "Accept": 'multipart/form-data'
      //             }
      //         }
      //
      //         axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
      //             if (res.data.status) {
      //                 switch (item.type) {
      //                     case 'image/jpg':
      //                     case 'image/jpeg':
      //                     case 'image/gif':
      //                     case 'image/bmp':
      //                     case 'image/png':
      //                         this.FileProject.push({
      //                             name: item.name,
      //                             src: URL.createObjectURL(item),
      //                             path: res.data.path,
      //                             type: 'image',
      //                             type_Img: item.type
      //                         })
      //                         break
      //                     case 'application/pdf':
      //                         this.FileProject.push({
      //                             name: item.name,
      //                             src: URL.createObjectURL(item),
      //                             path: res.data.path,
      //                             type: 'pdf',
      //                             type_Img: item.type
      //                         })
      //                         break
      //                     default:
      //                         break
      //                 }
      //
      //                 // count++
      //                 //
      //                 // if (count === this.files.length) {
      //                 //     this.FileProjectPdf = []
      //                 //     this.FileProject = []
      //                 // }
      //             }
      //         })
      //     })
      //
      // } else {
      //     this.alert = true
      // }

    },
    FileSelectExpert: function () {
      // var count = 0
      this.txtAlert = []
      this.FileProjectExpert = []
      this.alertExpert = false
      if (this.filesExpert.length > 0) {
        this.filesExpert.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/png':
              Checkfile = true;
              break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 4096 * 4096) {
              this.txtAlertExpert.push({
                id: this.txtAlertExpert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 8 mb*'
              })
            }
          } else {
            this.txtAlertExpert.push({
              id: this.txtAlertExpert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
          }
        })
      }

      if (this.txtAlertExpert.length == 0) {
        this.filesExpert.map((item) => {
          const fd = new FormData()
          fd.append('file', item, item.name)
          const headerAxios = {
            headers: {
              'Content-Type': 'multipart/form-data',
              'WithCredentials': true,
              "Access-Control-Allow-Origin": "*"
              // "Accept": 'multipart/form-data'
            }
          }

          axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
            if (res.data.status) {
              switch (item.type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.FileProjectExpert.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'image',
                    type_Img: item.type,
                    File_name: item.name,
                    File_path: res.data.path,
                    File_type: 'image',
                  })
                  break
                case 'application/pdf':
                  this.FileProjectExpert.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'pdf',
                    type_Img: item.type,
                    File_name: item.name,
                    File_path: res.data.path,
                    File_type: 'image',
                  })
                  break
                default:
                  break
              }

              // count++
              //
              // if (count === this.files.length) {
              //     this.FileProjectPdf = []
              //     this.FileProject = []
              // }
            }
          })
        })

      } else {
        this.alertExpert = true
      }
    },
    DeleteExpense_p(item) {
      this.expense_p_DataForSubmit.map((item_e, idx) => {
        if (item.id == item_e.id) {
          this.expense_p_DataForSubmit.splice(idx, 1)
        }
      })
    },
    DeleteExpense(item) {
      this.expense_DataForSubmit.map((item_e, idx) => {
        if (item.id == item_e.id) {
          this.expense_DataForSubmit.splice(idx, 1)
        }
      })
    },
    DeleteCoordinator(data) {
      this.Coordinator.map((item, idx) => {
        if (item.name == data.name) {
          this.Coordinator.splice(idx, 1)
        }
      })
      this.WorkGroupData.map((item, idx) => {
        if (item.perid == data.Perid) {
          this.WorkGroupData.splice(idx, 1)
        }
      })
    },
    UpdateName(perid) {
      this.staffData.map((item) => {
        if (item.perid == perid) {
          this.full_name = item.full_Name
        }
      })
    },
    InsertCoordinator(Condi) {
      var committ_desc = ''

      if (this.full_name != '' && this.phone != '' && this.Committee_code != '') {

        if ((this.Committee_code == '5' || this.Committee_code == '6'
            || this.Committee_code == '10' || this.Committee_code == '11'
            || this.Committee_code == '12' || this.Committee_code == '13'
            || this.Committee_code == '14') && !Condi) {
          if (this.radioGroup == '1' || this.radioGroup == '3') {
            if (this.committee_Posi.filter(commit_i => commit_i.Committee_code == this.Committee_code).length > 0) {
              committ_desc = this.committee_Posi.filter(commit_i => commit_i.Committee_code == this.Committee_code)[0].committee_des
            }

            if (this.Coordinator.length > 0) {
              if (this.radioGroup == '0') {
                var CheckCupe = false
                this.Coordinator.map((CoorItem) => {
                  if (CoorItem.Name == this.full_name && CoorItem.Committee_code == this.Committee_code) {
                    CheckCupe = true
                  }
                })
                if (CheckCupe) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อมูลรายชื่อ ' + this.full_name + ' และตำแหน่งที่เลือกในระบบอยู่แล้ว'
                  })
                } else {
                  this.staffData.map((item) => {
                    if (item.perid == this.perid) {
                      if (this.radioGroup == '0') {
                        this.Coordinator.push({
                          ...item,
                          Project_code: this.Project_code,
                          Committee_code: this.Committee_code,
                          Committee_type: this.radioGroup,
                          Committee_des: committ_desc,
                          Name: this.full_name,
                          Perid: this.perid,
                          TEL: this.phone,
                        })
                      } else {
                        this.Coordinator.push({
                          ...item,
                          Project_code: this.Project_code,
                          Committee_code: this.Committee_code,
                          Committee_type: this.radioGroup,
                          Committee_des: committ_desc,
                          Name: this.full_name,
                          Perid: '',
                          TEL: this.phone,
                        })
                      }
                    }
                  })
                  this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                  this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                  if (this.Committee_ToShow.length > 0) {
                    this.Committee_ToShow.map((Committee_i, idx) => {
                      Committee_i.index = (idx + 1)
                    })
                  }
                  if (this.LecturerToShow.length > 0) {
                    this.LecturerToShow.map((lecture_i, idx) => {
                      lecture_i.index = (idx + 1)
                    })
                  }
                  this.Committee_code = ''
                  this.perid = ''
                  this.full_name = ''
                  this.phone = ''
                }
              } else {
                this.Coordinator.push({
                  Project_code: this.Project_code,
                  Committee_code: this.Committee_code,
                  Committee_type: this.radioGroup,
                  Committee_des: committ_desc,
                  Name: this.full_name,
                  Perid: '',
                  TEL: this.phone,
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              }
            } else {
              if (this.radioGroup == '0') {
                this.staffData.map((item) => {
                  if (item.perid == this.perid) {
                    if (this.radioGroup == '0') {
                      this.Coordinator.push({
                        ...item,
                        Project_code: this.Project_code,
                        Committee_code: this.Committee_code,
                        Committee_type: this.radioGroup,
                        Committee_des: committ_desc,
                        Name: this.full_name,
                        Perid: this.perid,
                        TEL: this.phone,
                      })
                    } else {
                      this.Coordinator.push({
                        ...item,
                        Project_code: this.Project_code,
                        Committee_code: this.Committee_code,
                        Committee_type: this.radioGroup,
                        Committee_des: committ_desc,
                        Name: this.full_name,
                        Perid: '',
                        TEL: this.phone,
                      })
                    }
                  }
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                if (this.Committee_ToShow.length > 0) {
                  this.Committee_ToShow.map((Committee_i, idx) => {
                    Committee_i.index = (idx + 1)
                  })
                }
                if (this.LecturerToShow.length > 0) {
                  this.LecturerToShow.map((lecture_i, idx) => {
                    lecture_i.index = (idx + 1)
                  })
                }
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              } else {
                this.Coordinator.push({
                  Project_code: this.Project_code,
                  Committee_code: this.Committee_code,
                  Committee_type: this.radioGroup,
                  Committee_des: committ_desc,
                  Name: this.full_name,
                  Perid: '',
                  TEL: this.phone,
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              }
            }
          } else {
            this.dialogLecturer = true
          }
        } else {
          if ((this.Committee_code == '5' || this.Committee_code == '6'
              || this.Committee_code == '10' || this.Committee_code == '11'
              || this.Committee_code == '12' || this.Committee_code == '13'
              || this.Committee_code == '14') && this.Lecturer.length == 0) {
            this.$swal.fire({
              icon: 'error',
              title: 'กรุณากรอกข้อมูลการเป็นวิทยากร/คณะกรรมการ/นำเสนอผลงาน'
            })
          } else {
            this.dialogLecturer = false
            this.WorkGroupData = this.WorkGroupData.concat(this.Lecturer)
            this.SubjectForLecturer = ''
            this.dateSTravelForLecturer = ''
            this.dateETravelForLecturer = ''
            this.dateSForLecturer = ''
            this.dateEForLecturer = ''
            this.timeSForLecturer = ''
            this.timeEForLecturer = ''
            this.FileProjectExpert = []
            this.filesExpert = []
            this.txtAlertExpert = []
            this.Lecturer = []

            if (this.committee_Posi.filter(commit_i => commit_i.Committee_code == this.Committee_code).length > 0) {
              committ_desc = this.committee_Posi.filter(commit_i => commit_i.Committee_code == this.Committee_code)[0].committee_des
            }

            if (this.Coordinator.length > 0) {
              if (this.radioGroup == '0') {
                CheckCupe = false
                this.Coordinator.map((CoorItem) => {
                  if (CoorItem.Name == this.full_name && CoorItem.Committee_code == this.Committee_code) {
                    CheckCupe = true
                  }
                })
                if (CheckCupe) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อมูลรายชื่อ ' + this.full_name + ' และตำแหน่งที่เลือกในระบบอยู่แล้ว'
                  })
                } else {
                  this.staffData.map((item) => {
                    if (item.perid == this.perid) {
                      if (this.radioGroup == '0') {
                        this.Coordinator.push({
                          ...item,
                          Project_code: this.Project_code,
                          Committee_code: this.Committee_code,
                          Committee_type: this.radioGroup,
                          Committee_des: committ_desc,
                          Name: this.full_name,
                          Perid: this.perid,
                          TEL: this.phone,
                        })
                      } else {
                        this.Coordinator.push({
                          ...item,
                          Project_code: this.Project_code,
                          Committee_code: this.Committee_code,
                          Committee_type: this.radioGroup,
                          Committee_des: committ_desc,
                          Name: this.full_name,
                          Perid: '',
                          TEL: this.phone,
                        })
                      }
                    }
                  })
                  this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                  this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                  if (this.Committee_ToShow.length > 0) {
                    this.Committee_ToShow.map((Committee_i, idx) => {
                      Committee_i.index = (idx + 1)
                    })
                  }
                  if (this.LecturerToShow.length > 0) {
                    this.LecturerToShow.map((lecture_i, idx) => {
                      lecture_i.index = (idx + 1)
                    })
                  }
                  this.Committee_code = ''
                  this.perid = ''
                  this.full_name = ''
                  this.phone = ''
                }
              } else {
                this.Coordinator.push({
                  Project_code: this.Project_code,
                  Committee_code: this.Committee_code,
                  Committee_type: this.radioGroup,
                  Committee_des: committ_desc,
                  Name: this.full_name,
                  Perid: '',
                  TEL: this.phone,
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              }
            } else {
              if (this.radioGroup == '0') {
                this.staffData.map((item) => {
                  if (item.perid == this.perid) {
                    if (this.radioGroup == '0') {
                      this.Coordinator.push({
                        ...item,
                        Project_code: this.Project_code,
                        Committee_code: this.Committee_code,
                        Committee_type: this.radioGroup,
                        Committee_des: committ_desc,
                        Name: this.full_name,
                        Perid: this.perid,
                        TEL: this.phone,
                      })
                    } else {
                      this.Coordinator.push({
                        ...item,
                        Project_code: this.Project_code,
                        Committee_code: this.Committee_code,
                        Committee_type: this.radioGroup,
                        Committee_des: committ_desc,
                        Name: this.full_name,
                        Perid: '',
                        TEL: this.phone,
                      })
                    }
                  }
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                if (this.Committee_ToShow.length > 0) {
                  this.Committee_ToShow.map((Committee_i, idx) => {
                    Committee_i.index = (idx + 1)
                  })
                }
                if (this.LecturerToShow.length > 0) {
                  this.LecturerToShow.map((lecture_i, idx) => {
                    lecture_i.index = (idx + 1)
                  })
                }
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              } else {
                this.Coordinator.push({
                  Project_code: this.Project_code,
                  Committee_code: this.Committee_code,
                  Committee_type: this.radioGroup,
                  Committee_des: committ_desc,
                  Name: this.full_name,
                  Perid: '',
                  TEL: this.phone,
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              }
            }
          }


        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณากรอกชื่อ-สกุล ตำแหน่ง และ เบอร์โทร,ของผู้ประสานงานให้ครบถ้วน'
        })
      }
    },
    getTrainFiles(Ref_id) {
      return new Promise(resolve => {
        var dumpArr = []
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/Ref_id/' + Ref_id).then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              dumpArr = res.data
            } else {
              dumpArr.push(res.data)
            }
          } else {
            dumpArr = []
          }
          resolve(dumpArr)
        })
      })
    },
    getCourseType() {
      // this.Project_code = (this.ProjectPlan == '' || this.ProjectPlan == null) ? ((parseInt(this.FiscalYear) + 543).toString().substring(2)) + '-' + this.Project_category + this.Project_type + this.IsPlan + '1-' + '???' : this.ProjectPlan
      if (this.Course_code == null) {
        this.course_group = ''
        // this.Project_code = ''
        this.Period_code = 0
        this.CalHourse = this.CalHourse != '0' ? this.CalHourse : '0'
        this.CalCredit = this.CalCredit != '0' ? this.CalCredit : '0'
      } else {
        this.courseData.map((item) => {
          if (item.Course_code == this.Course_code) {
            this.course_group = item.Course_type_des
            this.Period_code = item.Period_code
            this.CalHourse = '' + item.Course_hour
            this.CalCredit = '' + item.General_credit
          }
        })
      }
      if (this.DateForPlan.filter(item => item.date_start <= this.getDateNow() && item.date_end >= this.getDateNow() && item.year == this.FiscalYear).length > 0) {
        this.isPlanCordi = false
      } else {
        this.isPlanCordi = true
      }
    },
    DeleteDataCondi(DataCor) {
      this.DataCondi.map((item, index) => {
        if (item.PosCode == DataCor.PosCode) {
          this.DataCondi.splice(index, 1)
        }
      })
    },
    DeleteDepQuotaCondi(DataCor) {
      this.ProjectQuotaDepCount -= parseInt(DataCor.count)
      this.DepQuotaData.map((item, index) => {
        if (item.dep_id == DataCor.dep_id) {
          this.DepQuotaData.splice(index, 1)
        }
      })
    },
    DataCondiFunc() {
      var CheckDupe = false
      if (this.workAgeStart_Condi > this.workAgeEnd_Condi) {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด คุณกรอกอายุงานไม่ถูกต้อง'
        })
      } else if (this.workAgeStart_Condi == '' || this.workAgeEnd_Condi == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด โปรดกรอกอายุงานให้ครบถ้วน'
        })
      } else {
        this.DataCondi.map((item) => {
          if (item.PosCode == this.posiCondi) {
            if (this.workAgeStart_Condi >= item.workAgeStart && this.workAgeStart_Condi <= item.workAgeEnd) {
              CheckDupe = true
            } else if (this.workAgeEnd_Condi >= item.workAgeStart && this.workAgeEnd_Condi <= item.workAgeEnd) {
              CheckDupe = true
            }
          }
        })
        if (CheckDupe) {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด อายุงานที่เลือก มีในระบบอยู่แล้ว โปรดตรวจสอบข้อมูลอายุงาน'
          })
        } else {
          this.positions.map((item) => {
            if (item.PosCode == this.posiCondi) {
              this.DataCondi.push({
                ...item,
                workAgeStart: this.workAgeStart_Condi,
                workAgeEnd: this.workAgeEnd_Condi,
              })
            }
          })
          this.posiCondi = ''
          this.levelCondi = ''
          this.workAgeStart_Condi = ''
          this.workAgeEnd_Condi = ''
          this.Course_Choose = ''
        }
      }

    },
    DeleteCourse(DataCourse) {
      this.courseCondi.map((item, index) => {
        if (item.Course_code == DataCourse.Course_code) {
          this.courseCondi.splice(index, 1)
        }
      })
    },
    CourseCondiFunc() {
      var CheckDupe = false
      this.courseCondi.map((item) => {
        if (item.Course_code == this.ChooseCourse) {
          CheckDupe = true
        }
      })
      if (CheckDupe) {
        this.$swal.fire({
          icon: 'error',
          title: 'มีข้อมูลหลักสูตรแล้ว ไม่สามารถเพิ่มข้อมูลได้อีก'
        })
      } else {
        this.courseData.map((item) => {
          if (item.Course_code == this.ChooseCourse) {
            this.courseCondi.push(item)
          }
        })
        this.ChooseCourse = ''
      }
    },
    dateFunctionEvents(date) {
      const [, , day] = date.split('-')
      if ([12, 17, 28].includes(parseInt(day, 10))) return true
      if ([1, 19, 22].includes(parseInt(day, 10))) return ['red', '#00f']
      return false
    },
    monthFunctionEvents(date) {
      const month = parseInt(date.split('-')[1], 10)
      if ([1, 3, 7].includes(month)) return true
      if ([2, 5, 12].includes(month)) return ['error', 'purple', 'rgba(0, 128, 0, 0.5)']
      return false
    },
    SuccessProject() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการปิดโครงการใช่หรือไม่ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.btnDisable = true
          if (this.Project.IsPlanStatus == '7') {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.Project.Project_code, {
              IsPlanStatus: '8'
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(res => {
              if (res.data.status) {
                this.btnDisable = false
                this.ProjectPlan = null

                if (this.Project.Project_type == '2' && (this.Project.IsProcess == '1' || this.Project.IsProcess == '3')) {
                  this.initApproveMasterByType({
                    type: this.Project.Project_category
                  }).then(res => {
                    if (res) {
                      if (this.ApproveMaster.length > 0) {
                        var SendMailApprove = this.ApproveMaster.filter(Approveitem => Approveitem.type == this.Project.Project_category && Approveitem.sendmail == '1' && (Approveitem.Approve_Project_Type_Ms == '1' || Approveitem.Approve_Project_Type_Ms == '9') && Approveitem.readonly == '0' && Approveitem.project_type != '2')
                        if (SendMailApprove.length > 0) {
                          SendMailApprove.map(SendMailI => {
                            this.SendMailSucProject(SendMailI)
                          })
                        }
                      }
                    }
                  })
                } else if (this.Project.Project_type == '1') {
                  this.initApproveMasterByType({
                    type: this.Project.Project_category
                  }).then(res => {
                    if (res) {
                      if (this.ApproveMaster.length > 0) {
                        var SendMailApprove = this.ApproveMaster.filter(Approveitem => Approveitem.type == this.Project.Project_category && Approveitem.sendmail == '1' && (Approveitem.Approve_Project_Type_Ms == '1' || Approveitem.Approve_Project_Type_Ms == '9') && Approveitem.readonly == '0' && Approveitem.project_type != '2')
                        if (SendMailApprove.length > 0) {
                          SendMailApprove.map(SendMailI => {
                            this.SendMailSucProject(SendMailI)
                          })
                        }
                      }
                    }
                  })
                }

                this.init()
                this.$swal.fire({
                  icon: 'success',
                  title: 'บันทึกข้อมูลสำเร็จ'
                })
              } else {
                this.btnDisable = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้สำเร็จโปรดติดต่อผู้ดูแลระบบ'
                })
              }
            }).catch(res => {
              if (res) {
                this.btnDisable = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้สำเร็จโปรดติดต่อผู้ดูแลระบบ'
                })
              }
            })
          } else {
            this.btnDisable = false
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถปิดโครงการได้ เนื่องจากยังไม่สิ้นสุดกระบวนการเบิกจ่ายเงินเสร็จสิ้น'
            })
          }
        }
      })
    },
    CancelProject() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการยกเลิกแผนใช่หรือไม่ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.btnDisable = true
          axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
            queryName: 'updateStatus',
            param: btoa(encodeURIComponent(JSON.stringify({
              id: this.Project.Project_code,
              status: '9',
              remarks: this.remarksCloseProject,
              Update_By: this.MeData[0].perid
            })))
          }).then(res => {
            if (res.data.status) {
              this.btnDisable = false
              this.ProjectPlan = null
              if (this.Project.Project_type == '2' && (this.Project.IsProcess == '1' || this.Project.IsProcess == '3')) {
                this.initApproveMasterByType({
                  perid: this.MeData[0].perid
                }).then(res => {
                  if (res) {
                    if (this.ApproveMaster.length > 0) {
                      var SendMailApprove = this.ApproveMaster.filter(Approveitem => Approveitem.type == this.Project.Project_category && Approveitem.sendmail == '1' && (Approveitem.Approve_Project_Type_Ms == '1' || Approveitem.Approve_Project_Type_Ms == '9') && Approveitem.readonly == '0' && Approveitem.project_type != '2')
                      if (SendMailApprove.length > 0) {
                        SendMailApprove.map(SendMailI => {
                          this.SendMailCancelPlan(SendMailI)
                        })
                      }
                    }
                  }
                })
              } else if (this.Project.Project_type == '1') {
                this.initApproveMasterByType({
                  perid: this.MeData[0].perid
                }).then(res => {
                  if (res) {
                    if (this.ApproveMaster.length > 0) {
                      var SendMailApprove = this.ApproveMaster.filter(Approveitem => Approveitem.type == this.Project.Project_category && Approveitem.sendmail == '1' && (Approveitem.Approve_Project_Type_Ms == '1' || Approveitem.Approve_Project_Type_Ms == '9') && Approveitem.readonly == '0' && Approveitem.project_type != '2')
                      if (SendMailApprove.length > 0) {
                        SendMailApprove.map(SendMailI => {
                          this.SendMailCancelPlan(SendMailI)
                        })
                      }
                    }
                  }
                })
              }

              this.ProjectObj = null
              this.dialogCancelOrCloseProject = false
              this.init()
              this.$swal.fire({
                icon: 'success',
                title: 'บันทึกข้อมูลสำเร็จ'
              })
            } else {
              this.btnDisable = false
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้สำเร็จโปรดติดต่อผู้ดูแลระบบ'
              })
            }
          }).catch(res => {
            if (res) {
              this.btnDisable = false
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้สำเร็จโปรดติดต่อผู้ดูแลระบบ'
              })
            }
          })
        }
      })
    },
    UpdateProject(status) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการยืนยันแก้ไขข้อมูล",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.btnDisable = true
          this.CheckPermission().then(resPermiss => {
            if (resPermiss) {
              if (this.Project_code == '' || this.Project_name == '' || (this.Project_group == '' || this.Project_group == null) || this.PLACE == ''
                  || this.WorkBy == '' || (this.WorkByName == '' || this.WorkByName == null) || (this.WorkByPhone == '' || this.WorkByPhone == null) || this.DateStart == '' || this.DateEnd == '' || this.BudgetRequest == ''
                  || this.CalCredit == '' || this.CalHourse == '' || this.DepSelect == null || (this.TargetGroup == '' || this.TargetGroup == null) || (this.Objective == '' || this.Objective == null) || (this.IsPlan == '' || this.IsPlan == null) || (this.Project_category == '' || this.Project_category == null) || (this.Project_type == '' || this.Project_type == null) || (this.TypeProject == '2' && (this.IsProcess == '' || this.IsProcess == null))) {
                // console.log('this.Project_code ' + this.Project_code + ' ' + (this.Project_code == ''))
                // console.log('this.Project_name ' + this.Project_name + ' ' + (this.Project_name == ''))
                // console.log('this.Project_group ' + this.Project_group + ' ' + (this.Project_group == ''))
                // console.log('this.PLACE ' + this.PLACE + ' ' + (this.PLACE == ''))
                // console.log('this.WorkBy ' + this.WorkBy + ' ' + (this.WorkBy == ''))
                // console.log('this.WorkByName ' + this.WorkByName + ' ' + (this.WorkByName == ''))
                // console.log('this.DateStart ' + this.DateStart + ' ' + (this.DateStart == ''))
                // console.log('this.DateEnd ' + this.DateEnd + ' ' + (this.DateEnd == ''))
                // console.log('this.BudgetRequest ' + this.BudgetRequest + ' ' + (this.BudgetRequest == ''))
                // console.log('this.CalCredit ' + this.CalCredit + ' ' + (this.CalCredit == ''))
                // console.log('this.CalHourse ' + this.CalHourse + ' ' + (this.CalHourse == ''))
                // console.log('this.DepSelect ' + this.DepSelect + ' ' + (this.DepSelect == null))
                // console.log('this.Objective ' + this.Objective + ' ' + (this.Objective == '' || this.Objective == null))
                // console.log('this.IsPlan ' + this.IsPlan + ' ' + (this.IsPlan == '' || this.IsPlan == null))
                // console.log('this.Project_category ' + this.Project_category + ' ' + (this.Project_category == '' || this.Project_category == null))
                // console.log('this.Project_type ' + this.Project_type + ' ' + (this.Project_type == '' || this.Project_type == null))
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'โปรดกรอกข้อมูลให้ครบถ้วน',
                })
                this.btnDisable = false
              } else if (this.episode == null) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'ระยะเวลาที่คาดว่าจะจัด ห้ามว่าง',
                })
                this.btnDisable = false
              }
              /*else if (this.Project_group == '101' || this.Project_group == '102' || this.Project_group == '103' || this.Project_group == '104') {
                if (this.Course_code == null || this.Course_code == '') {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'เลือกประเภทโครงการ : จัดบริหารวิชาการ,จัดพัฒนาบุคลากร เงื่อนไขหลักสูตรต้องห้ามว่าง',
                  })
                  this.btnDisable = false
                } else {
                  this.updateData()
                }
              } */
              else if (this.PLACE == '2' && this.Province_id == '') {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'โปรดกรอกข้อมูลจังหวัด',
                })
                this.btnDisable = false
              } else if (this.PLACE == '3' && this.Country_id == '') {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'โปรดกรอกข้อมูลประเทศ',
                })
                this.btnDisable = false
              } else if (this.selection.length == 0) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'โปรดเลือก ค่า Competency,Core Value,Strategic Objective ก่อนบันทึกข้อมูล',
                })
                this.btnDisable = false
              } else if (this.selection.length > 0) {
                if (this.Project_category == '1' && !this.CompetencyData[0].checkCordi && !this.CompetencyData[2].checkCordi) {
                  (this.IsPlanStatus == '2' || this.IsPlanStatus == '5') ? this.updateDataAfterApprove() : this.updateData(status)
                } else if (this.Project_category != '1' && !this.CompetencyData[2].checkCordi) {
                  (this.IsPlanStatus == '2' || this.IsPlanStatus == '5') ? this.updateDataAfterApprove() : this.updateData(status)
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: this.Project_category == '1' ? 'โปรดตรวจสอบ ข้อมูล Competency และ Strategic Objective' : 'โปรดตรวจสอบ ข้อมูล Strategic Objective',
                  })
                  this.btnDisable = false
                }
              } else {
                (this.IsPlanStatus == '2' || this.IsPlanStatus == '5') ? this.updateDataAfterApprove() : this.updateData(status)
              }
            } else {
              this.btnDisable = false
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          })
        }
      })
    },
    updateDataAfterApprove() {
      var Ref_id_edit = this.getRandomFileName()
      this.D_Project.Project_code = this.Project_code
      this.D_Project.Ref_Project_code = this.Project_code_ref
      this.D_Project.Project_name = this.Project_name
      this.courseData.map((item) => {
        if (item.Course_code == this.Course_code) {
          this.D_Project.Course_code = item.Course_code
          this.D_Project.course_group = item.Course_group
        }
      })
      this.D_Project.Project_group = this.Project_group
      this.D_Project.IsProcess = this.IsProcess
      this.D_Project.Project_category = this.Project_category
      this.D_Project.Project_type = this.Project_type
      this.D_Project.Objective = this.Objective
      this.D_Project.TargetGroup = this.TargetGroup
      this.D_Project.Remarks = this.Remarks
      this.D_Project.CalCredit = this.CalCredit
      this.D_Project.CalHourse = this.CalHourse
      this.D_Project.PLACE = this.PLACE
      this.D_Project.Province_id = this.Province_id
      this.D_Project.Country_id = this.Country_id
      this.D_Project.BudgetRequest = this.BudgetRequest
      this.D_Project.Location = this.Location
      this.D_Project.WorkBy = this.WorkBy
      this.D_Project.WorkByName = this.WorkByName
      this.D_Project.WorkByPhone = this.WorkByPhone
      this.D_Project.DatePeriod = this.episode
      this.D_Project.DateStart = this.DateStart
      this.D_Project.DateEnd = this.DateEnd
      this.D_Project.Approve = this.Approve
      this.D_Project.FiscalYear = this.FiscalYear
      this.D_Project.IsPlan = this.IsPlan
      this.D_Project.IsPlanStatus = this.IsPlanStatus == '2' ? '5' : this.IsPlanStatus
      this.D_Project.Status_Reg = this.ChooseTypRegis
      this.D_Project.Status_Type_Reg = this.ChooseTypRegis2
      this.D_Project.DateS_Reg = this.dateRegStart
      this.D_Project.DateE_Reg = this.dateRegEnd
      this.D_Project.IsDataComplete = '1'
      if (this.ChkJoinPerson) {
        this.D_Project.Status_Count_Reg = '1'
      } else {
        this.D_Project.Status_Count_Reg = '0'
      }
      this.D_Project.Count_Reg = this.ProjectQuotaCount
      this.D_Project.Dep_Code = this.DepSelect
      this.D_Project.Status = this.Status
      this.D_Project.Update_By = this.MeData[0].perid

      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      if (this.TypeProject == '2' && (this.IsProcess == '2' || this.IsProcess == '3')) {
        this.updateData('5')
      } else {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_Edit_Project/Req_status/0/Project_code/' + this.D_Project.Project_code + '/?limit=1').then(resTemp => {
          if (resTemp.data) {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สามารถแก้ไขข้อมูลได้เนื่องจากมีคำร้องขอแก้ไขข้อมูลแผน ที่ยังไม่ได้รับการพิจาณา',
            })
            this.ProjectPlan = null
            this.ClearData()
          } else {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_Edit_Project/', {
              Ref_id: Ref_id_edit,
              Project_code: this.D_Project.Project_code,
              Create_By: this.MeData[0].perid
            }, {
              headers: {
                'Content-Type': 'application/json',
                'X-REST-METHOD': 'PUT'
              }
            })
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_D_project/Project_code/' + this.D_Project.Project_code, {
              Ref_id: Ref_id_edit,
              Project_code: this.D_Project.Project_code,
              Ref_Project_code: this.D_Project.Ref_Project_code,
              Project_name: this.D_Project.Project_name,
              Course_code: this.D_Project.Course_code,
              course_group: this.D_Project.course_group,
              IsProcess: this.D_Project.IsProcess,
              Project_category: this.D_Project.Project_category,
              Project_type: this.D_Project.Project_type,
              WorkBy: this.D_Project.WorkBy,
              WorkByName: this.D_Project.WorkByName,
              WorkByPhone: this.D_Project.WorkByPhone,
              Location: this.D_Project.Location,
              DatePeriod: this.D_Project.DatePeriod,
              DateStart: this.D_Project.DateStart,
              DateEnd: this.D_Project.DateEnd,
              CalHourse: this.D_Project.CalHourse,
              CalCredit: this.D_Project.CalCredit,
              PLACE: this.D_Project.PLACE,
              Province_id: this.D_Project.Province_id,
              Country_id: this.D_Project.Country_id,
              Status: this.D_Project.Status,
              Objective: this.D_Project.Objective,
              TargetGroup: this.D_Project.TargetGroup,
              Remarks: this.D_Project.Remarks,
              ProjectLevel: this.D_Project.ProjectLevel,
              App_doc_no: this.D_Project.App_doc_no,
              BudgetRequest: this.D_Project.BudgetRequest,
              BudgetArrove: this.D_Project.BudgetArrove,
              MoneyDisburse: this.D_Project.MoneyDisburse,
              Project_group: this.D_Project.Project_group,
              Approve: this.D_Project.Approve,
              FiscalYear: this.D_Project.FiscalYear,
              IsPlan: this.D_Project.IsPlan,
              IsPlanStatus: this.D_Project.IsPlanStatus,
              Status_Reg: this.D_Project.Status_Reg,
              Status_Type_Reg: this.D_Project.Status_Type_Reg,
              DateS_Reg: this.D_Project.DateS_Reg,
              DateE_Reg: this.D_Project.DateE_Reg,
              Status_Count_Reg: this.D_Project.Status_Count_Reg,
              Count_Reg: this.D_Project.Count_Reg,
              Dep_Code: this.D_Project.Dep_Code,
              Create_By: this.MeData[0].perid
            }, {
              headers: {
                'Content-Type': 'application/json',
                'X-REST-METHOD': 'PUT'
              }
            }, headerAxios).then(res => {
              if (res.data.status) {

                this.DataCourse.Project_code = this.D_Project.Project_code

                // Log D_project_files
                if (this.FileProject.length > 0) {
                  var countFileProject = 0
                  this.FileProject.map((item) => {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_D_project_files', {
                      Ref_id: Ref_id_edit,
                      Project_code: this.Project_code,
                      File_name: item.name,
                      File_path: item.path,
                      File_type: item.type_Img,
                      Type: '0',
                      Create_By: this.MeData[0].perid
                    }, {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'PUT'
                      }
                    }).then(res => {
                      if (res.data.status) {
                        countFileProject++
                        if (countFileProject == this.FileProject.length) {
                          this.FileProject = []
                        }
                      }
                    })
                  })
                }
                // Log D_project_competency
                this.AddTempCompetency(Ref_id_edit).then(res => {
                  if (res) {
                    if ((this.TypeProject == '1') || (this.TypeProject == '2' && (this.IsProcess == '1' || this.IsProcess == '3'))) {
                      this.initApproveMasterByType({
                        perid: this.MeData[0].perid
                      }).then(res => {
                        if (res) {
                          if (this.ApproveMaster.length > 0) {
                            var SendMailApprove = this.ApproveMaster.filter(Approveitem => Approveitem.type == this.Project.Project_category && Approveitem.sendmail == '1' && (Approveitem.Approve_Project_Type_Ms == '1' || Approveitem.Approve_Project_Type_Ms == '9') && Approveitem.readonly == '0' && Approveitem.project_type != '2')
                            if (SendMailApprove.length > 0) {
                              SendMailApprove.map(SendMailI => {
                                this.SendMailAfterApprove(SendMailI)
                              })
                            }
                          }
                        }
                      })
                    }

                    this.initProjectDataForApprove({
                      perid: this.MeData[0].perid
                    }).then(res => {
                      if (res) {
                        this.init()
                        this.$swal.fire({
                          icon: 'success',
                          title: 'แก้ไขข้อมูลสำเร็จ'
                        })

                        this.btnDisable = false

                        this.e1 = '1'

                        this.Project_code_ref = ''
                        this.Project_code = ''
                        this.Project_name = ''
                        this.Course_code = null
                        this.course_group = ''
                        this.IsProcess = null
                        this.Project_category = null
                        this.Remarks = ''
                        this.WorkBy = ''
                        this.Location = ''
                        this.DateStart = ''
                        this.IsDataComplete = ''
                        this.DateEnd = ''
                        this.CalHourse = '0'
                        this.CalCredit = '0'
                        this.PLACE = ''
                        this.Province_id = ''
                        this.BudgetRequest = ''
                        this.ChooseTypeDep = '0'
                        this.ChooseTypRegis = '1'
                        this.ChooseTypRegis2 = '0'
                        this.dateRegStart = ''
                        this.dateRegEnd = ''
                        this.ProjectQuotaCount = ''
                        this.ProjectQuotaDepCount = 0
                        this.MessageSuc = ''
                        this.MessageError = ''
                        this.ChkJoinPerson = true
                        this.ShowAlertErr = false
                        this.ShowAlertSuc = false
                        this.Project_Choose = ''
                        this.Project_group = ''
                        this.DepSelect = ''
                        this.Period_code = ''
                        this.editorData = ''
                        this.FiscalYear = ''
                        this.IsPlan = null
                        this.ProjectPlan = null
                        this.WorkByName = ''
                        this.WorkByPhone = ''
                        this.itemCode = ''
                        this.txtAlert = []
                        this.alert = false
                      }
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด',
                      text: 'ไม่สามารถบันทึกข้อมูลได้',
                    })
                    this.Project_code_ref = ''
                    this.Project_code = ''
                    this.Project_name = ''
                    this.Course_code = null
                    this.course_group = ''
                    this.IsProcess = null
                    this.Project_category = null
                    this.Objective = ''
                    this.TargetGroup = ''
                    this.Remarks = ''
                    this.WorkBy = ''
                    this.Location = ''
                    this.DateStart = ''
                    this.IsDataComplete = ''
                    this.DateEnd = ''
                    this.CalHourse = '0'
                    this.CalCredit = '0'
                    this.PLACE = ''
                    this.Province_id = ''
                    this.BudgetRequest = ''
                    this.ChooseTypeDep = '0'
                    this.ChooseTypRegis = '1'
                    this.ChooseTypRegis2 = '0'
                    this.dateRegStart = ''
                    this.dateRegEnd = ''
                    this.ProjectQuotaCount = ''
                    this.ProjectQuotaDepCount = 0
                    this.MessageSuc = ''
                    this.MessageError = ''
                    this.ChkJoinPerson = true
                    this.ShowAlertErr = false
                    this.ShowAlertSuc = false
                    this.Project_group = ''
                    this.DepSelect = ''
                    this.Period_code = ''
                    this.editorData = ''
                    this.FiscalYear = ''
                    this.IsPlan = null
                    this.ProjectPlan = null
                    this.WorkByName = ''
                    this.WorkByPhone = ''
                    this.itemCode = ''
                    this.txtAlert = []
                    this.alert = false
                  }
                })

                /*this.AddCompetency().then(res => {
                  if (res) {
                    this.init()
                    this.initProjectData({
                      perid: this.MeData[0].perid
                    })

                    this.$swal.fire({
                      icon: 'success',
                      title: 'แก้ไขข้อมูลสำเร็จ'
                    })

                    this.btnDisable = false

                    this.e1 = '1'

                    this.Project_code = ''
                    this.Project_name = ''
                    this.Course_code = null
                    this.course_group = ''
                    this.Project_category = '1'
                    this.Project_type = '1'
                    this.Objective = ''
                    this.Remarks = ''
                    this.WorkBy = ''
                    this.Location = ''
                    this.DateStart = ''
                    this.DateEnd = ''
                    this.CalHourse = ''
                    this.CalCredit = ''
                    this.PLACE = ''
                    this.Province_id = ''
                    this.BudgetRequest = ''
                    this.ChooseTypeDep = '0'
                    this.ChooseTypRegis = '1'
                    this.ChooseTypRegis2 = '0'
                    this.dateRegStart = ''
                    this.dateRegEnd = ''
                    this.ProjectQuotaCount = ''
                    this.ProjectQuotaDepCount = 0
                    this.MessageSuc = ''
                    this.MessageError = ''
                    this.ChkJoinPerson = true
                    this.ShowAlertErr = false
                    this.ShowAlertSuc = false
                    this.Project_Choose = ''
                    this.Project_group = ''
                    this.DepSelect = ''
                    this.Period_code = ''
                    this.editorData = ''
                    this.FiscalYear = ''
                    this.IsPlan = null
                    this.ProjectPlan = null
                    this.WorkByName = ''
                    this.itemCode = ''
                    this.txtAlert = []
                    this.alert = false
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด',
                      text: 'ไม่สามารถบันทึกข้อมูลได้',
                    })
                    this.Project_code = ''
                    this.Project_name = ''
                    this.Course_code = null
                    this.course_group = ''
                    this.Project_category = '1'
                    this.Project_type = '1'
                    this.Objective = ''
                    this.Remarks = ''
                    this.WorkBy = ''
                    this.Location = ''
                    this.DateStart = ''
                    this.DateEnd = ''
                    this.CalHourse = ''
                    this.CalCredit = ''
                    this.PLACE = ''
                    this.Province_id = ''
                    this.BudgetRequest = ''
                    this.ChooseTypeDep = '0'
                    this.ChooseTypRegis = '1'
                    this.ChooseTypRegis2 = '0'
                    this.dateRegStart = ''
                    this.dateRegEnd = ''
                    this.ProjectQuotaCount = ''
                    this.ProjectQuotaDepCount = 0
                    this.MessageSuc = ''
                    this.MessageError = ''
                    this.ChkJoinPerson = true
                    this.ShowAlertErr = false
                    this.ShowAlertSuc = false
                    this.Project_group = ''
                    this.DepSelect = ''
                    this.Period_code = ''
                    this.editorData = ''
                    this.FiscalYear = ''
                    this.IsPlan = null
                    this.ProjectPlan = null
                    this.WorkByName = ''
                    this.itemCode = ''
                    this.txtAlert = []
                    this.alert = false
                  }
                })*/

              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'ไม่สามารถบันทึกข้อมูลได้',
                })
                this.Project_code = ''
                this.Project_code_ref = ''
                this.Project_name = ''
                this.Course_code = null
                this.course_group = ''
                this.IsProcess = null
                this.Project_category = null
                this.Objective = ''
                this.TargetGroup = ''
                this.Remarks = ''
                this.WorkBy = ''
                this.Location = ''
                this.DateStart = ''
                this.IsDataComplete = ''
                this.DateEnd = ''
                this.CalHourse = '0'
                this.CalCredit = '0'
                this.PLACE = ''
                this.Province_id = ''
                this.BudgetRequest = ''
                this.ChooseTypeDep = '0'
                this.ChooseTypRegis = '1'
                this.ChooseTypRegis2 = '0'
                this.dateRegStart = ''
                this.dateRegEnd = ''
                this.ProjectQuotaCount = ''
                this.ProjectQuotaDepCount = 0
                this.MessageSuc = ''
                this.MessageError = ''
                this.ChkJoinPerson = true
                this.ShowAlertErr = false
                this.ShowAlertSuc = false
                this.Project_group = ''
                this.DepSelect = ''
                this.Period_code = ''
                this.editorData = ''
                this.FiscalYear = ''
                this.IsPlan = null
                this.ProjectPlan = null
                this.WorkByName = ''
                this.WorkByPhone = ''
                this.itemCode = ''
                this.txtAlert = []
                this.alert = false
              }
            });
          }
        })
      }
    },
    updateData(status) {
      var Ref_id_edit = this.getRandomFileName()
      this.D_Project.Project_code = this.Project_code
      this.D_Project.Ref_Project_code = this.Project_code_ref
      this.D_Project.Project_name = this.Project_name
      this.courseData.map((item) => {
        if (item.Course_code == this.Course_code) {
          this.D_Project.Course_code = item.Course_code
          this.D_Project.course_group = item.Course_group
        }
      })
      this.D_Project.Project_group = this.Project_group
      this.D_Project.IsProcess = this.IsProcess
      this.D_Project.Project_category = this.Project_category
      this.D_Project.Objective = this.Objective
      this.D_Project.TargetGroup = this.TargetGroup
      this.D_Project.Project_type = this.Project_type
      this.D_Project.Remarks = this.Remarks
      this.D_Project.CalCredit = this.CalCredit
      this.D_Project.CalHourse = this.CalHourse
      this.D_Project.PLACE = this.PLACE
      this.D_Project.Province_id = this.Province_id
      this.D_Project.Country_id = this.Country_id
      this.D_Project.BudgetRequest = this.BudgetRequest
      this.D_Project.Location = this.Location
      this.D_Project.WorkBy = this.WorkBy
      this.D_Project.WorkByName = this.WorkByName
      this.D_Project.WorkByPhone = this.WorkByPhone
      this.D_Project.DatePeriod = this.episode
      this.D_Project.DateStart = this.DateStart
      this.D_Project.DateEnd = this.DateEnd
      this.D_Project.Approve = this.Approve
      this.D_Project.FiscalYear = this.FiscalYear
      this.D_Project.IsPlan = this.IsPlan
      // this.D_Project.IsPlanStatus = this.IsPlanStatus == '2' ? '5' : this.IsPlanStatus
      this.D_Project.IsPlanStatus = (((this.TypeProject == '1') || (this.TypeProject == '2' && (this.IsProcess == '1' || this.IsProcess == '3'))) ? (this.IsPlanStatus == '5') ? this.IsPlanStatus : status : (this.TypeProject == '2' && this.IsProcess != '1' && status == '1') ? '2' : status)
      this.D_Project.Status_Reg = this.ChooseTypRegis
      this.D_Project.Status_Type_Reg = this.ChooseTypRegis2
      this.D_Project.DateS_Reg = this.dateRegStart
      this.D_Project.DateE_Reg = this.dateRegEnd
      this.D_Project.IsDataComplete = '1'
      if (this.ChkJoinPerson) {
        this.D_Project.Status_Count_Reg = '1'
      } else {
        this.D_Project.Status_Count_Reg = '0'
      }
      this.D_Project.Count_Reg = this.ProjectQuotaCount
      this.D_Project.Dep_Code = this.DepSelect
      this.D_Project.Status = this.Status
      if (this.IsDataComplete == '0') {
        this.D_Project.Create_By = this.MeData[0].perid
      }
      this.D_Project.Update_By = this.MeData[0].perid

      this.updateD_Project(this.D_Project).then(async res => {
        if (res) {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_Edit_Project/', {
            Ref_id: Ref_id_edit,
            Create_By: this.MeData[0].perid
          }, {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'PUT'
            }
          })
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project/', {
            Ref_id: Ref_id_edit,
            Project_code: this.LogObjProject.Project_code,
            Ref_Project_code: this.LogObjProject.Ref_Project_code,
            Project_name: this.LogObjProject.Project_name,
            Course_code: this.LogObjProject.Course_code,
            course_group: this.LogObjProject.course_group,
            Project_type: this.LogObjProject.Project_type,
            WorkBy: this.LogObjProject.WorkBy,
            WorkByName: this.LogObjProject.WorkByName,
            WorkByPhone: this.LogObjProject.WorkByPhone,
            Location: this.LogObjProject.Location,
            DatePeriod: this.LogObjProject.DatePeriod,
            DateStart: this.LogObjProject.DateStart,
            DateEnd: this.LogObjProject.DateEnd,
            CalHourse: this.LogObjProject.CalHourse,
            CalCredit: this.LogObjProject.CalCredit,
            PLACE: this.LogObjProject.PLACE,
            Province_id: this.LogObjProject.Province_id,
            Country_id: this.LogObjProject.Country_id,
            Status: this.LogObjProject.Status,
            Remarks: this.LogObjProject.Remarks,
            ProjectLevel: this.LogObjProject.ProjectLevel,
            App_doc_no: this.LogObjProject.App_doc_no,
            BudgetRequest: this.LogObjProject.BudgetRequest,
            BudgetArrove: this.LogObjProject.BudgetArrove,
            MoneyDisburse: this.LogObjProject.MoneyDisburse,
            Project_group: this.LogObjProject.Project_group,
            IsProcess: this.LogObjProject.IsProcess,
            Project_category: this.LogObjProject.Project_category,
            Objective: this.LogObjProject.Objective,
            TargetGroup: this.LogObjProject.TargetGroup,
            Approve: this.LogObjProject.Approve,
            FiscalYear: this.LogObjProject.FiscalYear,
            IsPlan: this.LogObjProject.IsPlan,
            IsPlanStatus: this.LogObjProject.IsPlanStatus,
            Status_Reg: this.LogObjProject.Status_Reg,
            Status_Type_Reg: this.LogObjProject.Status_Type_Reg,
            DateS_Reg: this.LogObjProject.DateS_Reg,
            DateE_Reg: this.LogObjProject.DateE_Reg,
            Status_Count_Reg: this.LogObjProject.Status_Count_Reg,
            Count_Reg: this.LogObjProject.Count_Reg,
            Dep_Code: this.LogObjProject.Dep_Code,
            Create_By: this.MeData[0].perid
          }, {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'PUT'
            }
          })
          this.DataCourse.Project_code = this.D_Project.Project_code
          await this.clearActiveData(this.D_Project.Project_code)

          if (this.FileProject.length > 0) {
            const headerAxiosPUT = {
              headers: {
                'Content-Type': 'application/json',
                'X-REST-METHOD': 'PUT'
              }
            }

            var Count = 0

            if (this.FileProject.length > 0) {
              this.FileProject.map((item) => {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files', {
                  Project_code: this.DataCourse.Project_code,
                  File_name: item.name,
                  File_path: item.path,
                  File_type: item.type_Img,
                  Type: '0',
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()'
                }, headerAxiosPUT).then(res => {
                  if (res.data.status) {
                    Count++
                    if (Count == this.FileProject.length) {
                      this.FileProject = []
                      this.files = []
                    }
                  }
                })
              })
            }
          }

          // Log D_project_files
          if (this.FileProjectOld.length > 0) {
            var countFileProject = 0
            this.FileProjectOld.map((item) => {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_files', {
                Ref_id: Ref_id_edit,
                Project_code: this.Project_code,
                File_name: item.name,
                File_path: item.path,
                File_type: item.type_Img,
                Type: '0',
                Create_By: this.MeData[0].perid
              }, {
                headers: {
                  'Content-Type': 'application/json',
                  'X-REST-METHOD': 'PUT'
                }
              }).then(res => {
                if (res.data.status) {
                  countFileProject++
                  if (countFileProject == this.FileProjectOld.length) {
                    this.FileProjectOld = []
                  }
                }
              })
            })
          }

          // Log D_project_competency
          this.AddLogCompetency(Ref_id_edit)

          this.AddCompetency().then(res => {
            if (res) {
              if (status == '1' && this.IsPlanStatus == '4') {
                if ((this.TypeProject == '1') || (this.TypeProject == '2' && (this.IsProcess == '1' || this.IsProcess == '3'))) {
                  this.initApproveMasterByType({
                    type: this.Project.Project_category
                  }).then(res => {
                    if (res) {
                      if (this.ApproveMaster.length > 0) {
                        var SendMailApprove = this.ApproveMaster.filter(Approveitem => Approveitem.type == this.Project.Project_category && Approveitem.sendmail == '1' && (Approveitem.Approve_Project_Type_Ms == '1' || Approveitem.Approve_Project_Type_Ms == '9') && Approveitem.readonly == '0' && Approveitem.project_type != '2')
                        if (SendMailApprove.length > 0) {
                          SendMailApprove.map(SendMailI => {
                            this.SendMail(SendMailI)
                          })
                        }
                      }
                    }
                  })
                }
              } else if (status == '1' && this.IsPlanStatus == '0') {
                this.initApproveMasterByType({
                  perid: this.MeData[0].perid
                }).then(res => {
                  if (res) {
                    if (this.ApproveMaster.length > 0) {
                      var SendMailApprove = this.ApproveMaster.filter(Approveitem => Approveitem.type == this.Project.Project_category && Approveitem.sendmail == '1' && (Approveitem.Approve_Project_Type_Ms == '1' || Approveitem.Approve_Project_Type_Ms == '9') && Approveitem.readonly == '0' && Approveitem.project_type != '2')
                      if (SendMailApprove.length > 0) {
                        SendMailApprove.map(SendMailI => {
                          this.SendReqProjMail(SendMailI)
                        })
                      }
                    }
                  }
                })
              }

              this.initProjectDataForApprove({
                perid: this.MeData[0].perid
              }).then(res => {
                if (res) {
                  this.init()
                  this.$swal.fire({
                    icon: 'success',
                    title: 'แก้ไขข้อมูลสำเร็จ'
                  })

                  this.btnDisable = false

                  this.e1 = '1'

                  this.Project_code = ''
                  this.Project_code_ref = ''
                  this.Project_name = ''
                  this.Course_code = null
                  this.course_group = ''
                  this.IsProcess = null
                  this.Project_category = null
                  this.Remarks = ''
                  this.WorkBy = ''
                  this.Location = ''
                  this.DateStart = ''
                  this.IsDataComplete = ''
                  this.DateEnd = ''
                  this.CalHourse = '0'
                  this.CalCredit = '0'
                  this.PLACE = ''
                  this.Province_id = ''
                  this.BudgetRequest = ''
                  this.ChooseTypeDep = '0'
                  this.ChooseTypRegis = '1'
                  this.ChooseTypRegis2 = '0'
                  this.dateRegStart = ''
                  this.dateRegEnd = ''
                  this.ProjectQuotaCount = ''
                  this.ProjectQuotaDepCount = 0
                  this.MessageSuc = ''
                  this.MessageError = ''
                  this.ChkJoinPerson = true
                  this.ShowAlertErr = false
                  this.ShowAlertSuc = false
                  this.Project_Choose = ''
                  this.Project_group = ''
                  this.DepSelect = ''
                  this.Period_code = ''
                  this.editorData = ''
                  this.FiscalYear = ''
                  this.IsPlan = null
                  this.ProjectPlan = null
                  this.WorkByName = ''
                  this.WorkByPhone = ''
                  this.itemCode = ''
                  this.txtAlert = []
                  this.alert = false
                }
              })

            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'ไม่สามารถบันทึกข้อมูลได้',
              })
              this.Project_code = ''
              this.Project_code_ref = ''
              this.Project_name = ''
              this.Course_code = null
              this.course_group = ''
              this.IsProcess = null
              this.Project_category = null
              this.Remarks = ''
              this.WorkBy = ''
              this.Location = ''
              this.DateStart = ''
              this.IsDataComplete = ''
              this.DateEnd = ''
              this.CalHourse = '0'
              this.CalCredit = '0'
              this.PLACE = ''
              this.Province_id = ''
              this.BudgetRequest = ''
              this.ChooseTypeDep = '0'
              this.ChooseTypRegis = '1'
              this.ChooseTypRegis2 = '0'
              this.dateRegStart = ''
              this.dateRegEnd = ''
              this.ProjectQuotaCount = ''
              this.ProjectQuotaDepCount = 0
              this.MessageSuc = ''
              this.MessageError = ''
              this.ChkJoinPerson = true
              this.ShowAlertErr = false
              this.ShowAlertSuc = false
              this.Project_group = ''
              this.DepSelect = ''
              this.Period_code = ''
              this.editorData = ''
              this.FiscalYear = ''
              this.IsPlan = null
              this.ProjectPlan = null
              this.WorkByName = ''
              this.WorkByPhone = ''
              this.itemCode = ''
              this.txtAlert = []
              this.alert = false
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ไม่สามารถบันทึกข้อมูลได้',
          })
          this.Project_code = ''
          this.Project_code_ref = ''
          this.Project_name = ''
          this.Course_code = null
          this.course_group = ''
          this.IsProcess = null
          this.Project_category = null
          this.Remarks = ''
          this.WorkBy = ''
          this.Location = ''
          this.DateStart = ''
          this.IsDataComplete = ''
          this.DateEnd = ''
          this.CalHourse = '0'
          this.CalCredit = '0'
          this.PLACE = ''
          this.Province_id = ''
          this.BudgetRequest = ''
          this.ChooseTypeDep = '0'
          this.ChooseTypRegis = '1'
          this.ChooseTypRegis2 = '0'
          this.dateRegStart = ''
          this.dateRegEnd = ''
          this.ProjectQuotaCount = ''
          this.ProjectQuotaDepCount = 0
          this.MessageSuc = ''
          this.MessageError = ''
          this.ChkJoinPerson = true
          this.ShowAlertErr = false
          this.ShowAlertSuc = false
          this.Project_group = ''
          this.DepSelect = ''
          this.Period_code = ''
          this.editorData = ''
          this.FiscalYear = ''
          this.IsPlan = null
          this.ProjectPlan = null
          this.WorkByName = ''
          this.WorkByPhone = ''
          this.itemCode = ''
          this.txtAlert = []
          this.alert = false
        }
      })
    },
    updateD_Project(projectObj) {
      return new Promise(resolve => {
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + projectObj.Project_code, projectObj, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(async res => {
          if (res.data.status) {
            resolve(true)
          } else {
            resolve(false)
          }
        }).catch(res => {
          if (res) {
            resolve(true)
          }
        })
      })
    },
    async clearActiveData(projectCode) {
      await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Project_code/' + projectCode, {
        active: '0',
        Update_By: this.MeData[0].perid
      }, this.headerAxios)
      await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/' + projectCode, {
        active: '0',
        update_by: this.MeData[0].perid
      }, this.headerAxios)
    },
    getRandomFileName() {
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      return random_number;
    },
    AddLogCompetency(Ref_id_edit) {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      return new Promise(resolve => {
        if (this.logSelection.length > 0) {
          for (var i = 0; i <= this.logSelection.length - 1; i++) {
            this.CompetencyData.map(root => {
              if (root.children.length > 0) {
                root.children.map(child1 => {
                  if (child1.children.length > 0) {
                    child1.children.map(child2 => {
                      if (child2.id == this.logSelection[i]) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_competency/', {
                          Ref_id: Ref_id_edit,
                          Project_code: this.DataCourse.Project_code,
                          DelvNo: child2.DelvNo,
                          create_by: this.MeData[0].perid,
                        }, headerAxiosPUT)
                      }
                    })
                  }
                  if (child1.id == this.logSelection[i]) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_competency/', {
                      Ref_id: Ref_id_edit,
                      Project_code: this.DataCourse.Project_code,
                      DelvNo: child1.DelvNo,
                      create_by: this.MeData[0].perid,
                    }, headerAxiosPUT)
                  }
                })
              }
              if (root.id == this.logSelection[i]) {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_competency/', {
                  Ref_id: Ref_id_edit,
                  Project_code: this.DataCourse.Project_code,
                  DelvNo: root.DelvNo,
                  create_by: this.MeData[0].perid,
                }, headerAxiosPUT)
              }
            })
          }
          this.logSelection = []
          resolve(true)
        } else {
          resolve(false)
        }
      })
    },
    AddTempCompetency(Ref_id_edit) {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      return new Promise(resolve => {
        if (this.selection.length > 0) {
          for (var i = 0; i <= this.selection.length - 1; i++) {
            this.CompetencyData.map(root => {
              if (root.children.length > 0) {
                root.children.map(child1 => {
                  if (child1.children.length > 0) {
                    child1.children.map(child2 => {
                      if (child2.id == this.selection[i]) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_D_project_competency/', {
                          Ref_id: Ref_id_edit,
                          Project_code: this.DataCourse.Project_code,
                          DelvNo: child2.DelvNo,
                          create_by: this.MeData[0].perid,
                        }, headerAxiosPUT)
                      }
                    })
                  }
                  if (child1.id == this.selection[i]) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_D_project_competency/', {
                      Ref_id: Ref_id_edit,
                      Project_code: this.DataCourse.Project_code,
                      DelvNo: child1.DelvNo,
                      create_by: this.MeData[0].perid,
                    }, headerAxiosPUT)
                  }
                })
              }
              if (root.id == this.selection[i]) {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_D_project_competency/', {
                  Ref_id: Ref_id_edit,
                  Project_code: this.DataCourse.Project_code,
                  DelvNo: root.DelvNo,
                  create_by: this.MeData[0].perid,
                }, headerAxiosPUT)
              }
            })
          }
          this.tempSelection = []
          resolve(true)
        } else {
          resolve(false)
        }
      })
    },
    AddCompetency() {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      return new Promise(resolve => {
        if (this.selection.length > 0) {
          for (var i = 0; i <= this.selection.length - 1; i++) {
            this.CompetencyData.map(root => {
              if (root.children.length > 0) {
                root.children.map(child1 => {
                  if (child1.children.length > 0) {
                    child1.children.map(child2 => {
                      if (child2.id == this.selection[i]) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                          Project_code: this.DataCourse.Project_code,
                          DelvNo: child2.DelvNo,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()'
                        }, headerAxiosPUT)
                      }
                    })
                  }
                  if (child1.id == this.selection[i]) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                      Project_code: this.DataCourse.Project_code,
                      DelvNo: child1.DelvNo,
                      create_by: this.MeData[0].perid,
                      create_time: 'now()'
                    }, headerAxiosPUT)
                  }
                })
              }
              if (root.id == this.selection[i]) {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                  Project_code: this.DataCourse.Project_code,
                  DelvNo: root.DelvNo,
                  create_by: this.MeData[0].perid,
                  create_time: 'now()'
                }, headerAxiosPUT)
              }
            })
          }
          this.selection = []
          resolve(true)
        } else {
          resolve(true)
        }
      })

    },
    CheckPermission() {
      return new Promise(resolve => {
        var CheckPermiss = false
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '10001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '10001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    getDateNow() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      var hour = today.getHours();
      var minute = today.getMinutes();
      var second = today.getSeconds();
      if (hour.toString().length == 1) {
        hour = '0' + hour;
      }
      if (minute.toString().length == 1) {
        minute = '0' + minute;
      }
      if (second.toString().length == 1) {
        second = '0' + second;
      }
      return yyyy + '-' + mm + '-' + dd
    },
    SendReqProjMail(obj) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: obj.perid,
        perid: this.Project.Create_By,
        headerName: 'แจ้งเตือนการพิจารณาข้อมูลเสนอแผนตั้งงบประมาณประจำปี ' + this.Project.Project_name,
        header: this.Project.Project_name,
        body: '<p style="font-size: 25px;color: peru;font-weight: bold">มีการเสนอแผนตั้งงบเข้ามาใหม่ ชื่อแผน: ' + this.Project.Project_name + '</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">ผู้มีอำนาจพิจารณาแผนตั้งงบ</span> โปรดพิจารณาในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    SendMail(obj) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: obj.perid,
        perid: this.Project.Create_By,
        headerName: 'แจ้งเตือนการพิจารณาข้อมูลเสนอแผนตั้งงบประมาณประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')',
        header: this.Project.Project_name,
        body: '<p style="font-size: 25px;color: peru;font-weight: bold">มีการแก้ไขข้อมูลแผนและถูกเสนอแผนตั้งงบเข้ามาใหม่ ชื่อแผน: ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">ผู้มีอำนาจพิจารณาแผนตั้งงบ</span> โปรดพิจารณาในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    SendMailAfterApprove(obj) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: obj.perid,
        perid: this.Project.Create_By,
        headerName: 'แจ้งเตือนการพิจารณาขอแก้ไขข้อมูลเสนอแผนตั้งงบประมาณประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')',
        header: this.Project.Project_name,
        body: '<p style="font-size: 25px;color: peru;font-weight: bold">มีการขอแก้ไขข้อมูลแผน ชื่อแผน: ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">ผู้มีอำนาจพิจารณาแผนตั้งงบ</span> โปรดพิจารณาในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveEditProject/' + this.Project.Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    SendMailCancelPlan(obj) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: obj.perid,
        perid: this.Project.Create_By,
        headerName: 'แจ้งเตือนการการยกเลิกเสนอแผนตั้งงบประมาณประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')',
        header: this.Project.Project_name,
        body: '<p style="font-size: 25px;color: peru;font-weight: bold">มีการยกเลิกแผนเสนอขอตั้งงบประมาณประจำปี ชื่อแผน: ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')</p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    SendMailSucProject(obj) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: obj.perid,
        perid: this.Project.Create_By,
        headerName: 'แจ้งเตือนการเสร็จสิ้นโครงการจากแผนตั้งงบประมาณประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')',
        header: this.Project.Project_name,
        body: '<p style="font-size: 25px;color: peru;font-weight: bold">แผน: ' + this.Project.Project_name + ' (' + this.Project.Project_code + ') ณ ขณะนี้ได้เสร็จสิ้นโครงการแล้ว</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">สามารถตรวจสอบข้อมูลได้</span> ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/BudgetProject/"> พิจารณาเสนอแผนอนุมัติงบประมาณประจำปี </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    ChooseCompetency() {
      this.CompetencyData = JSON.parse(JSON.stringify(this.CompetencyDataDump))
      if (this.Project_category == '1') {
        this.CompetencyData[0].checkCordi = true
        this.CompetencyData[2].checkCordi = true
      } else {
        this.CompetencyData[0].checkCordi = false
        this.CompetencyData[2].checkCordi = true
      }
      if (this.selection.length > 0) {
        for (var i = 0; i <= this.selection.length - 1; i++) {
          this.CompetencyData.map(root => {
            if (root.children.length > 0) {
              root.children.map(child1 => {
                if (child1.children.length > 0) {
                  child1.children.map(child2 => {
                    if (child2.id == this.selection[i]) {
                      if ((this.Project_category == '1' && ((root.DelvGroup == 'A' && root.DelvLevel == '0') || (root.DelvGroup == 'D' && root.DelvLevel == '0'))) || (this.Project_category != '1' && root.DelvGroup == 'D' && root.DelvLevel == '0')) {
                        root.checkCordi = false
                      }
                    }
                  })
                }
                if (child1.id == this.selection[i]) {
                  if ((this.Project_category == '1' && ((root.DelvGroup == 'A' && root.DelvLevel == '0') || (root.DelvGroup == 'D' && root.DelvLevel == '0'))) || (this.Project_category != '1' && root.DelvGroup == 'D' && root.DelvLevel == '0')) {
                    root.checkCordi = false
                  }
                }
              })
            }
            if (root.id == this.selection[i]) {
              if ((this.Project_category == '1' && ((root.DelvGroup == 'A' && root.DelvLevel == '0') || (root.DelvGroup == 'D' && root.DelvLevel == '0'))) || (this.Project_category != '1' && root.DelvGroup == 'D' && root.DelvLevel == '0')) {
                root.checkCordi = false
              } else {
                root.checkCordi = true
              }
            }
          })
        }
      }
      this.getCourseType()
    },
    init() {
      this.initMeData().then(res => {
        if (res) {
          this.CompetencyData = []
          this.itemsSel = []
          this.FiscalYearData = []
          this.Project_plan = []
          this.Project_type = this.TypeProject
          this.FiscalYearMenuData = []
          const today = new Date()
          this.YearSel = (today.getMonth() + 1) >= 10 ? today.getFullYear() + 1 : today.getFullYear()

          if ((new Date().getMonth() + 1) >= 10) {
            for (var i = new Date().getFullYear() - 2; i <= (new Date().getFullYear() + 2); i++) {
              this.FiscalYearData.push({
                year: i,
                yearth: i + 543
              })
            }
          } else {
            for (i = new Date().getFullYear() - 3; i <= (new Date().getFullYear() + 1); i++) {
              this.FiscalYearData.push({
                year: i,
                yearth: i + 543
              })
            }
          }

          for (var j = 2020; j <= (new Date().getFullYear() + 3); j++) {
            this.FiscalYearMenuData.push({
              year: j,
              yearth: j + 543
            })
          }

          this.initCountryData()

          if (this.staffData.length > 0) {
            this.staffData.map(item => {
              item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
            })
          }

          this.selProjFiscalYear()

          // this.initAllPlanProjectDataForApprove().then(res => {
          //   if (res) {
         /*  if (this.projectForApprove.length > 0) {
            if (this.CheckAdmin) {
              this.getPermissionDep({
                perid: this.MeData[0].perid
              }).then(resDep => {
                if (resDep) {
                  this.projectForApprove.map(Project => {
                    // var DepData = this.Permission_Dep.filter(Dep => Project.dep_id == Dep.dep_id)
                    var DepData = this.Permission_Dep.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                    if (DepData.length > 0) {
                      if (Project.IsPlanStatus == '0' || Project.IsPlanStatus == '2' || Project.IsPlanStatus == '4' || Project.IsPlanStatus == '5') {
                        this.Project_plan.push({
                          ...Project,
                          full_Text: 'แผนปี ' + (parseInt(Project.FiscalYear) + 543) + ' => (' + Project.Project_code + ') ' + Project.Project_name

                        })
                      }
                    }
                  })
                  this.dialogLoading = false
                } else {
                  this.dialogLoading = false
                }
              }).catch(res => {
                if (res) {
                  this.dialogLoading = false
                }
              })
            } else if (this.CheckSubAdmin) {
              this.getPermissionDepUserData({
                perid: this.MeData[0].perid
              }).then(resDep => {
                if (resDep) {
                  this.projectForApprove.map(Project => {
                    // var DepData = this.Permission_Dep_User.filter(Dep => Project.dep_id == Dep.dep_id)
                    var DepData = this.Permission_Dep_User.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                    if (DepData.length > 0) {
                      if (Project.IsPlanStatus == '0' || Project.IsPlanStatus == '2' || Project.IsPlanStatus == '4' || Project.IsPlanStatus == '5') {
                        this.Project_plan.push({
                          ...Project,
                          full_Text: ' แผนปี ' + (parseInt(Project.FiscalYear) + 543) + ' => (' + Project.Project_code + ') ' + Project.Project_name
                        })
                      }
                    }
                  })
                  this.dialogLoading = false
                } else {
                  this.dialogLoading = false
                }
              }).catch(res => {
                if (res) {
                  this.dialogLoading = false
                }
              })
            }
          } else {
            this.dialogLoading = false
          } */
          // }
          this.isLoading = false
          // })


          if (this.courseData.length == 0) {
            this.initCourseData()
          }

          if (this.positions.length == 0) {
            this.initPositionsData()
          }


          if (this.provinces_Data.length == 0) {
            this.initProvincesData()
          }

          if (this.projectGroup.length == 0) {
            this.initProjectGroupData()
          }

          this.initCompetencyData().then(res => {
            if (res) {
              this.Competency.map(compe_i => {
                if (compe_i.DelvCover == null || compe_i.DelvCover == '') {
                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                    this.CompetencyData.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes,
                      DelvLevel: '0',
                      checkCordi: (compe_i.DelvGroup == 'A' || compe_i.DelvGroup == 'D') ? true : false,
                      children: []
                    })
                  } else {
                    this.CompetencyData.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                      DelvLevel: '0',
                      checkCordi: (compe_i.DelvGroup == 'A' || compe_i.DelvGroup == 'D') ? true : false,
                      children: []
                    })
                  }
                }
              })
              this.CompetencyData.map((data_i, idx) => {
                if (data_i.children.length == 0) {
                  this.Competency.map(compe_i => {
                    if (data_i.DelvNo == compe_i.DelvCover) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyData[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '1',
                          checkCordi: false,
                          children: []
                        })
                      } else {
                        this.CompetencyData[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '1',
                          checkCordi: false,
                          children: []
                        })
                      }
                    }
                  })
                }
              })
              // lv2
              this.CompetencyData.map(data_i => {
                if (data_i.children.length > 0) {
                  data_i.children.map((child1_i, idx) => {
                    if (child1_i.children.length == 0) {
                      this.Competency.map(compe_i => {
                        if (child1_i.DelvNo == compe_i.DelvCover) {
                          if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                            data_i.children[idx].children.push({
                              ...compe_i,
                              id: compe_i.DelvNo,
                              name: compe_i.DelvDes,
                              DelvLevel: '2',
                              checkCordi: false,
                              children: []
                            })
                          } else {
                            data_i.children[idx].children.push({
                              ...compe_i,
                              id: compe_i.DelvNo,
                              name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                              DelvLevel: '2',
                              checkCordi: false,
                              children: []
                            })
                          }

                        }
                      })
                    }
                  })
                }
              })

              // item to autocomplete
              this.CompetencyData.map(itemRoot => {
                this.itemsSel.push({
                  ...itemRoot
                })
                if (itemRoot.children.length > 0) {
                  itemRoot.children.map(itemChild1 => {
                    this.itemsSel.push({
                      ...itemChild1
                    })
                    if (itemChild1.children.length > 0) {
                      itemChild1.children.map(itemChild2 => {
                        this.itemsSel.push({
                          ...itemChild2
                        })
                      })
                    }
                  })
                }
              })

              this.CompetencyDataDump = JSON.parse(JSON.stringify(this.CompetencyData))
            }
          })
        }
      })
    },
    selProjFiscalYear() {
      this.dialogLoading = true;
      this.Project_plan = []
      this.ProjectPlan = null
      this.initProjAllPlanDataFromFiscalYear({
        FiscalYear: this.YearSel,
        permiss_check: this.MeData[0].perid,
        Project_type: this.TypeProject,
      }).then((res) => {
        if (res) {
          if (this.allPlanProj.length > 0) {
            this.allPlanProj.map(Project => {
              var DepData = this.Permission_Dep.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
              if (DepData.length > 0) {
                if (Project.IsPlanStatus == '0' || Project.IsPlanStatus == '2' || Project.IsPlanStatus == '4' || Project.IsPlanStatus == '5') {
                  this.Project_plan.push({
                    ...Project,
                    full_Text: 'แผนปี ' + (parseInt(Project.FiscalYear) + 543) + ' => (' + Project.Project_code + ') ' + Project.Project_name

                  })
                }
              }
            })
          } else {
            this.$swal({
              title: 'ไม่พบข้อมูลแผนตั้งงบประมาณประจำปี',
              text: 'ไม่พบข้อมูลแผนตั้งงบประมาณประจำปีในปี ' + (this.YearSel + 543) + ' กรุณาเลือกปีอื่น',
              icon: 'warning',
              confirmButtonText: 'ตกลง'
            })
          }
        } else {
          this.$swal({
            title: 'ไม่พบข้อมูลแผนตั้งงบประมาณประจำปี',
            text: 'ไม่พบข้อมูลแผนตั้งงบประมาณประจำปีในปี ' + (this.YearSel + 543) + ' กรุณาเลือกปีอื่น',
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          })
        }
      }).catch((err) => {
        if (err) {
          this.$swal({
            title: 'พบข้อผิดพลาด ในการดึงข้อมูล โปรดลองทำรายการอีกครั้ง', 
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          })
        }
      }).finally(() => {
        this.dialogLoading = false
      })
    },
    remarksProject(item) {
      this.ProjectObj = item
      this.dialogCancelOrCloseProject = true
    },
  },
  mounted() {
    this.initMeData().then(res => {
      if (res) {
        if (this.MeData.length > 0) {
          this.getIgnoreSubMenuPermissData({
            perid: this.MeData[0].perid,
            page_id: '6',
            page_sub_id: '3',
          })
          this.getSubMenuPermissData().then(res => {
            if (res) {
              if (this.SubMenuPermiss.length > 0 && this.SubMenuPermiss.filter(item => item.page_sub_id == '3' && item.PageStatus_page_id == '6' && item.page_status == '1').length > 0 || this.IgnoreSubMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                this.getPermissionData({
                  perid: this.MeData[0].perid
                }).then(resAdmin => {
                  if (resAdmin) {
                    this.PermissionAdmin.map((Per_i, idx) => {
                      if (Per_i.permission_id == '10000') {
                        this.CheckAdmin = true
                        this.init()
                        this.initDateForPlan().then(res => {
                          if (res) {
                            if (this.DateForPlan.filter(item => item.date_start <= this.getDateNow() && item.date_end >= this.getDateNow() && item.year == this.FiscalYear).length > 0) {
                              this.IsPlan = '1'
                              this.IsPlanCordi = false
                            } else {
                              this.IsPlan = '0'
                              this.IsPlanCordi = true
                            }
                          }
                        }).catch(res => {
                          if (res) {
                            this.IsPlan = '0'
                            this.IsPlanCordi = true
                          }
                        })
                      } else {
                        if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                          this.$router.push('/')
                        }
                      }
                    })
                  } else {
                    this.getPermissionUserData({
                      perid: this.MeData[0].perid
                    }).then(resUser => {
                      if (resUser) {
                        this.Permission.map((Per_i, idx) => {
                          if (Per_i.permission_id == '10000') {
                            this.CheckSubAdmin = true
                            this.init()
                            this.initDateForPlan().then(res => {
                              if (res) {
                                if (this.DateForPlan.filter(item => item.date_start <= this.getDateNow() && item.date_end >= this.getDateNow()).length > 0) {
                                  this.IsPlan = '1'
                                  this.IsPlanCordi = false
                                } else {
                                  this.IsPlan = '0'
                                  this.IsPlanCordi = true
                                }
                              }
                            }).catch(res => {
                              if (res) {
                                this.IsPlan = '0'
                                this.IsPlanCordi = true
                              }
                            })
                          } else {
                            if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                              this.$router.push('/')
                            }
                          }
                        })
                      } else {
                        this.CheckSubAdmin = false
                        this.CheckAdmin = false
                        this.$router.push('/')
                      }
                    })
                  }
                })
              } else {
                this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '3' && item.PageStatus_page_id == '6' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '3' && item.PageStatus_page_id == '6')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                this.maintain = true
              }
            }
          }).then(err => {
            if (err) {
              this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '3' && item.PageStatus_page_id == '6' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '3' && item.PageStatus_page_id == '6')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
              this.maintain = true
            }
          })
        } else {
          this.$router.push('/Propose_a_plan')
        }
      }
    })
  }
}
</script>

<style scoped>
@font-face {
  font-family: "THSarabunNew";
  src: url('../../lib/font/THSarabunNew.ttf');
}

@font-face {
  font-family: "THSarabunNew";
  font-weight: bold;
  src: url('../../lib/font/THSarabunNew Bold.ttf');
}

.pdf-content {
  width: 100%;
  background: #fff;
}

strong {
  font-family: "THSarabunNew";
  font-weight: bold;
  color: black;
}

p {
  font-family: "THSarabunNew";
  font-size: 22px;
  color: black;
}

ul {
  font-family: "THSarabunNew";
  font-size: 22px;
  color: black;
}

ol {
  font-family: "THSarabunNew";
  font-size: 22px;
  color: black;
}

i {
  font-family: "THSarabunNew";
  font-size: 22px;
  color: black;
}

s {
  font-family: "THSarabunNew";
  font-size: 22px;
  color: black;
}


@media print {
  .no-print {
    display: none !important;
  }
}

@media screen {
  .no-screen {
    display: none !important;
  }
}

.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.ck-content {
  height: 500px;
}

.ck-editor__editable {
  min-height: 500px;
}

textarea {
  font-family: THSarabunNew;
  font-size: 24px;
}
</style>
